
var SHTHelper = window.SHTHelper || {},
    TRAP_FOCUS_HANDLERS = {};
(SHTHelper.fetchConfigHTTP = {
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
}),
    (SHTHelper.fetchConfigJSON = {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
    }),
    (SHTHelper.isColor = function (t) {
        var e = new Option().style;
        return (e.color = t), e.color == t;
    }),
    (SHTHelper.debounce = function (e, s) {
        let i = null;
        return function (t) {
            clearTimeout(i),
                (i = null),
                (i = setTimeout(function () {
                    e.call(this, t);
                }, s));
        };
    }),
    (SHTHelper.removeTrapFocus = function (t = null) {
        document.removeEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin),
            document.removeEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout),
            document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown),
            t && t.focus();
    }),
    (SHTHelper.trapFocus = function (e, t = e) {
        var s = e.querySelectorAll(
            `a[href]:not([disabled]):not(.disable), [tabindex]:not([tabindex^='-']), summary, button:enabled:not([tabindex^='-']), textarea:not([disabled]), input:not([type=hidden]):enabled, input[type="text"]:not([disabled]), object, iframe, input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [draggable], area`
        );
        let i = s[0],
            r = s[s.length - 1];
        SHTHelper.removeTrapFocus(),
            (TRAP_FOCUS_HANDLERS.focusin = (t) => {
                (t.target !== e && t.target !== r && t.target !== i) ||
                    document.addEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
            }),
            (TRAP_FOCUS_HANDLERS.focusout = function () {
                document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
            }),
            (TRAP_FOCUS_HANDLERS.keydown = function (t) {
                ("Tab" !== t.key && 9 !== t.keyCode) ||
                    (t.shiftKey
                        ? (t.target !== e && t.target !== i) || (r.focus(), t.preventDefault())
                        : t.target === r && (i.focus(), t.preventDefault()));
            }),
            document.addEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout),
            document.addEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin),
            t.focus();
    }),
    (SHTHelper.initTabLogging = function () {
        document.addEventListener("keydown", function (t) {
            "Tab" === t.key &&
                setTimeout(() => {
                    console.log("Tabbed to element:", document.activeElement);
                }, 0);
        });
    }),
    (SHTHelper.isColor = function (t) {
        var e = new Option().style;
        return (e.color = t), e.color == t;
    }),
    (SHTHelper.isHexColor = function (t) {
        return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(t);
    }),
    (SHTHelper.isImage = function (t) {
        return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg|.webp|.heic|.gif|.svg)(\?[^\s[",><]*)?/gi.test(t);
    }),
    (SHTHelper.formatMoney = function (t, e = "") {
        "string" == typeof t && (t = t.replace(".", ""));
        var s = /\{\{\s*(\w+)\s*\}\}/,
            e = e || window.theme_variables.settings.money_format;
        let i = "";
        switch (e.match(s)[1]) {
            case "amount":
                i = SHTHelper.formatWithDelimiters(t, 2);
                break;
            case "amount_no_decimals":
                i = SHTHelper.formatWithDelimiters(t, 0);
                break;
            case "amount_with_space_separator":
                i = SHTHelper.formatWithDelimiters(t, 2, " ", ".");
                break;
            case "amount_with_comma_separator":
                i = SHTHelper.formatWithDelimiters(t, 2, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                i = SHTHelper.formatWithDelimiters(t, 2, "'", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = SHTHelper.formatWithDelimiters(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = SHTHelper.formatWithDelimiters(t, 0, " ");
                break;
            case "amount_no_decimals_with_apostrophe_separator":
                i = SHTHelper.formatWithDelimiters(t, 0, "'");
        }
        return e.indexOf("with_comma_separator"), e.replace(s, i);
    }),
    (SHTHelper.defaultTo = function (t, e) {
        return null == t || t != t ? e : t;
    }),
    (SHTHelper.formatWithDelimiters = function (t, e, s, i) {
        return (
            (e = SHTHelper.defaultTo(e, 2)),
            (s = SHTHelper.defaultTo(s, ",")),
            (i = SHTHelper.defaultTo(i, ".")),
            isNaN(t) || null == t
                ? 0
                : (e = (t = (t / 100).toFixed(e)).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) +
                  (e[1] ? i + e[1] : "")
        );
    }),
    (SHTHelper.preventStickyHeaderReveal = function () {
        var t = SHTHelper.qs("sht-header-sticky");
        t && t.dispatchEvent(new Event("preventStickyHeaderReveal"));
    }),
    (SHTHelper.loadScript = function (t, e, s) {
        var i;
        SHTHelper.qs("#" + t)
            ? s()
            : ((i = document.createElement("script")).setAttribute("src", "" + e),
              i.setAttribute("id", "" + t),
              (i.onload = function () {
                  s();
              }),
              (i.onreadystatechange = function () {
                  ("complete" != this.readyState && "loaded" != this.readyState) || s();
              }),
              (i.onerror = function (t) {
                  console.log("Failed to load script file " + e, t), s();
              }),
              document.body.appendChild(i));
    }),
    (SHTHelper.forceUpdateCartStatus = function (t) {
        let e = [
                {
                    section: "cart-drawer",
                    selector: ".js-cart-drawer-wrapper",
                    space_selector: ".js-cart-drawer-wrapper",
                },
                {
                    section: "header-cart-status",
                    space_selector: ".shopify-section",
                    selector: "#headerCartStatus",
                    cart_notification: !1,
                },
                {
                    section: "main-cart",
                    space_selector: "#mainCartContainer",
                    selector: "#mainCartContainer",
                    cart_notification: !1,
                },
            ],
            r = SHTHelper.qs("sht-cart-noti");
        SHTHelper.qs("sht-header-sticky");
        var s = e.map((t) => t.section).join(",");
        fetch(window.location.pathname + "?sections=" + s)
            .then((t) => t.json())
            .then((i) => {
                e.forEach((t) => {
                    var e = i[t.section],
                        s = SHTHelper.qs(t.selector);
                    e &&
                        s &&
                        ((e = new DOMParser().parseFromString(e, "text/html").querySelector(t.space_selector)) &&
                            (s.innerHTML = e.innerHTML),
                        t.cart_notification) &&
                        r &&
                        r.open();
                });
            })
            .catch((t) => {
                console.log("Cannot force Update Cart Status");
            });
    });
class SHTElementLazyLoad {
    constructor() {
        (this.elements = SHTHelper.qsa(".js-main-body .js-animate")),
            (this.viewportHeight = window.innerHeight),
            this.setupEventListeners();
    }
    setupEventListeners() {
        const e = new IntersectionObserver(
                (t, e) => {
                    t.forEach((t) => {
                        t.isIntersecting && (t.target.classList.add("animated"), e.unobserve(t.target));
                    });
                },
                { rootMargin: "-50px" }
            ),
            s = new IntersectionObserver(
                (t, e) => {
                    t.forEach((t) => {
                        t.isIntersecting && (t.target.classList.add("animated"), e.unobserve(t.target));
                    });
                },
                { threshold: 0.2 }
            );
        this.elements.forEach((t) => {
            (t.offsetHeight > 0.8 * this.viewportHeight ? e : s).observe(t);
        });
    }
}
setTimeout(() => {
    void 0 !== SHTElementLazyLoad && new SHTElementLazyLoad();
}),
    Shopify.designMode &&
        document.addEventListener("shopify:section:load", function (t) {
            void 0 !== SHTElementLazyLoad && new SHTElementLazyLoad();
        });
class SHTCustomComponent extends HTMLElement {
    constructor() {
        super(), (this.$ = this.querySelector.bind(this)), (this.$$ = this.querySelectorAll.bind(this));
    }
}
class SHTAccordion extends SHTCustomComponent {
    constructor() {
        super(),
            (this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {}),
            (this.accordionItems = this.$$(".js-accordion-item")),
            (this.accordionTriggers = this.$$(".js-accordion-trigger")),
            (this.accordionContents = this.$$(".js-accordion-content"));
    }
    connectedCallback() {
        this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.accordionTriggers.forEach((t) => {
            t.addEventListener("click", (t) => {
                t.preventDefault(), this.onTriggerClick(t.currentTarget);
            });
        }),
            this.onResize();
    }
    onResize() {
        (this.resizeObserver = new ResizeObserver((t) => {
            this.accordionItems.forEach((t) => {
                t.querySelector(".js-accordion-trigger").classList.contains("open") &&
                    ((t.querySelector(".js-accordion-content").style.maxHeight =
                        this.calculateMaxHeightContent(t.querySelector(".js-accordion-content")) + "px"),
                    Array.from(t.querySelector(".js-accordion-content").children).forEach((t) => {
                        t.style.transform = "translateY(0)";
                    }));
            });
        })),
            this.resizeObserver.observe(this);
    }
    onTriggerClick(t) {
        var e = "true" === t.getAttribute("aria-expanded");
        !0 === this.properties.multiple && this.toggleAll(), this.toggle(!e, t);
    }
    toggle(t, e) {
        e.setAttribute("aria-expanded", "" + t);
        let s = this.$("#" + e.getAttribute("aria-controls"));
        var i = Array.from(s.children);
        t
            ? (e.classList.add("open"),
              s.classList.add("open"),
              (s.style.maxHeight = this.calculateMaxHeightContent(s) + "px"),
              i.forEach((t) => {
                  t.style.transform = "translateY(0)";
              }))
            : (e.classList.remove("open"),
              s.classList.remove("open"),
              (s.style.maxHeight = "0px"),
              i.forEach((t) => {
                  t.style.transform = `translateY(-${this.calculateMaxHeightContent(s)}px)`;
              }));
    }
    open() {
        this.toggle(!0);
    }
    close() {
        this.toggle(!1);
    }
    toggleAll() {
        this.accordionTriggers.forEach((t) => {
            t.setAttribute("aria-expanded", "false"), t.classList.remove("open");
        }),
            this.accordionContents.forEach((t) => {
                t.classList.remove("open"), (t.style.maxHeight = "0px");
            });
    }
    calculateMaxHeightContent(t) {
        return t.scrollHeight;
    }
}
customElements.define("sht-accordion", SHTAccordion);
class SHTDropdownSelect extends SHTCustomComponent {
    constructor() {
        super(),
            (this.selectElement = this.querySelector("select")),
            (this.selectedItemDiv = document.createElement("div")),
            (this.optionsContainerDiv = document.createElement("div")),
            (this.observer = new MutationObserver(this.handleMutations.bind(this)));
    }
    connectedCallback() {
        this.init(), this.observeSelectElement();
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    init() {
        this.setAttribute("role", "combobox"),
            this.setAttribute("aria-haspopup", "listbox"),
            this.setAttribute("aria-expanded", "false"),
            this.selectedItemDiv.classList.add("select-selected"),
            this.selectedItemDiv.setAttribute("role", "button"),
            this.selectedItemDiv.setAttribute("tabindex", "0"),
            this.selectedItemDiv.setAttribute("aria-label", "Select option"),
            this.optionsContainerDiv.classList.add("select-items", "select-hide"),
            this.optionsContainerDiv.setAttribute("role", "listbox"),
            this.updateSelectedItem(),
            this.populateOptions(),
            this.addEventListeners(),
            this.appendChild(this.selectedItemDiv),
            this.appendChild(this.optionsContainerDiv);
    }
    updateSelectedItem() {
        this.selectedItemDiv.textContent =
            this.selectElement.options[this.selectElement.selectedIndex]?.textContent || "";
    }
    populateOptions() {
        (this.optionsContainerDiv.innerHTML = ""),
            Array.from(this.selectElement.options).forEach((t, e) => {
                var s = document.createElement("div");
                s.classList.add("select-item"),
                    s.setAttribute("role", "option"),
                    s.setAttribute("tabindex", "0"),
                    s.setAttribute("aria-selected", "false"),
                    (s.textContent = t.textContent),
                    (s.dataset.index = e) === this.selectElement.selectedIndex &&
                        s.setAttribute("aria-selected", "true"),
                    s.addEventListener("click", () => {
                        this.handleOptionClick(e);
                    }),
                    this.optionsContainerDiv.appendChild(s);
            });
    }
    addEventListeners() {
        this.selectedItemDiv.addEventListener("click", (t) => {
            t.stopPropagation(), this.toggleDropdown();
        }),
            document.addEventListener("click", () => this.closeAllDropdowns()),
            this.selectedItemDiv.addEventListener("keydown", (t) => {
                ("Enter" !== t.key && " " !== t.key) || (t.preventDefault(), this.toggleDropdown());
            }),
            this.addEventListener("keydown", (t) => {
                var e = this.optionsContainerDiv.querySelectorAll(".select-item"),
                    s = Array.from(e).findIndex((t) => t === document.activeElement);
                switch (t.key) {
                    case "ArrowDown":
                        t.preventDefault(), s < e.length - 1 && e[s + 1].focus();
                        break;
                    case "ArrowUp":
                        t.preventDefault(), 0 < s && e[s - 1].focus();
                        break;
                    case "Enter":
                    case " ":
                        t.preventDefault(),
                            document.activeElement.classList.contains("select-item") &&
                                this.handleOptionClick(parseInt(document.activeElement.dataset.index));
                        break;
                    case "Escape":
                        this.closeAllDropdowns(), this.selectedItemDiv.focus();
                }
            });
    }
    handleOptionClick(t) {
        (this.selectElement.selectedIndex = t),
            this.selectElement.dispatchEvent(new Event("change", { bubbles: !0 })),
            this.updateSelectedItem(),
            this.closeAllDropdowns();
    }
    toggleDropdown() {
        var t = !this.optionsContainerDiv.classList.contains("select-hide");
        this.setAttribute("aria-expanded", (!t).toString()),
            SHTHelper.qsa(".select-items").forEach((t) => {
                this.contains(t) || t.classList.add("select-hide");
            }),
            SHTHelper.qsa(".select-selected").forEach((t) => {
                this.contains(t) || t.classList.remove("select-arrow-active");
            }),
            this.optionsContainerDiv.classList.toggle("select-hide"),
            this.selectedItemDiv.classList.toggle("select-arrow-active");
    }
    closeAllDropdowns() {
        SHTHelper.qsa(".select-items").forEach((t) => t.classList.add("select-hide")),
            SHTHelper.qsa(".select-selected").forEach((t) => t.classList.remove("select-arrow-active"));
    }
    observeSelectElement() {
        this.observer.observe(this.selectElement, { childList: !0, subtree: !1 });
    }
    handleMutations(t) {
        let e = !1;
        t.forEach((t) => {
            "childList" === t.type && (e = !0);
        }),
            e && (this.populateOptions(), this.updateSelectedItem());
    }
}
customElements.define("sht-select", SHTDropdownSelect);
class SHTCarousel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            (this.pagination = this.$(".js-carousel-pagination-dots")),
            (this.pagination_items = this.pagination?.querySelectorAll(".js-carousel-pagination-dot")),
            (this.scrollbarThumb = this.$(".js-scrollbar-thumb")),
            (this.scrollbarTrack = this.$(".js-scrollbar-track")),
            (this.desktopThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbDesk)),
            (this.tabletThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbTablet)),
            (this.mobileThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbMobile)),
            (this.totalItems = parseInt(this.scrollbarTrack?.dataset.thumbTotal));
    }
    connectedCallback() {
        this.init(), this.bindEventHandlers();
    }
    init() {
        ("false" == this.dataset.enable && "false" == this.dataset.enableMobile) ||
            ((this.itemsToShow = Array.from(this.carousels).filter((t) => 0 < t.clientWidth)),
            this.itemsToShow.length < 2
                ? this.togglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel()));
    }
    pauseAllVideo() {
        SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach((t) => {
            t.player?.pauseVideo();
        }),
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                t.playerVimeo?.pause();
            }),
            SHTHelper.qsa(".js-media-item-video").forEach((t) => {
                t.pause();
            });
    }
    updateCarousel() {
        var t = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML = this.currentPage),
            this.currentPage != t &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement?.setAttribute("disabled", "disabled")
                : this.prevBtnElement?.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement?.setAttribute("disabled", "disabled")
                : this.nextBtnElement?.removeAttribute("disabled"),
            1 < this.totalPages && this.togglePagination(!0),
            this.totalPages <= 1 && this.togglePagination(!1),
            this.updatePagination(),
            this.pauseAllVideo(),
            this.updateScrollIndicator();
    }
    updatePagination() {
        var t;
        this.pagination &&
            (t = this.pagination.querySelector(`li[data-dot-index="${this.currentPage}"]`)) &&
            (this.pagination_items.forEach((t) => t.classList.remove("is-active")), t.classList.add("is-active"));
    }
    togglePagination(t) {
        t
            ? this.paginationElement?.classList.remove("d-none-important")
            : this.paginationElement?.classList.add("d-none-important");
    }
    isItemVisible(t, e = 0) {
        if (void 0 === t) return !1;
        var s = this.classList.contains("carousel--special");
        let i, r;
        return (
            (r = s
                ? ((i =
                      this.container.clientWidth +
                      this.container.scrollLeft -
                      e -
                      Math.abs(this.container.offsetLeft) +
                      1),
                  0)
                : ((i = this.container.clientWidth + this.container.scrollLeft - e),
                  parseInt(getComputedStyle(this.container).paddingLeft))),
            Math.floor(t.getBoundingClientRect().width + r + t.offsetLeft) <= Math.round(i) &&
                t.offsetLeft >= this.container.scrollLeft
        );
    }
    onButtonClick(t) {
        t.preventDefault();
        let e = t.currentTarget.dataset.stepMb,
            s = 0;
        window.matchMedia("(min-width: 459px)").matches && (e = t.currentTarget.dataset.step),
            (0 != this.container.scrollLeft && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === t.currentTarget.name
                    ? this.container.scrollLeft - s + e * this.itemOffset
                    : this.container.scrollLeft + s - e * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    updateScrollIndicator() {
        this.scrollbarTrack &&
            ((this.maxScroll = this.container.scrollWidth - this.container.clientWidth),
            (this.scrollPercent = (this.container.scrollLeft / this.maxScroll) * 100),
            (this.thumbPercentDesk = this.calculateThumbPercent(this.desktopThumbItemCount)),
            (this.thumbPercentTablet = this.calculateThumbPercent(this.tabletThumbItemCount)),
            (this.thumbPercentMobile = this.calculateThumbPercent(this.mobileThumbItemCount)),
            this.scrollbarTrack.style.setProperty("--width-thumb-desktop", this.thumbPercentDesk + "%"),
            this.scrollbarTrack.style.setProperty("--width-thumb-tablet", this.thumbPercentTablet + "%"),
            this.scrollbarTrack.style.setProperty("--width-thumb-mobile", this.thumbPercentMobile + "%"));
    }
    calculateThumbPercent(t) {
        return (100 * (t + (this.scrollPercent / 100) * (this.totalItems - t))) / this.totalItems;
    }
    bindEventHandlers() {
        ("false" == this.dataset.enable && "false" == this.dataset.enableMobile) ||
            (new ResizeObserver((t) => this.init()).observe(this.container),
            new IntersectionObserver(
                ((t, e) => {
                    t[0].isIntersecting && (this.init(), e.unobserve(this));
                }).bind(this)
            ).observe(this),
            this.prevBtnElement?.addEventListener("click", (t) => {
                this.updateScrollIndicator(), this.onButtonClick(t);
            }),
            this.nextBtnElement?.addEventListener("click", (t) => {
                this.updateScrollIndicator(), this.onButtonClick(t);
            }),
            this.container.addEventListener("scroll", () => {
                this.updateScrollIndicator(), SHTHelper.debounce(this.updateCarousel(), 100);
            }));
    }
}
customElements.define("sht-carousel", SHTCarousel);
class SHTPopup extends SHTCustomComponent {
    static currentZIndex = 100;
    constructor() {
        super(),
            (this.closeButton = this.$(".js-popup-btn-close")),
            (this.delayTime = parseInt(this.dataset.delayTime || 0)),
            (this.popupId = this.dataset.sectionId),
            (this.overlay = this.$(".js-dialog-overlay")),
            (this.container = this.$(".js-popup-container")),
            (this.enabledOverlay = this.dataset.enabledOverlay),
            (this.isAdminEditor = Shopify?.designMode || !1),
            (this.eleFocusRemove = SHTHelper.qs("a")),
            this.init();
    }
    init() {
        this.checkPopupState(), this.bindEventHandlers(), this.isAdminEditor && this.handlePopupInAdmin();
    }
    getStorageKey() {
        return "SHT_popupDismissedDate_" + this.popupId;
    }
    bindEventHandlers() {
        this.closeButton?.addEventListener("click", this.handleClose.bind(this)),
            this.overlay?.addEventListener("click", this.handleClose.bind(this)),
            this.classList.contains("hidden-xs") || "true" != this.enabledOverlay || this.handleOverlay(),
            this.querySelector("form")?.addEventListener("submit", () => {
                var t;
                this.isAdminEditor ||
                    (0 < this.delayTime
                        ? ((t = new Date()).setHours(0, 0, 0, 0),
                          localStorage.setItem(this.getStorageKey(), t.toString()))
                        : localStorage.setItem(this.getStorageKey(), "permanent"));
            });
    }
    checkPopupState() {
        var t = localStorage.getItem(this.getStorageKey());
        return this.isPopupDismissed(t)
            ? (this.hidePopup(), !0)
            : ("permanent" !== t && localStorage.removeItem(this.getStorageKey()), this.hidePopup(), !1);
    }
    isPopupDismissed(t = localStorage.getItem(this.getStorageKey())) {
        var e;
        return (
            !this.isAdminEditor &&
            ("permanent" === t ||
                (!(!t || !this.delayTime) &&
                    ((e = new Date().toDateString()),
                    (t = new Date(t).toDateString()),
                    Math.floor((new Date(e) - new Date(t)) / 864e5) < this.delayTime)))
        );
    }
    handleOverlay() {
        this.isAdminEditor ||
            ("true" == this.enabledOverlay
                ? document.body.classList.add("o-hidden")
                : document.body.classList.remove("o-hidden"),
            SHTHelper.qsa(".js-sht-popup").forEach((t) => {
                t.classList.contains("hidden-xs") ||
                    "true" != t.dataset.enabledOverlay ||
                    document.body.classList.add("o-hidden");
            }));
    }
    updateZIndex() {
        (SHTPopup.currentZIndex += 2),
            (this.querySelector(".js-popup-container").style.zIndex = SHTPopup.currentZIndex.toString());
    }
    handleClose() {
        var t;
        this.hidePopup(),
            this.isAdminEditor ||
                (0 < this.delayTime
                    ? ((t = new Date()).setHours(0, 0, 0, 0), localStorage.setItem(this.getStorageKey(), t.toString()))
                    : localStorage.setItem(this.getStorageKey(), "permanent"));
    }
    hidePopup() {
        this.offsetHeight,
            this.classList.add("drawer-out"),
            setTimeout(() => {
                this.classList.remove("is-active"),
                    this.classList.replace("drawer-out", "hidden-xs"),
                    document.body.classList.remove("o-hidden"),
                    SHTHelper.qsa(".js-sht-popup").forEach((t) => {
                        t.classList.contains("hidden-xs") ||
                            "true" != t.dataset.enabledOverlay ||
                            document.body.classList.add("o-hidden");
                    });
            }, 300);
    }
    showPopup() {
        setTimeout(() => {
            this.isAdminEditor ||
                (this.handleOverlay(),
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.offsetHeight,
                            this.classList.add("is-active"),
                            this.classList.remove("hidden-xs"),
                            this.updateZIndex();
                    });
                }));
        }, 300);
    }
    handlePopupInAdmin() {
        this.isAdminEditor &&
            (document.addEventListener("shopify:section:select", (t) => {
                if (t.target.id.includes("popup")) {
                    const e = t.target.querySelector(".popup");
                    setTimeout(() => {
                        e.classList.remove("hidden-xs"),
                            e.classList.add("is-active"),
                            "true" == e.dataset.enabledOverlay
                                ? document.body.classList.add("o-hidden")
                                : document.body.classList.remove("o-hidden");
                    }, 300);
                }
            }),
            document.addEventListener("shopify:section:deselect", (t) => {
                t.target.id.includes("popup") && this.hidePopup();
            }));
    }
}
class SHTInteractionPopup extends SHTPopup {
    constructor() {
        super(),
            (this.footer = document.querySelector("footer")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            this.initInteractionHandlers();
    }
    initInteractionHandlers() {
        var t = new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting && !this.isPopupDismissed() && (this.showPopup(), SHTHelper.trapFocus(this));
                });
            },
            { threshold: 0.1 }
        );
        this.footer && t.observe(this.footer),
            this.cartNotification &&
                this.cartNotification.addEventListener("opened", this.handleShowPopupAddToCart.bind(this));
    }
    handleShowPopupAddToCart() {
        this.checkPopupState() || (this.showPopup(), SHTHelper.trapFocus(this));
    }
}
customElements.define("sht-interaction-popup", SHTInteractionPopup);
class SHTTimeDelayPopup extends SHTPopup {
    constructor() {
        super(), (this.delayUntil = parseInt(this.dataset.delayUntil)), this.initDelayUntil();
    }
    initDelayUntil() {
        this.isPopupDismissed() ||
            (0 === this.delayUntil
                ? (this.showPopup(this), SHTHelper.trapFocus(this.$(".js-popup-btn-close")))
                : 0 < this.delayUntil &&
                  setTimeout(() => {
                      this.isPopupDismissed() ||
                          (this.showPopup(this), SHTHelper.trapFocus(this.$(".js-popup-btn-close")));
                  }, 1e3 * this.delayUntil));
    }
}
customElements.define("sht-time-delay-popup", SHTTimeDelayPopup);
class SHTCoreDrawer extends SHTCustomComponent {
    constructor() {
        super(),
            (this.drawerWrapperElement = this.$(".js-drawer-wrapper")),
            (this.drawerOverlayElement = this.$(".js-drawer-overlay")),
            (this.closeBtnElement = this.$$(".js-drawer-btn-close")),
            (this.opener = null),
            (this.bodyElement = document.body),
            (this.isMobileMenuDrawer = this.closest("sht-menu-drwer")),
            this.bindEventHandlers(),
            (this.scrollElement = this.$(".js-scroll-element")),
            (this.containerOverflowElement = this.$(".js-container-overflow"));
    }
    bindEventHandlers() {
        this.drawerOverlayElement.addEventListener("click", this.closeDrawer.bind(this)),
            this.closeBtnElement.forEach((t) => {
                t.addEventListener("click", this.closeDrawer.bind(this)),
                    window.addEventListener("load", () => {
                        this.removeAttribute("hidden");
                    });
            }),
            this.addEventListener("keyup", (t) => {
                var e;
                "ESCAPE" === t.code.toUpperCase() &&
                    ((e = this.checkLevelDrawer("sht-menu-drwer")),
                    !this.isMobileMenuDrawer || (this.isMobileMenuDrawer && e)) &&
                    this.closeDrawer(t);
            }),
            this.drawerAttrObserve();
    }
    checkLevelDrawer(t) {
        let e = !0;
        return (
            this.closest(t)
                .querySelectorAll("details")
                .forEach((t) => {
                    !0 === t.hasAttribute("open") && (e = !1);
                }),
            e
        );
    }
    drawerAttrObserve() {
        new MutationObserver((t) => {
            t.forEach(async (t) => {
                "open" == t.attributeName &&
                    (this.hasAttribute("open")
                        ? (this.opener?.removeAttribute("disabled"),
                          this.opener?.setAttribute("aria-expanded", "true"),
                          this.setAttribute("aria-hidden", "false"),
                          this.dispatchEvent(new Event("opening")),
                          this.classList.add("active"),
                          this.offsetHeight,
                          this.classList.remove("hidden-xs"),
                          await this.animationsComplete(),
                          this.bodyElement.classList.add("o-hidden"),
                          this.dispatchEvent(new Event("opened")),
                          SHTHelper.trapFocus(this))
                        : (SHTHelper.removeTrapFocus(this.opener),
                          this.setAttribute("aria-hidden", "true"),
                          this.opener?.setAttribute("aria-expanded", "false"),
                          this.opener?.removeAttribute("disabled"),
                          this.dispatchEvent(new Event("closing")),
                          this.offsetHeight,
                          this.classList.add("drawer-out"),
                          setTimeout(() => {
                              this.classList.remove("active", "drawer-out"),
                                  this.classList.add("hidden-xs"),
                                  this.dispatchEvent(new Event("closed")),
                                  this.bodyElement.classList.remove("o-hidden");
                          }, 300)));
            });
        }).observe(this, { attributes: !0 });
    }
    async animationsComplete() {
        var t = this.getAnimations();
        await Promise.all(t.map((t) => t.finished));
    }
    handleInitOverflow() {
        this.scrollElement &&
            this.scrollElement.scrollHeight <= this.scrollElement.clientHeight &&
            this.containerOverflowElement?.classList.remove("gradient-overlay");
    }
    openDrawer(t) {
        SHTHelper.preventStickyHeaderReveal(),
            this.handleInitOverflow(),
            (this.opener = t),
            this.removeAttribute("hidden"),
            this.toggleAttribute("open", !0);
    }
    closeDrawer(t) {
        t.preventDefault(),
            t.stopPropagation(),
            this.toggleAttribute("open", !1),
            this.classList.remove("is-open"),
            this.querySelector(".js-drawer-message")?.setActiveMessage(!1);
    }
}
class SHTDrawer extends SHTCoreDrawer {}
customElements.define("sht-drwr", SHTDrawer);
class SHTDrawerTrigger extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.triggerBtnElement = this.$(".js-drawer-trigger")),
            (this.drawerElement = SHTHelper.qs("sht-drwr#" + this.dataset.drawerId)),
            this.triggerBtnElement &&
                this.drawerElement &&
                ((this.headingElement = this.$(".js-drawer-trigger-heading")),
                (this.mediaElement = this.$(".js-drawer-trigger-media")),
                (this.contentElements = this.$$(".js-drawer-trigger-content")),
                this.handleBindEvents());
    }
    bindDataToDrawer() {
        let e = "";
        var t;
        this.headingElement &&
            (this.drawerElement.querySelector(".js-drawer-heading").innerHTML = this.headingElement.innerHTML),
            this.mediaElement &&
                ((t = this.mediaElement.firstElementChild.cloneNode(!0)),
                "auto" == this.dataset.ratio && t.querySelector("sht-image-atf").classList.add("drawer-media"),
                (this.drawerElement.querySelector(".js-drawer-media").innerHTML = t.innerHTML)),
            this.contentElements.forEach((t) => {
                e += t.innerHTML;
            }),
            (this.drawerElement.querySelector(".js-drawer-content").innerHTML = e);
    }
    handleBindEvents() {
        this.triggerBtnElement.addEventListener("click", (t) => {
            setTimeout(() => {
                this.bindDataToDrawer(), this.drawerElement.openDrawer(t.target);
            }, 100);
        });
    }
    connectedCallback() {
        Shopify.designMode
            ? setTimeout(() => {
                  this.init();
              }, 1e3)
            : this.init();
    }
}
customElements.define("sht-drwr-trg", SHTDrawerTrigger);
class SHTMegaMenuDrawer extends SHTCoreDrawer {
    constructor() {
        super(),
            (this.details = this.closest("details")),
            (this.header = SHTHelper.qs("sht-header")),
            (this.menuType = this.header.dataset.menuDropdownOpenType),
            (this.menuWrapper = this.closest(".js-mega-menu-wrapper")),
            (this.detailsLevel2 = this.querySelectorAll(".menu__item-lv2.js-menu-drawer-link")),
            (this.level3BackBtn = this.querySelectorAll(".js-menu-header-back-btn")),
            (this.megaMenuWrapper = this.closest(".js-mega-menu-wrapper")),
            (this.megaMenuType = this.megaMenuWrapper.dataset.megaMenuType);
    }
    connectedCallback() {
        this.init();
    }
    init() {
        "hover" === this.menuType &&
            this.details.addEventListener("mouseover", (t) => {
                "drawer" !== this.megaMenuType &&
                    requestAnimationFrame(() => {
                        this.openDrawer(t.target);
                    });
            }),
            this.details.addEventListener("click", (t) => {
                requestAnimationFrame(() => {
                    this.openDrawer(t.target);
                });
            }),
            this.detailsLevel2.forEach((t) => {
                t.addEventListener("click", () => {
                    this.handleMenuDrawer(!0);
                });
            }),
            this.level3BackBtn.forEach((t) => {
                t.addEventListener("click", (t) => {
                    this.handleMenuDrawer(!1);
                });
            }),
            this.drawerOverlayElement.addEventListener("click", this.handleCloseDrawer.bind(this)),
            this.closeBtnElement.forEach((t) => {
                t.addEventListener("click", this.handleCloseDrawer.bind(this));
            }),
            this.addEventListener("keyup", (t) => {
                var e;
                "ESCAPE" === t.code.toUpperCase() &&
                    ((e = this.checkLevelDrawer("sht-mega-menu-drawer")), !this.isMobileMenuDrawer) &&
                    e &&
                    this.handleCloseDrawer(t);
            });
    }
    handleMenuDrawer(e) {
        (this.level1BackBtn = this.closest("details").querySelectorAll('.js-menu-header-back-btn[data-level="1"]')),
            (this.menuLevel2Item = this.querySelectorAll(".js-menu-drawer-link.menu__item-lv2")),
            this.level1BackBtn.forEach((t) => {
                t.toggleAttribute("hidden", e);
            }),
            this.menuLevel2Item.forEach((t) => {
                t.toggleAttribute("hidden", e);
            });
    }
    handleCloseDrawer(t) {
        t.preventDefault(),
            t.stopPropagation(),
            this.closest("sht-menu-header") &&
                this.closest("sht-menu-header")
                    .querySelectorAll("details")
                    .forEach((t) => {
                        setTimeout(() => {
                            t.toggleAttribute("open", !1), t.classList.remove("is-open");
                        }, 500);
                    });
    }
}
customElements.define("sht-mega-menu-drawer", SHTMegaMenuDrawer);
class SHTDialogCore extends SHTCustomComponent {
    constructor() {
        super(),
            (this.dialog = this.$(".dialog")),
            (this.dialogOverlayElement = this.$(".js-dialog-overlay")),
            (this.closeBtn = this.$$(".js-dialog-close-btn")),
            (this.body = this.$(".js-dialog-body")),
            (this.container = this.$(".js-dialog-container")),
            (this.closeModalOnOverlayClick = this.dataset.closeModalOnOverlay || "true"),
            (this.scrollElement = this.$(".js-scroll-element")),
            (this.opener = null),
            (this.bodyElement = document.body),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.dialogOverlayElement?.addEventListener("click", () => {
            this.closeModal();
        }),
            this.closeBtn.forEach((t) => {
                t.addEventListener("click", (t) => {
                    this.closeModal();
                });
            }),
            this.addEventListener("click", (t) => {
                t.target.nodeName === this.tagName && "true" === this.closeModalOnOverlayClick && this.closeModal();
            }),
            this.scrollElement &&
                this.scrollElement.addEventListener("scroll", () => {
                    this.scrollElement.scrollHeight - Math.floor(this.scrollElement.scrollTop) - 2 <
                    this.scrollElement.clientHeight
                        ? this.classList.remove("gradient-overlay")
                        : this.classList.add("gradient-overlay");
                }),
            this.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.closeModal()),
            this.dialogAttrObserve();
    }
    dialogAttrObserve() {
        new MutationObserver((t, e) => {
            t.forEach(async (t) => {
                "hidden" == t.attributeName &&
                    (!this.hasAttribute("hidden")
                        ? (this.dispatchEvent(
                              new CustomEvent("opening", { detail: { opener: this.opener, dialog: this } })
                          ),
                          await this.animationsComplete(),
                          this.dispatchEvent(
                              new CustomEvent("opened", { detail: { opener: this.opener, dialog: this } })
                          ),
                          SHTHelper.trapFocus(this),
                          this.bodyElement.classList.add("o-hidden"))
                        : (SHTHelper.removeTrapFocus(this.opener),
                          this.dispatchEvent(
                              new CustomEvent("closing", { detail: { opener: this.opener, dialog: this } })
                          ),
                          await this.animationsComplete(),
                          this.dispatchEvent(
                              new CustomEvent("closed", { detail: { opener: this.opener, dialog: this } })
                          ),
                          this.bodyElement.classList.remove("o-hidden")));
            });
        }).observe(this, { attributes: !0 });
    }
    animationsComplete() {
        return Promise.allSettled(this.dialog.getAnimations({ subtree: !0 }).map((t) => t.finished));
    }
    processBodyContent() {
        var t;
        (this.template = this.$("template")),
            this.template && ((t = this.template.content), this.body.appendChild(t), this.handleInitOverflow());
    }
    handleInitOverflow() {
        this.scrollElement &&
            this.scrollElement.scrollHeight <= this.scrollElement.clientHeight &&
            this.classList.remove("gradient-overlay");
    }
    showModal(t, e = !1) {
        SHTHelper.preventStickyHeaderReveal(),
            e && this.processBodyContent(),
            (this.opener = t),
            this.toggleAttribute("hidden", !1),
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.classList.add("is-active"), this.offsetHeight, this.classList.remove("hidden-xs");
                });
            });
    }
    closeModal() {
        this.setAttribute("hidden", !0),
            this.offsetHeight,
            this.classList.add("drawer-out"),
            setTimeout(() => {
                this.classList.remove("is-active"), this.classList.replace("drawer-out", "hidden-xs");
            }, 300);
    }
}
class SHTColorSwatch extends SHTCustomComponent {
    constructor() {
        super(),
            (this.json = null),
            (this.jsonDataElement = SHTHelper.qs('#colorSwatchData[type="application/json"]') || null),
            (this.variantSwatchItems = this.$$(".js-variant-swatch-item") || []),
            this.jsonDataElement && 0 != this.variantSwatchItems.length && this.bindEventHandlers();
    }
    onObserverHandler() {
        new IntersectionObserver((t, e) => {
            t.forEach((t) => {
                t.isIntersecting && (this.init(), e.unobserve(this));
            });
        }).observe(this);
    }
    init() {
        (this.json = JSON.parse(this.jsonDataElement.textContent)), this.processJsonData();
        for (let t = 0, e = this.variantSwatchItems.length; t < e; t++) {
            let i = this.variantSwatchItems[t];
            var s,
                a,
                n,
                o,
                l = this.json["" + i.dataset.optionValue];
            let r = "";
            "variant_image" !== i.dataset.swatchSource &&
                ((s = i.dataset.optionValue),
                (a = i.dataset.swatchOptionValue),
                (n = (t, e = "", s = "") => {
                    (r = t),
                        (i.style.backgroundColor = e),
                        (i.style.backgroundImage = s ? `url("${s}")` : ""),
                        (i.style.backgroundSize = s ? "cover" : ""),
                        (i.style.backgroundRepeat = s ? "no-repeat" : "");
                }),
                void 0 !== l
                    ? ((o = SHTHelper.isHexColor(l)), SHTHelper.isImage(l) ? n("image", "", l) : o && n("color", l))
                    : SHTHelper.isColor(s) && n("color", s),
                a && ((o = SHTHelper.isHexColor(a)), SHTHelper.isImage(a) ? n("image", "", a) : o && n("color", a)),
                i.style.backgroundImage || i.style.backgroundColor) &&
                (r && i.classList.add("clr-swh__type--" + r),
                i.classList.add("clr-swh__has-value"),
                i.querySelector(".js-variant-option-label")?.classList.add("hide-value"));
        }
    }
    processJsonData() {
        this.json &&
            (this.json = Object.assign.apply(
                {},
                this.json.color_swatch_name.map((t, e) => ({ [t]: this.json.color_swatch_value[e] }))
            ));
    }
    bindEventHandlers() {
        this.onObserverHandler();
    }
}
class SHTVariantSwatch extends SHTColorSwatch {
    bindEventHandlers() {
        this.onObserverHandler(),
            this.variantSwatchItems.forEach((t) => {
                t.addEventListener("click", (t) => {
                    this.changeVariantImage(t.currentTarget);
                });
            });
    }
    changeVariantImage(t) {
        var e = SHTHelper.qs("#" + t.dataset.productImageId),
            s = SHTHelper.qsa("." + t.dataset.productLinkClass),
            i = t.querySelector("template"),
            r = t.closest(".mini-card")?.querySelector("sht-image-atf img");
        if (e && i) {
            this.setButtonVisibility(!1);
            const a = i.content.firstElementChild.cloneNode(!0);
            this.updateImage(e, a),
                r && this.updateImage(r, a),
                s &&
                    s.forEach((t) => {
                        t.href = a.getAttribute("data_url");
                    }),
                t.setAttribute("aria-current", "true"),
                t.classList.add("btn-active"),
                t.focus();
        }
    }
    updateImage(t, e) {
        (t.src = e.src), (t.srcset = e.srcset || e.src);
    }
    setButtonVisibility(e) {
        this.variantSwatchItems &&
            this.variantSwatchItems.forEach((t) => {
                e
                    ? (t.setAttribute("aria-current", "true"), t.classList.add("btn-active"))
                    : (t.removeAttribute("aria-current"), t.classList.remove("btn-active"));
            });
    }
}
customElements.define("sht-variant-swtch", SHTVariantSwatch);
class SHTProductCardVariantButton extends SHTVariantSwatch {}
customElements.define("sht-product-card-variant-button", SHTProductCardVariantButton);
class SHTCollectionCompare extends SHTCustomComponent {
    constructor() {
        super(), (this.observer = null);
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.productsArray = this.getArrayFromLocalStorage() || []),
            (this.stickyCompareBtn = SHTHelper.qs(".js-sticky-compare-btn")),
            (this.stickyCompareBtnsWrapper = SHTHelper.qs(".js-collections-compare-btn")),
            (this.btnCompares = this.$$(".js-btn-add-to-compare")),
            (this.productCounter = SHTHelper.qsa(".js-sticky-compare-counter")),
            (this.clearAllBtn = this.$(".js-btn-clear-all")),
            (this.dialogCompare = this.$(".js-dialog-compare")),
            (this.body = this.$(".js-product-compare")),
            (this.btnShowProducts = this.$(".js-btn-compare")),
            (this.comparisonDrawer = SHTHelper.qs(".js-comparison-drawer")),
            (this.closeBtnCompare = SHTHelper.qs(".js-dialog-close-btn-compare")),
            this.updateStatesProduct(this.productsArray),
            this.handleEvents(),
            this.checkProductFromLocalStorage(),
            this.processData();
    }
    handleEvents() {
        this.stickyCompareBtn?.addEventListener("click", () => {
            this.stickyCompareBtnsWrapper.classList.add("hidden-xs"), this.showModalCompare();
        }),
            this.btnCompares.forEach((s) => {
                s.addEventListener(
                    "click",
                    this.throttle(async () => {
                        this.stickyCompareBtnsWrapper.classList.remove("hidden-xs"),
                            (this.productsArray = this.getArrayFromLocalStorage() || []);
                        var t = s.getAttribute("data-product-id"),
                            e = s.getAttribute("data-product-url");
                        this.processDataProductDrawer(),
                            s.classList.contains("active")
                                ? (this.removeProductWhenAddCompare(t),
                                  s.classList.remove("active"),
                                  this.processData())
                                : this.productsArray.length < 3
                                  ? (this.addProductToArray(t, e),
                                    s.classList.add("active"),
                                    await this.processDataProductDrawer(),
                                    await this.processData())
                                  : 3 <= this.productsArray.length &&
                                    alert("You can only add a maximum of 3 products to compare."),
                            this.updateStickyCompare(this.productsArray.length);
                    }, 500)
                );
            }),
            this.clearAllBtn?.addEventListener("click", () => {
                this.clearAllProducts(),
                    this.updateStickyCompare(0),
                    localStorage.removeItem("sht-compare-product"),
                    (this.body.innerHTML = ""),
                    this.closeModalCompare(),
                    setTimeout(() => {
                        this.stickyCompareBtnsWrapper.classList.remove("hidden-xs");
                    }, 600);
            }),
            this.comparisonDrawer?.addEventListener("click", (t) => {
                t.target === t.currentTarget &&
                    (this.comparisonDrawer.offsetHeight,
                    this.comparisonDrawer.classList.add("drawer-out"),
                    setTimeout(() => {
                        this.comparisonDrawer.classList.remove("is-active"),
                            this.comparisonDrawer.classList.replace("drawer-out", "hidden-xs"),
                            document.body.classList.remove("o-hidden");
                    }, 300));
            }),
            this.closeBtnCompare?.addEventListener("click", () => {
                this.stickyCompareBtnsWrapper.classList.remove("hidden-xs"), this.closeModalCompare();
            });
    }
    showComparisonDrawer(e) {
        var t = SHTHelper.qsa(".js-comp-drawer-btn");
        let s = SHTHelper.qs(".js-comparison-drawer");
        t.forEach((t) => {
            t.addEventListener("click", () => {
                s.classList.remove("is-active"),
                    s.offsetHeight,
                    s.classList.add("drawer-out"),
                    setTimeout(() => {
                        s.classList.replace("drawer-out", "hidden-xs"), document.body.classList.remove("o-hidden");
                    }, 300),
                    SHTHelper.removeTrapFocus(e);
            });
        }),
            s
                ? (s.classList.add("is-active"),
                  document.body.classList.add("o-hidden"),
                  s.offsetHeight,
                  s.classList.remove("hidden-xs"),
                  SHTHelper.trapFocus(s))
                : "undefined" != typeof Shopify &&
                  Shopify.designMode &&
                  window.alert(
                      "Product comparison is disabled because the 'Compare Drawer' is hidden. To enable this feature, unhide the 'Compare Drawer.'"
                  );
    }
    processDataProductDrawer() {
        var t = this.getArrayFromLocalStorage();
        t &&
            ((this.productElement = null),
            (this.mainProductCompare = this.$(".js-main-product-compare")),
            (t = t.map((t) => t.url + "?view=show-products-compare")),
            Promise.all(t.map((t) => this.fetchProductCompareHTML(t)))
                .then((t) => {
                    (this.mainProductCompare.innerHTML = ""),
                        t.forEach((t, e) => {
                            var s = document.createElement("div"),
                                t = ((s.innerHTML = t), s.firstElementChild);
                            this.mainProductCompare.appendChild(t);
                        }),
                        this.executeScriptElements(this.mainProductCompare),
                        window.SHTProductMediaItemModel && window.SHTProductMediaItemModel.loadShopifyXR();
                })
                .catch((t) => {
                    console.error("Lỗi promise:", t);
                })
                .finally(() => {}));
    }
    fetchProductCompareHTML(t) {
        return fetch(t)
            .then((t) => t.text())
            .then((t) => {
                t = new DOMParser().parseFromString(t, "text/html").querySelector(".section-view-product-compare");
                return window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), t.innerHTML;
            });
    }
    switchDataProduct() {
        return new Promise((d) => {
            var t = SHTHelper.qs(".js-main-product-compare");
            let h = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-vendor"),
                c = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-des"),
                u = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-type"),
                m = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-tags"),
                p = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-price"),
                g = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-variants"),
                v = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-media"),
                b = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-title"),
                y = SHTHelper.qs(".js-comparison-drawer .js-comp-drawer-rating");
            if (
                (h && (h.innerHTML = ""),
                c && (c.innerHTML = ""),
                u && (u.innerHTML = ""),
                m && (m.innerHTML = ""),
                p && (p.innerHTML = ""),
                g && (g.innerHTML = ""),
                b && (b.innerHTML = ""),
                v && (v.innerHTML = ""),
                y && (y.innerHTML = ""),
                t)
            ) {
                const S = new MutationObserver(() => {
                    let t = SHTHelper.qsa(".js-prd-cp-vendor"),
                        e = SHTHelper.qsa(".js-prd-cp-des"),
                        s = SHTHelper.qsa(".js-prd-cp-type"),
                        i = SHTHelper.qsa(".js-prd-cp-tags"),
                        r = SHTHelper.qsa(".js-prd-cp-price"),
                        a = SHTHelper.qsa(".js-prd-cp-variants"),
                        n = SHTHelper.qsa(".js-prd-cp-media"),
                        o = SHTHelper.qsa(".js-prd-cp-title"),
                        l = SHTHelper.qsa(".js-prd-cp-rating");
                    h && this.applyStylesAndAppend(t, h),
                        c && this.applyStylesAndAppend(e, c),
                        u && this.applyStylesAndAppend(s, u),
                        m && this.applyStylesAndAppend(i, m),
                        p && this.applyStylesAndAppend(r, p),
                        g && this.applyStylesAndAppend(a, g),
                        b && this.applyStylesAndAppend(o, b),
                        y && this.applyStylesAndAppend(l, y),
                        v &&
                            n.forEach((t) => {
                                var t = t.cloneNode(!0),
                                    e = document.createElement("button");
                                e.classList.add(
                                    "btn",
                                    "btn-icon-m",
                                    "js-remove-product-drawer-button",
                                    "btn-secondary",
                                    "btn-remove-product"
                                ),
                                    (e.innerHTML = `
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.22797 6.22702C6.52086 5.93413 6.99574 5.93413 7.28863 6.22703L12.0009 10.9393L16.7132 6.22703C17.0061 5.93413 17.481 5.93413 17.7739 6.22702C18.0668 6.51991 18.0668 6.99479 17.7739 7.28768L13.0616 12L17.7739 16.7123C18.0668 17.0052 18.0668 17.48 17.7739 17.7729C17.481 18.0658 17.0061 18.0658 16.7132 17.7729L12.0009 13.0607L7.28863 17.7729C6.99574 18.0658 6.52086 18.0658 6.22797 17.7729C5.93508 17.48 5.93508 17.0052 6.22797 16.7123L10.9403 12L6.22797 7.28768C5.93508 6.99479 5.93508 6.51992 6.22797 6.22702Z" fill="currentColor"/>
                  </svg>`),
                                    t.appendChild(e),
                                    v.appendChild(t),
                                    e.addEventListener("click", (t) => {
                                        (t = t.target.closest("[data-product-id]").getAttribute("data-product-id")),
                                            SHTHelper.qsa(`div.prd-cp-item[data-product-id="${t}"]`).forEach((t) =>
                                                t.remove()
                                            ),
                                            this.removeProductIndrawer(t),
                                            this.updateLayoutDrawer(),
                                            (t = this.getArrayFromLocalStorage());
                                        1 == t.length &&
                                            (SHTHelper.qs(".js-comparison-drawer").classList.remove("is-active"),
                                            document.body.classList.remove("o-hidden"));
                                    });
                            }),
                        S.disconnect(),
                        d();
                });
                (t.innerHTML = ""), S.observe(t, { childList: !0, subtree: !0 });
            }
            this.updateLayoutDrawer();
        });
    }
    updateLayoutDrawer() {
        var t = this.getArrayFromLocalStorage(),
            e = SHTHelper.qs(".js-comp-drawer-body");
        2 == t.length ? e?.style.setProperty("--block-size", 6) : e?.style.setProperty("--block-size", 4);
    }
    removeProductIndrawer(e) {
        var t,
            s = this.getArrayFromLocalStorage();
        s &&
            (this.removeStateProduct(e),
            -1 !== (t = s.findIndex((t) => t.id === e)) && s.splice(t, 1),
            this.updateLocalStorage(s),
            this.updateStickyCompare(s.length)),
            this.processDataProductDrawer(),
            0 == s.length && this.closeModalCompare();
    }
    applyStylesAndAppend(t, e) {
        t.forEach((t) => {
            e.innerHTML += t.outerHTML;
        });
    }
    checkProductFromLocalStorage() {
        this.productsArray = this.getArrayFromLocalStorage() || [];
    }
    removeProductWhenAddCompare(e, t) {
        var s = [...this.body.children].find((t) => t.dataset.product === e);
        s &&
            (s.remove(),
            this.removeStateProduct(t),
            this.removeProductFromArray(e),
            this.updateLocalStorage(this.productsArray),
            this.updateStickyCompare(this.productsArray.length),
            0 === this.productsArray.length) &&
            this.closeModalCompare();
    }
    showModalCompare() {
        this.dialogCompare.classList.contains("is-active") ||
            (this.dialogCompare.classList.add("is-active"),
            this.dialogCompare.classList.remove("hidden-xs"),
            this.dialogCompare.removeAttribute("hidden"),
            this.processData());
    }
    fetchProductHTML(t) {
        return fetch(t)
            .then((t) => t.text())
            .then((t) => {
                t = new DOMParser().parseFromString(t, "text/html").querySelector(".section-product-compare");
                return window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), t.innerHTML;
            });
    }
    processData() {
        var t = this.getArrayFromLocalStorage();
        if (!t) return Promise.resolve();
        const n = new Set(Array.from(this.body.children).map((t) => t.dataset.product));
        t = t.map((t) => t.url + "?view=product-compare");
        return Promise.all(
            t.map((e) =>
                this.fetchProductHTML(e).catch((t) => (console.error(`Failed to fetch product from ${e}:`, t), null))
            )
        )
            .then((t) => {
                t.forEach((t, e) => {
                    if (t) {
                        var s = document.createElement("div");
                        s.innerHTML = t;
                        const i = s.firstElementChild,
                            r = i.dataset.product,
                            a = document.createElement("button");
                        a.classList.add("btn", "btn-icon-m", "js-remove-product-button", "bg-transparent"),
                            (a.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.22797 6.22702C6.52086 5.93413 6.99574 5.93413 7.28863 6.22703L12.0009 10.9393L16.7132 6.22703C17.0061 5.93413 17.481 5.93413 17.7739 6.22702C18.0668 6.51991 18.0668 6.99479 17.7739 7.28768L13.0616 12L17.7739 16.7123C18.0668 17.0052 18.0668 17.48 17.7739 17.7729C17.481 18.0658 17.0061 18.0658 16.7132 17.7729L12.0009 13.0607L7.28863 17.7729C6.99574 18.0658 6.52086 18.0658 6.22797 17.7729C5.93508 17.48 5.93508 17.0052 6.22797 16.7123L10.9403 12L6.22797 7.28768C5.93508 6.99479 5.93508 6.51992 6.22797 6.22702Z" fill="currentColor"/>
        </svg>`),
                            i.appendChild(a),
                            a.addEventListener("click", () => {
                                this.removeProduct(i, a, e);
                            }),
                            n.has(r) ||
                                ((t = Array.from(this.body.children).find((t) => t.dataset.product === r))
                                    ? this.body.replaceChild(i, t)
                                    : this.body.appendChild(i),
                                n.add(r));
                    }
                }),
                    this.executeScriptElements(this.body),
                    window.SHTProductMediaItemModel && window.SHTProductMediaItemModel.loadShopifyXR();
            })
            .catch((t) => {
                console.error("One of the promises failed:", t);
            });
    }
    removeProduct(t, e, s) {
        const i = e.parentNode.dataset.product;
        t.remove();
        e = this.getArrayFromLocalStorage();
        e &&
            (this.removeStateProduct(i),
            -1 !== (t = e.findIndex((t) => t.id === i)) && e.splice(t, 1),
            this.updateLocalStorage(e),
            this.updateStickyCompare(e.length)),
            this.processDataProductDrawer(),
            0 == e.length && this.closeModalCompare();
    }
    addProductToArray(t, e) {
        e = { id: t, url: e };
        this.checkProductValid(t, this.productsArray) ||
            (this.productsArray.push(e), this.updateLocalStorage(this.productsArray));
    }
    removeProductFromArray(e) {
        (this.productsArray = this.productsArray.filter((t) => t.id !== e)),
            this.updateLocalStorage(this.productsArray);
    }
    closeModalCompare() {
        this.dialogCompare.classList.contains("is-active") &&
            (this.dialogCompare.offsetHeight,
            this.dialogCompare.classList.add("drawer-out"),
            setTimeout(() => {
                this.dialogCompare.classList.remove("is-active"),
                    this.dialogCompare.classList.replace("drawer-out", "hidden-xs"),
                    this.dialogCompare.setAttribute("hidden", !0);
            }, 300));
    }
    executeScriptElements(t) {
        t = t.querySelectorAll("script");
        Array.from(t).forEach((t) => {
            const e = document.createElement("script");
            Array.from(t.attributes).forEach((t) => {
                e.setAttribute(t.name, t.value);
            }),
                e.appendChild(document.createTextNode(t.innerHTML)),
                t.parentNode.replaceChild(e, t);
        });
    }
    checkProductValid(e, t) {
        return t.some((t) => t.id === e);
    }
    updateLocalStorage(t) {
        localStorage.setItem("sht-compare-product", JSON.stringify(t));
    }
    getArrayFromLocalStorage() {
        var t = localStorage.getItem("sht-compare-product");
        return JSON.parse(t);
    }
    updateStickyCompare(e) {
        1 <= e
            ? (this.stickyCompareBtn?.classList.remove("d-none-important", "hide-btn-compare"),
              this.stickyCompareBtnsWrapper?.classList.remove("d-none-md"))
            : (this.stickyCompareBtn?.classList.add("d-none-important", "hide-btn-compare"),
              this.stickyCompareBtnsWrapper?.classList.add("d-none-md")),
            1 == e
                ? this.btnShowProducts?.setAttribute("disabled", "disabled")
                : this.btnShowProducts?.removeAttribute("disabled"),
            this.productCounter.forEach((t) => {
                t.innerText = e;
            });
    }
    updateStatesProduct(t) {
        var e;
        t &&
            ((e = t.length),
            t.forEach((t) => {
                this.$$(`.js-btn-add-to-compare[data-product-id="${t.id}"]`).forEach((t) => {
                    t.classList.add("active");
                });
            }),
            this.updateStickyCompare(e));
    }
    clearAllProducts() {
        this.$$(".js-btn-add-to-compare").forEach((t) => {
            t.classList.remove("active");
        });
    }
    removeStateProduct(t) {
        this.$$(`.js-btn-add-to-compare[data-product-id="${t}"]`).forEach((t) => {
            t.classList.remove("active");
        });
    }
    throttle(s, i) {
        let r, a;
        return function (...t) {
            const e = this;
            a
                ? (clearTimeout(r),
                  (r = setTimeout(
                      function () {
                          Date.now() - a >= i && (s.apply(e, t), (a = Date.now()));
                      },
                      i - (Date.now() - a)
                  )))
                : (s.apply(e, t), (a = Date.now()));
        };
    }
}
customElements.define("sht-collections-compare", SHTCollectionCompare);
class SHTHandleViewCompare extends HTMLElement {
    constructor() {
        super(), (this.observer = null);
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.btnShowProducts = SHTHelper.qs(".js-btn-compare")),
            (this.newDom = SHTHelper.qs("sht-collections-compare")),
            (this.readMore = SHTHelper.qs("sht-read-more")),
            this.btnShowProducts
                ? this.btnShowProducts.addEventListener("click", async () => {
                      await this.newDom.processDataProductDrawer(),
                          await this.newDom.switchDataProduct(),
                          setTimeout(() => {
                              this.newDom.showComparisonDrawer(this.btnShowProducts), this.readMore?.init();
                          }, 500);
                  })
                : console.error("btnShowProducts or newDom is not found.");
    }
}
customElements.define("sht-view-compare", SHTHandleViewCompare);
class SHTToggleBtnCompare extends SHTCustomComponent {
    constructor() {
        super(),
            (this.iconSwitch = this.$(".js-icon-switch")),
            (this.isChecked = this.iconSwitch.checked),
            this.iconSwitch;
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.iconSwitch &&
            (this.iconSwitch.addEventListener("click", () => {
                this.toggleState();
            }),
            this.iconSwitch.addEventListener("keydown", (t) => {
                ("Enter" !== t.key && " " !== t.key) || (t.preventDefault(), this.toggleState());
            }));
    }
    toggleState() {
        (this.isChecked = !this.isChecked),
            this.iconSwitch.toggleAttribute("checked"),
            (this.iconSwitch.checked = this.isChecked),
            this.isChecked ? this.iconSwitch.classList.add("is-active") : this.iconSwitch.classList.remove("is-active"),
            this.iconSwitch.setAttribute("aria-checked", this.isChecked),
            this.iconSwitch.setAttribute("aria-checked", this.isChecked);
    }
}
customElements.define("sht-toggle-btn-compare", SHTToggleBtnCompare);
class SHTMainProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-prd-variant-swtch", SHTMainProductVariantSwatch);
class SHTMainProductVariantSwatchWSelect extends SHTColorSwatch {}
customElements.define("sht-prd-variant-swtch-w-select", SHTMainProductVariantSwatchWSelect);
class SHTProductQuickViewVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-prd-qck-vw-variant-swtch", SHTProductQuickViewVariantSwatch);
class SHTMainCollectionProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-coll-prd-variant-swtch", SHTMainCollectionProductVariantSwatch);
class SHTFeaturedProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-featured-prd-variant-swtch", SHTFeaturedProductVariantSwatch);
class SHTMainSearchVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-srch-variant-swtch", SHTMainSearchVariantSwatch);
class SHTCustomSortField extends HTMLElement {
    constructor() {
        super(), (this.radioSortBtns = SHTHelper.qsa(".js-sort-field-item"));
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.radioSortBtns = SHTHelper.qsa(".js-sort-field-item")),
            this.radioSortBtns.forEach((e) => {
                e.addEventListener("click", (t) => {
                    this.handleRadioFieldMobile(t, e);
                });
            });
    }
    handleRadioFieldMobile(t, e) {
        this.sortByFieldHidden = SHTHelper.qs(".js-collection-product-sort-by-field-hidden");
        var s = e.querySelector(".js-sort-field-radio");
        this.deletedAllCheckbox(),
            this.addCheckbox(e),
            this.sortByFieldHidden &&
                ((this.sortByFieldHidden.value = s.dataset.value),
                this.sortByFieldHidden.dispatchEvent(new Event("input", { bubbles: !0 })));
    }
    addCheckbox(t) {
        t.classList.add("checked");
    }
    deletedAllCheckbox() {
        this.radioSortBtns.forEach((t) => {
            t.classList.remove("checked");
        });
    }
}
customElements.define("sht-custom-sort-field", SHTCustomSortField);
class SHTShowAllOption extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.dataStepExpand = parseInt(this.dataset.stepExpand)),
            (this.btn = this.$(".js-expandable-content-btn")),
            0 != this.dataStepExpand && (this.visibilityShowMore(), this.hidenFilterItem(), this.bindEventHandlers());
    }
    visibilityShowMore() {
        this.querySelectorAll(".filter-form__item").length > this.dataStepExpand &&
            this.btn.parentElement.classList.remove("d-none");
    }
    hidenFilterItem() {
        this.querySelectorAll(".filter-form__item").forEach((t, e) => {
            e + 1 > this.dataStepExpand && t.classList.add("d-none-important");
        });
    }
    bindEventHandlers() {
        this.btn.addEventListener("click", (t) => {
            this.querySelectorAll(".filter-form__item").forEach((t, e) => {
                t.classList.remove("d-none-important"), this.btn.parentElement.classList.add("d-none");
            });
        });
    }
}
customElements.define("sht-show-all-options", SHTShowAllOption);
class SHTLoadMore extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.loadMoreBtn = this.querySelector(".js-load-more")),
            (this.renderContainer = SHTHelper.qid("loadMoreContent")),
            (this.compare = SHTHelper.qs("sht-collections-compare")),
            (this.spinnerLoading = this.querySelector(".js-spinner-loading")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.addEventListener("click", this.loadMoreItems);
    }
    loadMoreItems() {
        this.loadMoreBtn.setAttribute("disabled", !0), this.spinnerLoading.classList.remove("d-none-important");
        let { pageSize: t, nextUrl: e, totalItems: s } = this.dataset,
            i = parseInt(this.dataset.currentPage) + 1;
        fetch(e.replace(/page=[0-9]+/, "page=" + i))
            .then((t) => t.text())
            .then((t) => {
                var e = this.renderContainer.children.length,
                    s = document.createElement("div"),
                    t = ((s.innerHTML = t), s.querySelector("#loadMoreContent").innerHTML);
                this.renderContainer.insertAdjacentHTML("beforeend", t),
                    Array.from(this.renderContainer.children)
                        .slice(e)
                        .forEach((t, e) => {
                            t.style.setProperty("--animation-order", e),
                                requestAnimationFrame(() => {
                                    t.classList.add("load-more-item--visible");
                                });
                        }),
                    this.compare?.init();
            })
            .catch((t) => {
                console.error(t);
            })
            .finally(() => {
                this.loadMoreBtn.removeAttribute("disabled"),
                    this.spinnerLoading.classList.add("d-none-important"),
                    (this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1),
                    parseInt(s) - i * parseInt(t) < 0 &&
                        (this.loadMoreBtn.classList.add("d-none-important"), (this.innerHTML = this.dataset.label));
            });
    }
}
customElements.define("sht-load-more", SHTLoadMore);
class SHTReadMore extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.contents = this.$$(".js-comp-drawer-des .js-expandable-content")),
            (this.btns = this.$$(".js-comp-drawer-des .js-expandable-content-btn")),
            this.contents.forEach((e, t) => {
                const s = this.btns[t];
                e.scrollHeight > e.clientHeight
                    ? (e.setAttribute("data-expanded", "false"), e.classList.add("expandable-content--expandable"))
                    : e.setAttribute("data-expanded", "true"),
                    s.addEventListener("click", () => {
                        var t = e.scrollHeight;
                        "true" == e.getAttribute("data-expanded")
                            ? (e.setAttribute("data-expanded", "false"),
                              (e.style.maxHeight = "120px"),
                              (s.innerHTML = s.getAttribute("data-view-more")))
                            : (e.setAttribute("data-expanded", "true"),
                              (e.style.maxHeight = t + "px"),
                              (s.innerHTML = s.getAttribute("data-view-less")));
                    });
            });
    }
}
customElements.define("sht-read-more", SHTReadMore);
class SHTShareProductButton extends SHTCustomComponent {
    constructor() {
        super(),
            (this.webShareApiContainer = this.$(".js-web-share-api-container")),
            (this.webShareApiButton = this.$(".js-web-share-api-btn")),
            (this.noneWebShareApiContainer = this.$(".js-none-web-share-api-container")),
            (this.noneWebShareApiButton = this.$(".js-none-web-share-api-btn")),
            (this.copyLinkButton = this.$(".js-social-share-copy-link")),
            this.init();
    }
    init() {
        navigator.share
            ? (this.webShareApiContainer.removeAttribute("hidden"),
              this.webShareApiButton.addEventListener("click", () => {
                  navigator
                      .share({ url: this.dataset.productUrl, title: document.title })
                      .then(() => {
                          console.log("Thanks for sharing!");
                      })
                      .catch(console.error);
              }))
            : (this.noneWebShareApiContainer.removeAttribute("hidden"),
              this.copyLinkButton.addEventListener("click", (t) => {
                  this.copyToClipboard(t.currentTarget);
              }));
    }
    copyToClipboard(t) {
        navigator.clipboard.writeText(this.dataset.productUrl).then(() => {
            t.querySelector(".js-social-share-copy-link-label").textContent = t.dataset.linkCopiedToClipboard;
        });
    }
}
customElements.define("sht-share-prd-btn", SHTShareProductButton);
class SHTReadMoreLine extends SHTCustomComponent {
    constructor() {
        super(),
            (this.content = this.$(".js-expandable-content")),
            (this.button = this.$(".js-expandable-content-btn")),
            (this.isTruncateEnabled = this.dataset.truncateEnabled),
            this.init();
    }
    init() {
        "true" == this.isTruncateEnabled && this.content.scrollHeight > this.getMaxHeight()
            ? (this.content.classList.add("card__excerpt"),
              this.button.classList.remove("d-none-important"),
              this.button.addEventListener("click", () => {
                  (this.isExpanded = this.content.getAttribute("data-expanded")),
                      "true" == this.isExpanded
                          ? (this.content.classList.remove("expanded"),
                            this.content.setAttribute("data-expanded", "false"),
                            (this.button.innerText = this.button.getAttribute("data-view-more")))
                          : (this.content.classList.add("expanded"),
                            (this.content.style.maxHeight = "none"),
                            this.content.setAttribute("data-expanded", "true"),
                            (this.button.innerText = this.button.getAttribute("data-view-less")));
              }))
            : this.button.classList.contains("d-none-important") || this.button.classList.add("d-none-important");
    }
    getMaxHeight() {
        return 3 * parseInt(getComputedStyle(this).lineHeight);
    }
}
customElements.define("sht-read-more-line", SHTReadMoreLine);
class SHTMap extends SHTCustomComponent {
    constructor() {
        super(), (this.iframe = this.$(".js-map-iframe")), this.bindEventHandlers();
    }
    loadIframeContent() {
        new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    t.isIntersecting &&
                        (this.dispatchEvent(
                            new CustomEvent("loadingStart", { detail: { ele: this.iframe, parent: this } })
                        ),
                        this.execute(),
                        e.unobserve(t.target));
                });
            },
            { rootMargin: "0px 0px -100px 0px" }
        ).observe(this);
    }
    bindEventHandlers() {
        this.iframe.addEventListener(
            "load",
            function () {
                this.dispatchEvent(new CustomEvent("loadingEnd", { detail: { ele: this.iframe, parent: this } })),
                    this.setAttribute("loaded", !0);
            }.bind(this)
        );
    }
    execute() {
        this.setIframeSrc();
    }
    setIframeSrc() {
        var t = `https://maps.google.com/maps?z=${this.dataZoom}&t=${this.dataType}&q=${this.dataLocation.replace(/"/g, "")}&ie=UTF8&&output=embed`;
        (this.iframe.src = t), this.iframe.removeAttribute("srcdoc");
    }
    static get observedAttributes() {
        return ["data-zoom", "data-type", "data-location"];
    }
    attributeChangedCallback(t, e, s) {
        e !== s && (Shopify.designMode ? this.execute() : this.loadIframeContent());
    }
    get dataZoom() {
        return this.getAttribute("data-zoom");
    }
    get dataType() {
        return this.getAttribute("data-type");
    }
    get dataLocation() {
        return this.getAttribute("data-location");
    }
    set dataZoom(t) {
        this.setAttribute("data-zoom", t);
    }
    set dataType(t) {
        this.setAttribute("data-type", t);
    }
    set dataLocation(t) {
        this.setAttribute("data-location", t);
    }
}
customElements.define("sht-map", SHTMap);
class SHTCarouselItem extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        new IntersectionObserver(
            (t, s) => {
                t.forEach((t) => {
                    var e = t.target;
                    t.isIntersecting &&
                        ("1" === e.dataset.attributePlaceholder &&
                            (e.setAttribute("aria-hidden", !1), e.setAttribute("aria-disabled", !1)),
                        s.unobserve(e));
                });
            },
            { root: this.closest("sht-carousel") }
        ).observe(this);
    }
    connectedCallback() {
        this.init();
    }
}
customElements.define("sht-carousel-itm", SHTCarouselItem);
var VAR_LOCALIZATION_CACHE = new Map();
class SHTLocalization extends SHTCustomComponent {
    constructor() {
        super();
    }
    async init() {
        Shopify.designMode
            ? await this.getSearchResults()
            : new IntersectionObserver(
                  (async (t, e) => {
                      t[0].isIntersecting && (await this.getSearchResults(), e.unobserve(this));
                  }).bind(this),
                  { threshold: 0.25 }
              ).observe(this);
    }
    async getSearchResults() {
        SHTHelper.loadScript(
            this.dataset.jsFileId,
            this.dataset.jsFile,
            async function () {
                var t = this.dataset.url.replace(/\s/g, "-").toLowerCase(),
                    e = VAR_LOCALIZATION_CACHE.get(t);
                e
                    ? (this.innerHTML = e)
                    : ((e = await this.fetchResults()), VAR_LOCALIZATION_CACHE.set(t, e), (this.innerHTML = e));
            }.bind(this)
        );
    }
    async fetchResults() {
        return fetch(this.dataset.url)
            .then((t) => t.text())
            .then((t) => {
                var e = document.createElement("div"),
                    t = ((e.innerHTML = t), e.querySelector("#" + this.dataset.sectionId));
                return t && t.innerHTML.trim().length ? t.innerHTML : "";
            })
            .catch((t) => (console.error(t), ""));
    }
    connectedCallback() {
        this.init();
    }
}
customElements.define("sht-localization", SHTLocalization);
class SHTMenuHeader extends SHTCustomComponent {
    constructor() {
        super(), (this.closeTimeout = null);
    }
    connectedCallback() {
        this.init(),
            this.handleOnLinkClick(),
            !1 === this.isMegaMenu && this.isDesktop && this.initSubmenuPositioning(),
            this.handleScrollEvent();
    }
    initSubmenuPositioning() {
        (this.resizeObserver = new ResizeObserver(this.checkSubmenuPositions.bind(this))),
            this.resizeObserver.observe(document.body),
            this.checkSubmenuPositions();
    }
    checkSubmenuPositions() {
        var t = this.$$(".menu-dropdown-lv2");
        const r = "rtl" === document.documentElement.dir || "rtl" === document.body.dir;
        t.forEach((t) => {
            var e,
                s,
                i = t.closest(".menu__item");
            i &&
                ((i = i.getBoundingClientRect()),
                (e = window.innerWidth),
                (s = t.offsetWidth + ((s = t.querySelector(".menu-dropdown-lv3")) ? s.offsetWidth : 0)),
                t.classList.remove("menu-dropdown--right", "menu-dropdown--left"),
                r
                    ? i.left <= s && t.classList.add("menu-dropdown--left")
                    : e - i.right <= s && t.classList.add("menu-dropdown--right"));
        });
    }
    init() {
        (this.header = SHTHelper.qs("sht-header")),
            (this.triggerBtnElement = SHTHelper.qs(".js-menu-drawer-trigger")),
            (this.details = this.$("details")),
            (this.summaries = this.$$("summary")),
            (this.summary = this.details.querySelector("summary")),
            (this.content = this.summary.nextElementSibling),
            (this.links = this.summary.querySelectorAll(".menu__link__link")),
            (this.level_one_btn = this.$$('.js-menu-header-back-btn[data-level="1"]')),
            (this.level_two_btn = this.$$('.js-menu-header-back-btn[data-level="2"]')),
            (this.level_third_btn = this.$$('.js-menu-header-back-btn[data-level="3"]')),
            (this.dropdownType = this.header.dataset.menuDropdownOpenType),
            (this.overlay = this.$("overlay")),
            (this.menuOverlay = this.$(".js-menu-overlay")),
            (this.isMegaMenuShow = !1),
            (this.isMegaMenu = "Megamenu" === this.dataset.menuDropdownType),
            (this.isDesktop = window.matchMedia("(min-width: 1195px)").matches),
            this.summaries.forEach((e) => {
                const s = e.closest("details");
                e.addEventListener("click", (t) => {
                    t.preventDefault(), this.handleSummaryClick(t, e, s);
                }),
                    e.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
            }),
            "hover" === this.dropdownType && this.addHoverEventListeners(),
            this.menuOverlay &&
                (this.menuOverlay.clientHeight < this.menuOverlay.querySelector(".megamenu-container").clientHeight
                    ? this.overlay.classList.add("menu-overlay")
                    : this.overlay.classList.remove("menu-overlay"),
                this.menuOverlay.addEventListener("scroll", () => {
                    Math.ceil(this.menuOverlay.scrollTop + this.menuOverlay.clientHeight) >=
                    this.menuOverlay.scrollHeight
                        ? this.overlay.classList.remove("menu-overlay")
                        : this.overlay.classList.add("menu-overlay");
                })),
            this.bindEventHandlers();
    }
    handleMegamenuContainerOverlay() {
        new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting && this.overlay?.classList.remove("menu-overlay");
                });
            },
            { threshold: 1 }
        ).observe(this.menuOverlay?.querySelector(".js-megamenu-container"));
    }
    handleSummaryClick(t, e, s) {
        this.menuOverlay?.querySelector(".js-megamenu-container") && this.handleMegamenuContainerOverlay();
        var i = s.querySelector(".js-mega-menu-wrapper");
        let r = "";
        var a = "1" === s.dataset.level,
            n = "2" === s.dataset.level;
        if (
            (t.currentTarget.setAttribute("aria-expanded", !s.open),
            i && (r = i.dataset.megaMenuType),
            (a || n) &&
                this.summaries.forEach((t) => {
                    const e = t.closest("details");
                    "2" === e.dataset.level &&
                        e !== s &&
                        (e.classList.remove("is-open"),
                        setTimeout(() => {
                            e.open = !1;
                        }, 100));
                }),
            a && (this.closeAllMenu(), "drawer" !== r) && t.stopPropagation(),
            s.hasAttribute("open") || this.menuOpen)
        ) {
            const o = s.querySelector(".js-header-menu-wrapper");
            o &&
                (o.offsetHeight,
                o.classList.remove("animated"),
                o.classList.add("animated-out"),
                document.body.classList.add("animated-out"),
                document.body.classList.remove("animated"),
                setTimeout(() => {
                    o.classList.remove("animated-out"),
                        document.body.classList.remove("animated-out", "animated", "is-megamenu-show"),
                        e.setAttribute("aria-expanded", !1),
                        s.classList.remove("is-open"),
                        (s.open = !1);
                }, 300));
        } else
            this.open(),
                (s.open = !0),
                setTimeout(() => {
                    s.classList.add("is-open");
                    var t = s.querySelector(".js-header-menu-wrapper");
                    t &&
                        (t.offsetHeight,
                        t.classList.remove("animated-out", "animated"),
                        document.body.classList.remove("animated-out", "animated"),
                        t.classList.add("animated"),
                        document.body.classList.add("animated")),
                        !this.isMegaMenu && this.isDesktop && this.checkSubmenuPositions();
                }, 0),
                document.body.classList.toggle("is-megamenu-show", "Megamenu" === this.dataset.menuDropdownType);
    }
    disconnectedCallback() {
        this.resizeObserver && this.resizeObserver.disconnect(),
            this.scrollHandler && window.removeEventListener("scroll", this.scrollHandler);
    }
    addHoverEventListeners() {
        this.summaries.forEach((t) => {
            if (t.closest("sht-header")) {
                const e = t.closest("details"),
                    s = e.querySelector(".js-mega-menu-wrapper");
                ["mouseenter", "mouseleave"].forEach((t) => {
                    e.addEventListener(t, this.onHandleMouseEvent.bind(this)),
                        s && s.addEventListener(t, this.onHandleMouseEvent.bind(this));
                });
            }
        });
    }
    bindEventHandlers() {
        const e = (t) => {
            const e = t.currentTarget.closest("details");
            t = e.querySelector("summary:first-child");
            t.setAttribute("aria-expanded", !e.open),
                e.hasAttribute("open") &&
                    (e.classList.toggle("is-open", !e.open),
                    setTimeout(() => {
                        e.open = !1;
                    }, 100),
                    "1" === e.dataset.level &&
                        (this.header.classList.remove("header-menu--open"),
                        this.menu_body_drawer?.classList.remove("menu--is-open")),
                    t.focus());
        };
        [...this.level_one_btn, ...this.level_two_btn, ...this.level_third_btn].forEach((t) => {
            t.addEventListener("click", e);
        });
    }
    handleOnLinkClick() {
        this.links.forEach((t) => {
            t.addEventListener("click", (t) => {
                t.stopPropagation();
            });
        });
    }
    handleScrollEvent() {
        let t = !1;
        (this.scrollHandler = () => {
            t ||
                (window.requestAnimationFrame(() => {
                    document.body.classList.remove("is-megamenu-show"),
                        this.$$("details[open]").forEach((t) => {
                            const e = t.querySelector(".js-header-menu-wrapper"),
                                s = t.querySelector("summary");
                            e &&
                                (e.classList.remove("animated"),
                                e.classList.add("animated-out"),
                                setTimeout(() => {
                                    e.classList.remove("animated-out"),
                                        t.classList.remove("is-open"),
                                        (t.open = !1),
                                        s && s.setAttribute("aria-expanded", !1);
                                }, 300));
                        }),
                        this.closeTimeout && (clearTimeout(this.closeTimeout), (this.closeTimeout = null)),
                        (t = !1);
                }),
                (t = !0));
        }),
            window.addEventListener("scroll", this.scrollHandler, { passive: !0 });
    }
    onHandleMouseEvent(t) {
        var e = this.querySelector("details"),
            s = e.querySelector(".js-mega-menu-wrapper");
        let i = "";
        var r,
            a,
            n = t.target.closest("details").dataset.level;
        "drawer" === (i = s ? s.dataset.megaMenuType : i) &&
            ((a = (r = s.closest("details").querySelector("summary")).querySelector(".js-menu-link")),
            (r = r.querySelector(".js-menu-link-title")),
            a.classList.replace("d-block", "d-none"),
            r.classList.replace("d-none", "d-block")),
            (s &&
                t.relatedTarget &&
                "mouseleave" === t.type &&
                (e.contains(t.relatedTarget) || s.contains(t.relatedTarget))) ||
                (s || "2" !== n || ((a = t.target.closest("details")), this.handleDetailsMouseEvent(t, a, i, s)),
                this.handleDetailsMouseEvent(t, e, i, s),
                this.menuOverlay?.querySelector(".js-megamenu-container") && this.handleMegamenuContainerOverlay());
    }
    handleDetailsMouseEvent(t, e, s, i) {
        "mouseenter" == t.type && "drawer" !== s
            ? this.toggleMenu(!0, e)
            : "mouseleave" != t.type ||
              e.contains(t.relatedTarget) ||
              i?.contains(t.relatedTarget) ||
              "drawer" === s ||
              this.toggleMenu(!1, e);
    }
    toggleMenu(t, e) {
        this.isMegaMenuShow = t;
        const s = e.querySelector(".js-header-menu-wrapper");
        let i = e.querySelector("summary");
        t
            ? (this.closeTimeout && clearTimeout(this.closeTimeout),
              this.closeAllMenu(),
              s && s.offsetHeight,
              e.classList.add("is-open"),
              (e.open = !0),
              i.setAttribute("aria-expanded", !0),
              s &&
                  (s.classList.remove("animated-out"),
                  document.body.classList.remove("animated-out"),
                  s.classList.add("animated"),
                  document.body.classList.add("animated")),
              document.body.classList.toggle("is-megamenu-show", "Megamenu" === this.dataset.menuDropdownType))
            : s &&
              (s.offsetHeight,
              s.classList.remove("animated"),
              s.classList.add("animated-out"),
              document.body.classList.add("animated-out"),
              document.body.classList.remove("animated"),
              (this.closeTimeout = setTimeout(() => {
                  s.classList.remove("animated-out"),
                      document.body.classList.remove("animated-out"),
                      e.classList.remove("is-open"),
                      (e.open = !1),
                      i.setAttribute("aria-expanded", !1);
                  var t = document.querySelectorAll("details");
                  Array.from(t).some((t) => {
                      return (
                          "drawer" !== t.querySelector(".js-mega-menu-wrapper")?.dataset.megaMenuType &&
                          t.matches(":hover")
                      );
                  }) ||
                      this.isMegaMenuShow ||
                      document.body.classList.remove("is-megamenu-show");
              }, 300)));
    }
    closeAllMenu() {
        var t = SHTHelper.qsa("sht-menu-header summary"),
            e = Array.from(SHTHelper.qsa("sht-menu-header details")).filter((t) => !this.contains(t));
        t.forEach((t) => {
            t.setAttribute("aria-expanded", !1);
        }),
            e.forEach((t) => {
                const e = t.querySelector(".js-header-menu-wrapper");
                e &&
                    (e.classList.remove("animated"),
                    e.classList.add("animated-out"),
                    setTimeout(() => e.classList.remove("animated-out"), 300)),
                    t.classList.toggle("is-open", !1),
                    (t.open = !1);
            });
    }
    onKeyUpEscEvent(t) {
        if ("ESCAPE" === t.code.toUpperCase()) {
            let e = t.target.closest("details[open]");
            if (e) {
                const s = e.querySelector(".js-header-menu-wrapper");
                s &&
                    (s.classList.remove("animated"),
                    s.classList.add("animated-out"),
                    setTimeout(() => s.classList.remove("animated-out"), 300)),
                    document.body.removeEventListener("click", this.onBodyClick);
                let t = e.querySelector("summary");
                "1" == e.dataset.level &&
                    (e.hasAttribute("open")
                        ? (this.header.classList.remove("header-menu--open"),
                          this.menu_body_drawer?.classList.remove("menu--is-open"))
                        : (this.header.classList.add("header-menu--open"),
                          this.menu_body_drawer?.classList.add("menu--is-open"))),
                    e.classList.remove("is-open"),
                    this.menu_body_drawer?.classList.remove("menu--is-open"),
                    setTimeout(() => {
                        e.removeAttribute("open"), t.setAttribute("aria-expanded", !1);
                    }, 100),
                    t.focus();
            }
        }
    }
    close() {
        document.body.removeEventListener("click", this.handleBodyClick.bind(this)),
            document.body.classList.remove("is-megamenu-show"),
            "1" == this.details.dataset.level &&
                this.details.hasAttribute("open") &&
                (this.header.classList.remove("header-menu--open"),
                this.menu_body_drawer?.classList.remove("menu--is-open"));
        for (let s = 0, t = this.summaries.length; s < t; s++) {
            let t = this.summaries[s],
                e = t.closest("details");
            const i = e.querySelector(".js-header-menu-wrapper");
            i &&
                (i.classList.remove("animated"),
                i.classList.add("animated-out"),
                setTimeout(() => i.classList.remove("animated-out"), 300)),
                e.classList.remove("is-open"),
                setTimeout(() => {
                    e.removeAttribute("open"), t.setAttribute("aria-expanded", !1);
                }, 100);
        }
    }
    open() {
        document.body.addEventListener("click", this.handleBodyClick.bind(this));
    }
    handleBodyClick(t) {
        this.contains(t.target) || this.close();
    }
}
customElements.define("sht-menu-header", SHTMenuHeader);
class SHTMenuDrawer extends SHTCoreDrawer {
    constructor() {
        super();
    }
    connectedCallback() {
        this.handleBindEvents();
    }
    handleBindEvents() {
        SHTHelper.qs("sht-menu-drwer-opner").addEventListener("click", () => {
            (this.summaries = this.querySelectorAll("summary")),
                (this.level_one_btn = this.querySelectorAll('.js-menu-header-back-btn[data-level="1"]')),
                this.summaries.forEach((t) => {
                    const e = t.closest("details");
                    t.addEventListener("click", (t) => {
                        t.preventDefault(), this.handleSummaryMobileClick(t, e);
                    });
                });
            const e = () => {
                SHTHelper.qsa(".js-header-navigation").forEach((t) => {
                    t.classList.remove("d-none-important");
                });
            };
            this.level_one_btn.forEach((t) => {
                t.addEventListener("click", e);
            });
        });
    }
    handleSummaryMobileClick(t, e) {
        if ("1" === e.dataset.level) {
            e = SHTHelper.qsa(".js-header-navigation");
            const s = t.target.closest(".js-header-navigation");
            e.forEach((t) => {
                t !== s && t.classList.add("d-none-important");
            });
        }
    }
}
customElements.define("sht-menu-drwer", SHTMenuDrawer);
class SHTMenuDrawerOpener extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.triggerBtnElement = this.$(".js-menu-drawer-trigger")),
            (this.menuDrawerElement = SHTHelper.qs("sht-menu-drwer")),
            (this.menuDrawerBodyElement = this.menuDrawerElement.querySelector(".js-menu-drawer-body")),
            (this.menuDrawerContentElements = SHTHelper.qsa(".js-menu-drawer-content")),
            (this.menuDrawerBodyContent = ""),
            this.menuDrawerContentElements.forEach((t) => {
                this.menuDrawerBodyContent += t.innerHTML;
            }),
            this.triggerBtnElement.addEventListener("click", (t) => {
                (this.menuDrawerBodyElement.innerHTML = this.menuDrawerBodyContent),
                    this.removeColorSchemeMegamenuMobile(),
                    setTimeout(() => {
                        this.menuDrawerElement.openDrawer(t.target);
                    }, 0);
            });
    }
    removeColorSchemeMegamenuMobile() {
        (this.megamenuWrappers = SHTHelper.qsa(".js-menu-drawer-body .js-mega-menu-wrapper")),
            this.megamenuWrappers.forEach((t) => {
                t.classList.remove(t.dataset.megaMenuColorScheme);
            });
    }
}
customElements.define("sht-menu-drwer-opner", SHTMenuDrawerOpener);
class SHTStickyHeader extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.shtHeaderElement = this.querySelector(".js-header")),
            (this.prodGridSection = SHTHelper.qs(".js-product-grid-section")),
            (this.header = SHTHelper.qs(".js-section-header")),
            (this.stickyProductGrid = SHTHelper.qs("sht-sticky-prodrid")),
            (this.headerTransparent = SHTHelper.qs(".shopify-section:first-child [enable-transparent-header]")),
            (this.sticky_state = this.dataset.stickyState),
            (this.colorSchemaDefault = this.shtHeaderElement.dataset.color),
            (this.colorSchemaSticky = this.shtHeaderElement.dataset.colorSticky),
            (this.colorSchemaTransparent = this.shtHeaderElement.dataset.colorTransparent),
            (this.originalHeaderPosition = this.header.offsetTop),
            (this.boundingBottom = this.shtHeaderElement.offsetHeight + this.originalHeaderPosition),
            (this.previousScrollTop = window.pageYOffset || document.documentElement.scrollTop),
            (this.currentScrollTop = 0),
            (this.isHeaderHidden = !1),
            (this.isSticky = !1),
            (this.isHeaderTransparent = !1),
            (this.prevent_reveal = !1),
            (this.headerBounds = {}),
            this.stickyProductGrid &&
                window.customElements.whenDefined("sht-sticky-prodrid").then(() => {
                    this.stickyProductGrid.init();
                }),
            this.updateHeaderHeight(),
            this.updateTransparentHeaderState(),
            this.bindEventHandlers(),
            this.createObserver();
    }
    updateHeaderHeight() {
        SHTHelper.qde.style.setProperty("--header-height", this.header.offsetHeight + "px");
    }
    connectedCallback() {
        this.init();
    }
    updateTransparentHeaderState() {
        (this.headerTransparent = SHTHelper.qs(".shopify-section:first-child [enable-transparent-header]")),
            this.headerTransparent
                ? ((this.isHeaderTransparent = !0), this.setTransparentHeader())
                : ((this.isHeaderTransparent = !1), this.removeTransparentHeader());
    }
    bindEventHandlers() {
        if ("false" == this.sticky_state) return !1;
        (this.preventStickyHeaderReveal = () => (this.prevent_reveal = !0)),
            this.addEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal),
            window.addEventListener("scroll", this.onScrollHandle.bind(this), !1);
    }
    createObserver() {
        new IntersectionObserver((t, e) => {
            (this.header_bounds = t[0].intersectionRect), e.disconnect();
        }).observe(this.header);
    }
    setTransparentHeader() {
        this.isHeaderTransparent &&
            (this.shtHeaderElement.classList.remove(this.colorSchemaDefault),
            this.shtHeaderElement.classList.remove(this.colorSchemaSticky),
            this.shtHeaderElement.classList.add(this.colorSchemaTransparent),
            this.header.classList.add("header--transparent"));
    }
    removeTransparentHeader() {
        this.colorSchemaDefault != this.colorSchemaTransparent &&
            this.shtHeaderElement.classList.remove(this.colorSchemaTransparent),
            this.header.classList.remove("header--transparent");
    }
    setSchemeSticky() {
        this.shtHeaderElement.classList.remove(this.colorSchemaDefault),
            this.shtHeaderElement.classList.add(this.colorSchemaSticky);
    }
    setSchemeDefault() {
        this.shtHeaderElement.classList.remove(this.colorSchemaSticky),
            this.shtHeaderElement.classList.add(this.colorSchemaDefault),
            this.removeTransparentHeader();
    }
    onScrollHandle() {
        (this.currentScrollTop = window.pageYOffset || SHTHelper.qde.scrollTop),
            "always_reveal" == this.sticky_state
                ? this.currentScrollTop > this.originalHeaderPosition
                    ? ((this.isSticky = !0),
                      (this.isHeaderTransparent = !1),
                      this.removeTransparentHeader(),
                      this.header.classList.add("header--sticky"),
                      this.setSchemeSticky(),
                      this.prodGridSection?.style.setProperty(
                          "--sticky-header-height",
                          this.shtHeaderElement.offsetHeight + "px"
                      ))
                    : ((this.isSticky = !1),
                      this.header.classList.remove("header--sticky"),
                      this.headerTransparent
                          ? ((this.isHeaderTransparent = !0), this.setTransparentHeader())
                          : this.setSchemeDefault())
                : this.header_bounds &&
                  (this.boundingBottom <= this.currentScrollTop && this.hideHeader(),
                  this.currentScrollTop > this.previousScrollTop &&
                      !this.isHeaderHidden &&
                      this.currentScrollTop > this.originalHeaderPosition &&
                      this.hideHeader(),
                  this.currentScrollTop < this.previousScrollTop &&
                      this.isHeaderHidden &&
                      (this.showHeader(), (this.isHeaderTransparent = !1)),
                  this.currentScrollTop > this.boundingBottom &&
                      !this.isSticky &&
                      (this.header.classList.add("header--fixed"),
                      this.setSchemeSticky(),
                      (this.isSticky = !0),
                      (this.isHeaderTransparent = !1),
                      this.removeTransparentHeader()),
                  ((this.currentScrollTop < this.originalHeaderPosition && this.isSticky) ||
                      0 == this.currentScrollTop) &&
                      (this.header.classList.remove("header--fixed"),
                      this.header.classList.remove("header--hidden", "header--visible"),
                      this.headerTransparent
                          ? ((this.isHeaderTransparent = !0), this.setTransparentHeader())
                          : this.setSchemeDefault(),
                      (this.isSticky = !1)),
                  (this.previousScrollTop = this.currentScrollTop));
    }
    showHeader() {
        this.header.classList.add("header--visible"),
            this.header.classList.remove("header--hidden"),
            this.setSchemeSticky(),
            (this.isHeaderHidden = !1);
    }
    hideHeader() {
        this.header.classList.add("header--hidden"),
            this.header.classList.remove("header--visible"),
            (this.isHeaderHidden = !0),
            (this.isHeaderTransparent = !1),
            this.closeMenu();
    }
    closeMenu() {
        (this.menus = this.header.querySelectorAll("sht-menu-header")), this.menus.forEach((t) => t.close());
    }
    disconnectedCallback() {
        this.removeEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal),
            window.removeEventListener("scroll", this.onScrollHandle.bind(this));
    }
}
customElements.define("sht-header-sticky", SHTStickyHeader);
class SHTHeader extends SHTCustomComponent {
    constructor() {
        super(),
            (this.btnSearchs = SHTHelper.qsa(".js-search-open-trigger")),
            (this.predictiveSearchDrawer = SHTHelper.qs("sht-search-drwr-section")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.btnSearchs.forEach((e) => {
            e.addEventListener("click", (t) => this.onBtnSearchClick(t, e));
        }),
            window.addEventListener("resize", () => {
                this.closeAllMenu(),
                    window.matchMedia("(max-width: 1024px)").matches ||
                        SHTHelper.qsa(".js-header-navigation").forEach((t) => {
                            t.classList.remove("d-none-important");
                        });
            });
    }
    closeAllMenu() {
        var t = this.$$("summary"),
            e = this.$$("details");
        t.forEach((t) => {
            t.setAttribute("aria-expanded", !1);
        }),
            e.forEach((t) => {
                t.classList.toggle("is-open", !1), (t.open = !1);
            }),
            document.body.classList.remove("o-hidden", "is-megamenu-show");
    }
    onBtnSearchClick(t, e) {
        t.preventDefault(),
            "page" != e?.dataset.event &&
                (this.predictiveSearchDrawer.openDrawer(t.target),
                setTimeout(() => {
                    SHTHelper.trapFocus(
                        this.predictiveSearchDrawer,
                        this.predictiveSearchDrawer.querySelector(".js-predictive-search-input")
                    );
                }, 650));
    }
}
customElements.define("sht-header", SHTHeader);
class SHTStickyProdGrid extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.stickyHeaderState = SHTHelper.qs("sht-header-sticky")?.dataset.stickyState),
            (this.onScrollHandle = this.onScrollHandle.bind(this)),
            (this.stickyBarPotition = this.offsetTop),
            (this.stickyHeight = this.offsetHeight),
            (this.prodGridSection = SHTHelper.qs(".js-product-grid-section")),
            this.prodGridSection?.style.setProperty("--prductgrid-bar-height", this.stickyHeight + "px"),
            (this.headerHeight = SHTHelper.qs(".js-section-header")?.offsetHeight),
            (this.prodgridToTop = this.stickyBarPotition - this.headerHeight),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        window.addEventListener("scroll", this.onScrollHandle, !1);
    }
    onScrollHandle() {
        var t = window.pageYOffset || SHTHelper.qde.scrollTop,
            e = this.classList.contains("product-grid-sticky-bar"),
            s = this.classList.contains("always_reveal--sticky");
        "always_reveal" === this.stickyHeaderState
            ? t > this.prodgridToTop && !s
                ? this.classList.add("always_reveal--sticky")
                : t <= this.prodgridToTop && s && this.classList.remove("always_reveal--sticky")
            : t > this.stickyBarPotition && !e
              ? this.classList.add("product-grid-sticky-bar")
              : t <= this.stickyBarPotition && e && this.classList.remove("product-grid-sticky-bar");
    }
}
customElements.define("sht-sticky-prodrid", SHTStickyProdGrid);
class SHTSrollGradientOverlay extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.scrollEle = this.$(".js-scroll-element")), this.scrollEle && this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.scrollEle.addEventListener("scroll", () => {
            this.scrollEle.scrollHeight - Math.floor(this.scrollEle.scrollTop) - 2 < this.scrollEle.clientHeight
                ? this.classList.remove("gradient-overlay")
                : this.classList.add("gradient-overlay");
        });
    }
}
customElements.define("sht-scroll-gradient-overlay", SHTSrollGradientOverlay);
class SHTTabs extends SHTCustomComponent {
    constructor() {
        super(),
            (this.tabLinks = this.$$(".js-tab-link")),
            (this.tabPanels = this.$$(".js-tab-panel")),
            (this.tabContent = this.$(".js-tab-content")),
            (this.isInitialized = !1),
            (this.handleMutation = this.handleMutation.bind(this)),
            (this.handleTabClick = this.handleTabClick.bind(this)),
            this.init();
    }
    init() {
        this.tabLinks.length &&
            this.tabPanels.length &&
            (this.initMutationObserver(),
            this.bindEventHandlers(),
            this.initResizeObserver(),
            requestAnimationFrame(() => {
                this.activateInitialTab(), (this.isInitialized = !0);
            }));
    }
    initResizeObserver() {
        window.addEventListener("resize", this.handleMutation.bind(this));
    }
    initMutationObserver() {
        this.tabContent &&
            ((this.observer = new MutationObserver(this.handleMutation)),
            this.observer.observe(this.tabContent, { childList: !0, subtree: !0, attributes: !0 }));
    }
    handleMutation() {
        const t = this.$(".tab__panel--active");
        t &&
            !this.classList.contains("drawer-wrapper") &&
            requestAnimationFrame(() => {
                this.tabContent.style.minHeight = t.offsetHeight + "px";
            });
    }
    activateInitialTab() {
        var t = this.$(".js-tab-item:not(.d-none-important) .js-tab-link.true") || this.tabLinks[0];
        t && (this.activateTab(t), this.$(".tab__panel--active")?.classList.add("tab__panel--initial"));
    }
    bindEventHandlers() {
        this.tabLinks.forEach((t) => {
            t.addEventListener("click", this.handleTabClick);
        });
    }
    handleTabClick(t) {
        t.preventDefault(), this.activateTab(t.target.closest(".js-tab-link"));
    }
    activateTab(t) {
        var e;
        t &&
            (e = t.getAttribute("href")?.replace("#", "")) &&
            (this.isInitialized &&
                this.tabPanels.forEach((t) => {
                    t.classList.add("tab__panel--transitioning");
                }),
            this.tabPanels.forEach((t) => {
                t.classList.remove("tab__panel--active", "tab__panel--initial");
            }),
            this.tabLinks.forEach((t) => {
                t.classList.remove("tab__link--active");
            }),
            (e = this.$(`[data-tab-content-id=${e}]`))) &&
            (e.classList.add("tab__panel--active"), t.classList.add("tab__link--active"));
    }
    disconnectedCallback() {
        this.observer?.disconnect(),
            window.removeEventListener("resize", this.handleResize),
            this.tabLinks.forEach((t) => {
                t.removeEventListener("click", this.handleTabClick);
            });
    }
}
customElements.define("sht-tabs", SHTTabs);
class SHTTabOverflow extends SHTCustomComponent {
    constructor() {
        super(),
            (this.tabContainer = this.$(".js-tab-container")),
            (this.tabOverflow = this.$(".js-tab-overflow")),
            (this.tabLinks = this.$$(".js-tab-link")),
            (this.tabStyle = this.getAttribute("data-tab-style")),
            (this.tabAnimation = this.initTabAnimation()),
            (this.activeTabLink = this.initActiveTab()),
            this.bindEventHandlers();
    }
    connectedCallback() {
        this.updateOverFlow(), this.updateIndicator(this.activeTabLink);
    }
    initTabAnimation() {
        let t = this.tabContainer.querySelector(".tab-animated-underline, .tab-animated-solid");
        return (
            t ||
                (((t = document.createElement("div")).className =
                    { underline: "tab-animated-underline", solid: "tab-animated-solid" }[this.tabStyle] || ""),
                this.tabContainer.appendChild(t)),
            t
        );
    }
    initActiveTab() {
        var t = this.tabContainer.querySelector(".js-tab-link.tab__link--active") || this.tabLinks[0];
        return (
            t && (t.classList.add("tab__link--active"), (t.style.background = this.tabStyle ? "transparent" : "")), t
        );
    }
    bindEventHandlers() {
        this.tabContainer.addEventListener("scroll", () => this.updateOverFlow()),
            window.addEventListener("resize", () => {
                this.updateOverFlow(), this.updateIndicator(this.activeTabLink);
            }),
            this.tabContainer.addEventListener("click", (t) => {
                t = t.target.closest(".js-tab-link");
                t &&
                    (this.tabLinks.forEach((t) => {
                        t.classList.remove("tab__link--active"), (t.style.background = "");
                    }),
                    t.classList.add("tab__link--active"),
                    (t.style.background = this.tabStyle ? "transparent" : ""),
                    this.updateIndicator(t));
            });
    }
    updateOverFlow() {
        var { scrollWidth: t, clientWidth: e, scrollLeft: s } = this.tabContainer,
            i = t - e - 1;
        e < t
            ? (this.tabOverflow?.classList.toggle("tab-overflow--left", 0 < s),
              this.tabOverflow?.classList.toggle("tab-overflow--right", s < i))
            : this.tabOverflow?.classList.remove("tab-overflow--right", "tab-overflow--left");
    }
    updateIndicator(t) {
        !t ||
            ("underline" !== this.tabStyle && "solid" !== this.tabStyle) ||
            Object.assign(this.tabAnimation.style, {
                width: t.offsetWidth + "px",
                left: t.offsetLeft + "px",
                display: "block",
            });
    }
}
customElements.define("sht-tab-overflow", SHTTabOverflow);
class SHTSelectSectionInEditor extends SHTCoreDrawer {
    constructor(t, e) {
        super(), (this.elementSelect = t), (this.key = e), this.bindEventSelectHandlers();
    }
    bindEventSelectHandlers() {
        const s = SHTHelper.qs(this.elementSelect);
        var t;
        "undefined" != typeof Shopify &&
            Shopify.designMode &&
            ((t = (t) => {
                var e = t.detail.sectionId.includes(this.key);
                s.toggleAttribute("open", e && "shopify:section:select" === t.type);
            }),
            document.addEventListener("shopify:section:select", t),
            document.addEventListener("shopify:section:deselect", t));
    }
}
class SHTSearchDrawerInEditor extends SHTSelectSectionInEditor {
    constructor() {
        super("sht-search-drwr-section", "search_drawer");
    }
}
customElements.define("sht-search-drwr-section", SHTSearchDrawerInEditor);
class SHTCartDrawer extends SHTSelectSectionInEditor {
    constructor() {
        super("sht-cart-drwr", "cart_drawer");
    }
    getSectionsToRender() {
        return [{ id: "cart-drawer", section: "cart-drawer", space_selector: "#cartDrawer" }];
    }
}
customElements.define("sht-cart-drwr", SHTCartDrawer),
    document.addEventListener("DOMContentLoaded", () => {
        var t = SHTHelper.qsa(".js-search-open-trigger");
        SHTHelper.qs("sht-search-drwr-section") ||
            t.forEach((t) => {
                "drawer" === t.dataset.event &&
                    ("undefined" != typeof Shopify && Shopify.designMode
                        ? t.addEventListener("click", () => {
                              setTimeout(() => {
                                  alert(
                                      "Search is unavailable due to a conflict in the search settings. Please unhide the ‘Search Drawer’ section or change the search behavior to ‘Search Page’ to resolve this issue. This message is only visible in the theme editor. In the live store, the system will automatically default to the ‘Search Page’."
                                  );
                              }, 500);
                          })
                        : t.removeAttribute("onclick"));
            });
    });
class SHTCollapsibleRegion extends SHTCustomComponent {
    constructor() {
        super(),
            (this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {}),
            (this.triggers = this.$$(".js-collapsible-region-trigger")),
            (this.contents = this.$$(".js-collapsible-region-content")),
            (this.bodyWidth = document.body.clientWidth),
            (this.isCollapsibleOnDesktop = this.properties.isCollapsibleOnDesktop),
            (this.isCollapsibleOnMobile = this.properties.isCollapsibleOnMobile),
            (this.isExpandOnMobile = this.properties.isExpandOnMobile),
            this.init(),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.isCollapsibleOnDesktop && this.isCollapsibleOnMobile) ||
            window.addEventListener("resize", (t) => {
                (this.bodyWidth = Math.floor(document.body.clientWidth)), this.init();
            }),
            this.triggers.forEach((t) => {
                t.addEventListener("click", (t) => {
                    this.onTriggerClick(t.currentTarget);
                });
            });
    }
    init() {
        ((!this.isCollapsibleOnDesktop && 1195 < this.bodyWidth) ||
            (!this.isCollapsibleOnMobile && this.bodyWidth <= 1195)) &&
            this.removeAriaProps(),
            ((this.isCollapsibleOnDesktop && 1195 < this.bodyWidth) ||
                (this.isCollapsibleOnMobile && this.bodyWidth <= 1195)) &&
                this.restoreAriaProps(),
            this.isExpandOnMobile && this.bodyWidth <= 1195 && this.expandMenu();
    }
    removeAriaProps() {
        this.triggers.forEach((t) => {
            (t.style.pointerEvents = "none"),
                t.setAttribute("tabindex", -1),
                t.removeAttribute("aria-controls"),
                t.removeAttribute("aria-expanded");
        }),
            this.contents.forEach((t) => {
                t.removeAttribute("aria-describedby"), t.removeAttribute("role");
            });
    }
    restoreAriaProps() {
        this.triggers.forEach((t) => {
            (t.style.pointerEvents = "auto"),
                t.setAttribute("aria-controls", this.properties.ariaControls),
                t.setAttribute("aria-expanded", "false"),
                t.removeAttribute("tabindex");
        }),
            this.contents.forEach((t) => {
                t.setAttribute("aria-describedby", this.properties.ariaDescribedby),
                    t.setAttribute("role", "region"),
                    (t.style.maxHeight = "0px");
            });
    }
    expandMenu() {
        this.triggers.forEach((t) => {
            t.setAttribute("aria-expanded", "true"), t.classList.add("open");
        }),
            this.contents.forEach((t) => {
                t.classList.add("open"),
                    requestAnimationFrame(() => {
                        t.style.maxHeight = `calc(${t.scrollHeight}px + var(--fix-m) * 2)`;
                    });
            });
    }
    onTriggerClick(t) {
        var e = "true" === t.getAttribute("aria-expanded");
        this.toggle(!e, t);
    }
    toggle(t, e) {
        e.setAttribute("aria-expanded", "" + t);
        let s = this.$("#" + e.getAttribute("aria-controls"));
        var i = Array.from(s.children);
        t
            ? (e.classList.add("open"),
              s.classList.add("open"),
              requestAnimationFrame(() => {
                  s.style.maxHeight = `calc(${s.scrollHeight}px + var(--fix-m) * 2)`;
              }),
              i.forEach((t) => {
                  t.style.transform = "translateY(0)";
              }))
            : (e.classList.remove("open"),
              s.classList.remove("open"),
              (s.style.maxHeight = "0px"),
              i.forEach((t) => {
                  t.style.transform = `translateY(-${s.scrollHeight}px)`;
              }));
    }
    open() {
        this.toggle(!0);
    }
    close() {
        this.toggle(!1);
    }
}
customElements.define("sht-clps-rgn", SHTCollapsibleRegion);
class SHTAnnouncementBar extends SHTCustomComponent {
    constructor() {
        super(),
            (this.layout = this.getAttribute("data-section-layout")),
            (this.container = this.$(".js-anmb-items")),
            (this.items = this.$$(".js-anmb-item")),
            (this.isRTL =
                "rtl" === document.documentElement.dir ||
                "rtl" === getComputedStyle(document.documentElement).direction);
    }
    init() {
        (this.totalItems = this.items.length),
            (this.previousButton = this.$(".js-anmb-control-prev")),
            (this.nextButton = this.$(".js-anmb-control-next")),
            (this.props = JSON.parse(this.dataset.props)),
            (this.delayTime = this.props.duration),
            (this.interval = null),
            (this.currentItemIndex = 1),
            (this.lastScrollTimeout = null),
            (this.messages = this.container.children),
            (this.isScrolling = !1),
            this.bindEventHandlers(),
            this.updateSort(),
            this.autoPlay();
    }
    connectedCallback() {
        "running" != this.layout &&
            ("grid-desktop" == this.layout
                ? (this.checkTabletView(), window.addEventListener("resize", this.checkTabletView.bind(this)))
                : this.init());
    }
    checkTabletView() {
        window.matchMedia("(max-width: 458.9px)").matches
            ? this.isInitialized ||
              ((this.isInitialized = !0),
              this.container.classList.add("ox-auto", "disable-scrollbars", "scrollable-stop-always", "scrollable-x"),
              this.init())
            : this.isInitialized && ((this.isInitialized = !1), this.destroySlider());
    }
    destroySlider() {
        this.clearDismissInterval(),
            this.container.classList.remove("ox-auto", "disable-scrollbars", "scrollable-stop-always", "scrollable-x"),
            this.container.removeAttribute("aria-live"),
            this.container.removeEventListener("mouseover", this.onMouseOverHandle.bind(this)),
            this.container.removeEventListener("mouseout", this.onMouseOutHandle.bind(this)),
            this.previousButton.removeEventListener("click", this.onPrevButtonClickHandler.bind(this)),
            this.nextButton.removeEventListener("click", this.onNextButtonClickHandler.bind(this)),
            this.container.removeEventListener("scroll", this.onScrollEventHandle.bind(this)),
            this.container.removeEventListener("wheel", this.resetAutoPlay.bind(this)),
            (this.isScrolling = !1);
    }
    updateSort() {
        var t, e, s, i;
        this.totalItems <= 1 ||
            ((this.isScrolling = !0),
            (t = this.container.scrollLeft),
            (e = Math.round(t)),
            (s = this.container.offsetWidth),
            (i = this.container.scrollWidth),
            this.isRTL
                ? (e <= 0 &&
                      Math.abs(e) < s &&
                      (this.container.prepend(this.messages[this.totalItems - 1]), (this.container.scrollLeft = e - s)),
                  e <= -(i - s - s) && (this.container.append(this.messages[0]), (this.container.scrollLeft = e + s)))
                : (e < s &&
                      (this.container.prepend(this.messages[this.totalItems - 1]), (this.container.scrollLeft = e + s)),
                  Math.floor(i - t) <= s &&
                      (this.container.append(this.messages[0]), (this.container.scrollLeft = e - s))),
            (this.isScrolling = !1));
    }
    onScrollEventHandle(t) {
        this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout),
            (this.lastScrollTimeout = setTimeout(
                function () {
                    this.updateSort();
                }.bind(this),
                100
            ));
    }
    bindEventHandlers() {
        this.previousButton.addEventListener(
            "click",
            SHTHelper.debounce(this.onPrevButtonClickHandler.bind(this), 300)
        ),
            this.nextButton.addEventListener(
                "click",
                SHTHelper.debounce(this.onNextButtonClickHandler.bind(this), 300)
            ),
            this.onObserverHandler(),
            this.container.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100)),
            this.container.addEventListener(
                "wheel",
                function (t) {
                    SHTHelper.debounce(this.resetAutoPlay.bind(this), 0);
                }.bind(this),
                { passive: !0 }
            );
    }
    onPrevButtonClickHandler() {
        if (!this.isScrolling) {
            (this.isScrolling = !0), this.resetAutoPlay();
            let t = this.currentItemIndex - 1;
            1 == this.currentItemIndex && (t = this.totalItems);
            var e = this.$(`div[data-item-index="${t}"]`);
            this.container.scrollTo({ left: e.offsetLeft, behavior: "smooth" });
        }
    }
    onNextButtonClickHandler() {
        if (!this.isScrolling) {
            (this.isScrolling = !0), this.resetAutoPlay();
            let t = this.currentItemIndex + 1;
            this.currentItemIndex == this.totalItems && (t = 1);
            var e = this.$(`div[data-item-index="${t}"]`);
            this.container.scrollTo({ left: e.offsetLeft, behavior: "smooth" });
        }
    }
    onMouseOverHandle(t) {
        this.clearDismissInterval();
    }
    onMouseOutHandle(t) {
        this.setDismissInterval();
    }
    clearDismissInterval() {
        this.interval && clearInterval(this.interval);
    }
    setDismissInterval() {
        this.interval = setInterval(
            function () {
                this.onNextButtonClickHandler();
            }.bind(this),
            this.delayTime
        );
    }
    resetAutoPlay() {
        !this.props.autoPlay ||
            this.totalItems < 2 ||
            (this.clearDismissInterval(),
            setTimeout(() => {
                this.setDismissInterval();
            }));
    }
    autoPlay() {
        !this.props.autoPlay || this.totalItems < 2
            ? (this.clearDismissInterval(), this.container.setAttribute("aria-live", "polite"))
            : (this.container.addEventListener("mouseover", this.onMouseOverHandle.bind(this)),
              this.container.addEventListener("mouseout", this.onMouseOutHandle.bind(this)),
              this.container.setAttribute("aria-live", "off"),
              this.setDismissInterval());
    }
    onObserverHandler() {
        let e = new IntersectionObserver(
            (t, e) => {
                t.forEach((e) => {
                    if (e.isIntersecting) {
                        let t = e.target;
                        window.requestAnimationFrame(() => {
                            var t = this.$(".anmb-item--active");
                            t && t.classList.remove("anmb-item--active");
                        }),
                            (this.currentItemIndex = parseInt(t.dataset.itemIndex)),
                            window.requestAnimationFrame(() => t.classList.add("anmb-item--active"));
                        e = t.querySelector(".js-anmb-link-items");
                        e && e.removeAttribute("tabindex");
                    }
                });
            },
            { root: this.container, rootMargin: "0px", threshold: 0.5 }
        );
        this.items.forEach((t) => {
            e.observe(t);
        });
    }
}
customElements.define("sht-ann-bar", SHTAnnouncementBar);
class SHTPopoverNoti extends SHTCustomComponent {
    constructor() {
        super(),
            (this.iconCancel = this.$(".js-icon-cancel")),
            (this.notificationNewsletter = SHTHelper.qs(".js-newsletter-notification"));
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.renderNotificationNewsletter(), this.bindEventHandlers(), this.autoHide();
    }
    togglePanel(t) {
        t ? this.notificationNewsletter.classList.add("show") : this.notificationNewsletter.classList.remove("show");
    }
    renderNotificationNewsletter() {
        (this.notificationNewsletter.innerHTML = this.innerHTML), this.togglePanel(!0);
    }
    bindEventHandlers() {
        this.iconCancel.addEventListener("click", () => {
            this.togglePanel(!1);
        });
    }
    autoHide() {
        setTimeout(() => {
            this.togglePanel(!1);
        }, 3e3);
    }
}
customElements.define("sht-noti", SHTPopoverNoti);
class SHTMarqueeSection extends SHTCustomComponent {
    constructor() {
        super(),
            (this.marqueeWrapper = this.$(".js-marquee-container")),
            (this.marqueeList = this.$(".js-marquee-list")),
            (this.marqueeListAll = this.$$(".js-marquee-list")),
            (this.normalSpeed = parseFloat(this.getAttribute("normal-speed")) / 2 || 1),
            (this.slowSpeed = parseFloat(this.getAttribute("slow-speed")) / 2 || 0.5),
            (this.size = parseInt(this.getAttribute("size"))),
            (this.direction = this.getAttribute("direction")),
            (this.loop = parseInt(this.marqueeWrapper.getAttribute("loop-marquee"))),
            (this.speed = this.normalSpeed),
            (this.hoverInteraction = this.getAttribute("hover-interaction")),
            (this.isRTL =
                "rtl" === document.documentElement.dir ||
                "rtl" === getComputedStyle(document.documentElement).direction),
            this.init();
    }
    onResize() {
        (this.resizeObserver = new ResizeObserver((t) => {
            (this.marqueeListWidth = this.marqueeList.offsetWidth),
                (this.currentPosition = 0),
                (this.currentPositionReverse = -this.marqueeListWidth),
                (this.minWidthValue = window.innerWidth / (this.loop - 1)),
                this.checkWidth(),
                (this.currentPositionReverse = -this.newWidth);
        })),
            this.resizeObserver.observe(this);
    }
    init() {
        this.onResize(), this.startAnimation(), this.bindHoverEvents();
    }
    checkWidth() {
        this.loop * this.marqueeListWidth < window.innerWidth
            ? (this.marqueeListAll.forEach((t) => {
                  t.style.minWidth = this.minWidthValue + "px";
              }),
              (this.newWidth = this.minWidthValue))
            : (this.marqueeListAll.forEach((t) => {
                  t.style.minWidth = "";
              }),
              (this.newWidth = this.marqueeListWidth));
    }
    bindHoverEvents() {
        this.marqueeWrapper.addEventListener("mouseover", () => {
            this.speed = "slow_down" == this.hoverInteraction ? this.slowSpeed : 0;
        }),
            this.marqueeWrapper.addEventListener("mouseout", () => {
                this.speed = this.normalSpeed;
            });
    }
    startAnimation() {
        this.animate();
    }
    animate() {
        var t = this.direction || "animation-direction";
        (this.isRTL ? "animation-direction" === t : "animation-reverse" === t)
            ? ((this.currentPositionReverse += this.speed),
              0 <= this.currentPositionReverse && (this.currentPositionReverse = -this.newWidth),
              (this.marqueeWrapper.style.transform = `translateX(${this.currentPositionReverse}px)`))
            : ((this.currentPosition -= this.speed),
              this.currentPosition <= -this.newWidth && (this.currentPosition = 0),
              (this.marqueeWrapper.style.transform = `translateX(${this.currentPosition}px)`)),
            requestAnimationFrame(this.animate.bind(this));
    }
}
customElements.define("sht-marquee-section", SHTMarqueeSection);
class SHTLoadMedia extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.idVideo = this.dataset.idVideo),
            (this.typeVideo = this.dataset.type),
            (this.muteVideo = this.dataset.muteVideo),
            (this.eleVideo = this.$(".js-video-media-item")?.id),
            (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
            (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
            (this.trigger = this.$(".js-load-media-trigger")),
            (this.isVideoReady = !1),
            (this.isLoadingStarted = !1),
            this.trigger && this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
    }
    handlePlayVideo() {
        if (!this.isLoadingStarted) {
            (this.isLoadingStarted = !0), this.trigger?.classList.add("loading"), this.loadContent();
            const t = this.querySelector(".js-media-item-video");
            t &&
                t.addEventListener("play", () => {
                    this.pauseAllVideo(t), t.play();
                });
        }
    }
    onYouTubeIframeAPIReady() {
        if ("undefined" != typeof YT && void 0 !== YT.Player)
            try {
                this.player = new YT.Player(this.eleVideo, {
                    videoId: this.idVideo,
                    playerVars: { playsinline: 1, autoplay: 1, mute: this.muteVideo },
                    events: { onReady: this.onPlayerYTReady, onStateChange: this.onPlayerStateYTChange },
                });
            } catch (t) {
                console.error("Error when creating the Youtube player:", t), this.handleVideoLoadError();
            }
        else {
            var t = document.createElement("script"),
                e =
                    ((t.src = "https://www.youtube.com/iframe_api"),
                    (t.onload = () => {
                        this.onYouTubeIframeAPIReady();
                    }),
                    (t.onerror = () => {
                        this.handleVideoLoadError();
                    }),
                    document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
        }
    }
    onVimeoIframeAPIReady() {
        if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
            try {
                var t = { id: this.idVideo, autoplay: 1 };
                (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
                    this.playerVimeo
                        .ready()
                        .then(() => {
                            this.onPlayerVimeoReady();
                        })
                        .catch((t) => {
                            console.error("Error when Vimeo player ready:", t), this.handleVideoLoadError();
                        }),
                    "iframe" !== this.playerVimeo.element
                        ? this.querySelector(".js-vimeo-media").classList.remove("d-none")
                        : this.querySelector(".js-vimeo-media").classList.add("d-none"),
                    this.playerVimeo.on("play", () => {
                        this.pauseAllVideo(this.playerVimeo);
                    });
            } catch (t) {
                console.error("Error when creating the Vimeo player:", t), this.handleVideoLoadError();
            }
        else {
            var t = document.createElement("script"),
                e =
                    ((t.src = "https://player.vimeo.com/api/player.js"),
                    (t.onload = () => {
                        this.onVimeoIframeAPIReady();
                    }),
                    (t.onerror = () => {
                        this.handleVideoLoadError();
                    }),
                    document.getElementsByTagName("script")[0]);
            e.parentNode.insertBefore(t, e);
        }
    }
    onPlayerYTReady = () => {
        (this.isVideoReady = !0),
            this.hideThumbAndShowVideo(),
            this.pauseAllVideo(this.player),
            this.player.playVideo();
    };
    onPlayerVimeoReady = () => {
        (this.isVideoReady = !0), this.hideThumbAndShowVideo(), this.pauseAllVideo(this.playerVimeo);
    };
    onPlayerStateYTChange = (t) => {
        1 == t.data && this.onPlayerPlay();
    };
    onPlayerPlay = () => {
        this.pauseAllVideo(this.player);
    };
    hideThumbAndShowVideo() {
        this.isVideoReady &&
            (this.trigger?.classList.add("d-none-important"),
            this.trigger?.classList.remove("loading"),
            this.$(".js-media-item")?.classList.add("d-flex"));
    }
    handleVideoLoadError() {
        (this.isLoadingStarted = !1),
            this.trigger?.classList.remove("loading"),
            console.error("Failed to load video player");
    }
    loadContent() {
        if (!this.getAttribute("loaded")) {
            if (this.$("template")) {
                var t = this.$("template").content.firstElementChild.cloneNode(!0);
                this.appendChild(t), this.isLoaded(!0), (this.isVideoReady = !0), this.hideThumbAndShowVideo();
            } else if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
            else {
                if ("vimeo" != this.typeVideo) return (this.isVideoReady = !0), this.hideThumbAndShowVideo(), !0;
                this.onVimeoIframeAPIReady();
            }
            return !0;
        }
    }
    pauseAllVideo(e) {
        SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach((t) => {
            t.player && e !== t.player && t.player?.pauseVideo();
        }),
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                t.playerVimeo !== e && t.playerVimeo?.pause();
            }),
            SHTHelper.qsa(".js-media-item-video").forEach((t) => {
                t !== e && t.pause();
            });
    }
    isLoaded(t) {
        t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
    }
}
customElements.define("sht-load-media", SHTLoadMedia);
class TabComponent extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const e = Array.from(this.querySelectorAll(".js-tab-header-button")),
            s = Array.from(this.querySelectorAll(".js-tab-content"));
        var t;
        e.length &&
            s.length &&
            ((t = this.getAttribute("data-toggle-mode") || "click"),
            this.initializeDefaultTab(e, s),
            this.addEventListener(t, (t) => {
                t = t.target.closest(".js-tab-header-button");
                t && this.toggleTab(t, e, s);
            }));
    }
    initializeDefaultTab(t, e) {
        var t = t[0],
            s = t.getAttribute("data-code"),
            s = this.querySelector("#" + s);
        s && (t.classList.add("active"), s.classList.add("active"));
    }
    toggleTab(t, e, s) {
        var i = t.getAttribute("data-code"),
            i = this.querySelector("#" + i);
        i &&
            (s.forEach((t) => t.classList.remove("active")),
            e.forEach((t) => t.classList.remove("active")),
            i.classList.add("active"),
            t.classList.add("active"));
    }
}
customElements.define("tab-component", TabComponent);
class SHTVideoBanner extends SHTCustomComponent {
    constructor() {
        super(),
            (this.iframe = this.$("iframe")),
            (this.isPlaying = JSON.parse(this.dataset.videoPlay)),
            (this.isMute = JSON.parse(this.dataset.videoMute)),
            (this.btnPlay = this.$(".js-btn-play")),
            (this.btnMute = this.$(".js-btn-mute")),
            (this.local_video = this.$("video")),
            this.btnPlay && this.bindEventHandlers();
    }
    connectedCallback() {
        this.execute(),
            "undefined" != typeof Shopify && Shopify.designMode
                ? this.querySelector(".js-btn-mute")?.classList.add("pe-none")
                : this.querySelector(".js-btn-mute")?.classList.remove("pe-none");
    }
    bindEventHandlers() {
        this.btnPlay.addEventListener("click", () => {
            this.togglePlay();
        }),
            this.btnMute.addEventListener("click", () => {
                this.toggleMute();
            }),
            this.bindVideoEndEvent();
    }
    bindVideoEndEvent() {
        "local_video" === this.dataVideoType &&
            this.local_video &&
            this.local_video.addEventListener("ended", () => this.onVideoEnded());
    }
    onVideoEnded() {
        (this.isPlaying = !1), (this.dataset.videoPlay = this.isPlaying);
    }
    togglePlay() {
        (this.isPlaying = !this.isPlaying),
            this.isPlaying
                ? (this.playVideo(), (this.dataset.videoPlay = !0))
                : ((this.dataset.videoPlay = !1), this.pauseVideo());
    }
    toggleMute() {
        (this.isMute = !this.isMute),
            this.isMute
                ? (this.muteVideo(), (this.dataset.videoMute = !0))
                : (this.unMuteVideo(), (this.dataset.videoMute = !1));
    }
    muteVideo() {
        "youtube" === this.dataVideoType
            ? this.iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', "*")
            : "vimeo" === this.dataVideoType
              ? this.iframe.contentWindow.postMessage('{"method":"setVolume","value":0}', "*")
              : "local_video" === this.dataVideoType && this.local_video && (this.local_video.muted = this.isMute);
    }
    unMuteVideo() {
        "youtube" === this.dataVideoType
            ? this.iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', "*")
            : "vimeo" === this.dataVideoType
              ? this.iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', "*")
              : (this.local_video.muted = this.isMute);
    }
    pauseVideo() {
        "youtube" === this.dataVideoType
            ? this.iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
            : "vimeo" === this.dataVideoType
              ? this.iframe.contentWindow.postMessage('{"method":"pause"}', "*")
              : "local_video" === this.dataVideoType && this.local_video && this.local_video.pause();
    }
    playVideo() {
        "youtube" === this.dataVideoType
            ? this.iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
            : "vimeo" === this.dataVideoType
              ? this.iframe.contentWindow.postMessage('{"method":"play"}', "*")
              : "local_video" === this.dataVideoType && this.local_video && this.local_video.play();
    }
    loadVideo() {
        new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    t.isIntersecting &&
                        (this.iframe &&
                            (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
                            this.iframe.addEventListener("load", () => {
                                "youtube" === this.dataVideoType &&
                                    this.iframe.contentWindow.postMessage(
                                        '{"event":"command","func":"playVideo","args":""}',
                                        "*"
                                    ),
                                    "vimeo" === this.dataVideoType &&
                                        this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
                            })),
                        "local_video" === this.dataVideoType &&
                            ((this.local_video = this.$("video")),
                            (t = this.local_video.querySelector("source").getAttribute("data-src")),
                            (this.local_video.src = t)),
                        e.disconnect());
                });
            },
            { root: null, rootMargin: "50px", threshold: 0 }
        ).observe(this);
    }
    execute() {
        this.loadVideo();
    }
    static get observedAttributes() {
        return ["data-video-type", "data-video-id"];
    }
    set dataVideoType(t) {
        this.setAttribute("data-video-type", t);
    }
    get dataVideoType() {
        return this.getAttribute("data-video-type");
    }
    set dataVideoId(t) {
        this.setAttribute("data-video-id", t);
    }
    get dataVideoId() {
        return this.getAttribute("data-video-id");
    }
    attributeChangedCallback(t, e, s) {
        e !== s && this.execute();
    }
}
customElements.define("sht-load-video", SHTVideoBanner),
    document.addEventListener("shopify:section:load", function (t) {
        SHTHelper.qs(".header-sticky")?.updateTransparentHeaderState();
    });
class SHTSlideShow extends SHTCustomComponent {
    constructor() {
        super(),
            (this.slideshow = this.$(".js-slideshow")),
            (this.slideshowItems = this.$(".js-slideshow-items")),
            (this.isRTL =
                "rtl" === document.documentElement.dir ||
                "rtl" === getComputedStyle(document.documentElement).direction),
            this.slideshowItems && (this.slideshowItems.style.direction = "ltr"),
            (this.totalElm = this.$(".js-slideshow-total")),
            (this.currentElm = this.$(".js-slideshow-current")),
            (this.separatorElm = this.$(".js-slideshow-separator")),
            (this.prevBtn = this.$(".js-slideshow-prev-btn")),
            (this.nextBtn = this.$(".js-slideshow-next-btn")),
            (this.startNStopBtn = this.$(".js-slideshow-start-n-stop-btn")),
            (this.imageItems = this.$$(".js-slideshow-image")),
            (this.pauseIcon = this.startNStopBtn.querySelector(".js-slideshow-pause-icon")),
            (this.playIcon = this.startNStopBtn.querySelector(".js-slideshow-play-icon")),
            (this.properties = JSON.parse(this.dataset.slideshowProperties)),
            (this.autoplay = this.properties.autoplay || !1),
            (this.image = null),
            (this.template = null),
            (this.current = 1),
            (this.anchors = []),
            (this.lastScrollTimeout = null),
            (this.autoplayInterval = null),
            (this.images = this.slideshowItems.children),
            (this.total = this.images.length),
            (this.slideshowItems.scrollLeft = 0),
            (this.observer = null),
            (this.isPaused = !1),
            (this.isFirstLoad = !0),
            (this.slideObserver = null);
    }
    cloneSlideItem() {
        var t, e;
        2 == this.total &&
            ((t = this.slideshowItems.querySelector(".js-slideshow-item:first-of-type")),
            (e = this.slideshowItems.querySelector(".js-slideshow-item:last-of-type")) &&
                ((e = e.cloneNode(!0)).classList.add("slider-slide--clone"), this.slideshowItems.append(e)),
            t) &&
            ((e = t.cloneNode(!0)).classList.add("slider-slide--clone"), this.slideshowItems.append(e));
    }
    execute() {
        this.total <= 1 || (this.cloneSlideItem(), this.prepare(), this.bindEventHandlers(), this.observeSection());
    }
    connectedCallback() {
        "complete" === document.readyState || "interactive" === document.readyState
            ? this.execute()
            : window.addEventListener("DOMContentLoaded", this.execute.bind(this), { once: !0 });
    }
    observeSection() {
        const e = new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting &&
                        this.isFirstLoad &&
                        (this.init(), (this.isFirstLoad = !1), e.unobserve(t.target));
                });
            },
            { threshold: 0.1 }
        );
        var t = this.slideshow.closest(".shopify-section");
        t && e.observe(t);
    }
    initSlideObserver() {
        (this.slideObserver = new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    var e = t.target.closest(".js-slideshow-item");
                    0.8 <= t.intersectionRatio
                        ? (e.classList.add("slider-slide--active"),
                          e.querySelectorAll(".js-button-group-link").forEach((t) => t.removeAttribute("tabindex")))
                        : (e.classList.remove("slider-slide--active"),
                          e.querySelectorAll(".js-button-group-link").forEach((t) => t.setAttribute("tabindex", "-1")));
                });
            },
            { root: this.slideshowItems, rootMargin: "0px", threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] }
        )),
            this.imageItems.forEach((t) => {
                this.slideObserver.observe(t);
            });
    }
    init() {
        this.autoplay && (this.resumeAutoPlay(), (this.isPaused = !0)),
            this.updateSort(),
            this.initSlideObserver(),
            this.handleScrollbarWidth();
    }
    updateSort() {
        var t, e, s, i;
        this.total <= 1 ||
            ((t = this.slideshowItems.scrollLeft),
            (e = Math.round(t)),
            (s = this.slideshowItems.offsetWidth),
            (i = this.slideshowItems.scrollWidth),
            e < s &&
                (this.slideshowItems.prepend(this.images[this.total - 1]), (this.slideshowItems.scrollLeft = e + s)),
            Math.floor(i - t) <= s &&
                (this.slideshowItems.append(this.images[0]), (this.slideshowItems.scrollLeft = e - s)));
    }
    startAutoPlay() {
        this.autoplay &&
            (this.autoplayInterval = setInterval(
                function () {
                    this.isRTL ? this.prevSlide() : this.nextSlide();
                }.bind(this),
                this.properties.duration
            ));
    }
    bindEventHandlers() {
        this.slideshowItems.addEventListener(
            "wheel",
            function (t) {
                5 == Math.abs(t.deltaX) && this.stopAutoPlay();
            }.bind(this),
            { passive: !0 }
        ),
            this.slideshowItems.addEventListener(
                "scroll",
                SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100)
            ),
            this.nextBtn.addEventListener(
                "click",
                function () {
                    this.isRTL ? this.prevSlide() : this.nextSlide(), this.stopAutoPlay();
                }.bind(this)
            ),
            this.prevBtn.addEventListener(
                "click",
                function () {
                    this.isRTL ? this.nextSlide() : this.prevSlide(), this.stopAutoPlay();
                }.bind(this)
            ),
            this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this)),
            this.handleSlideshowActionInAdmin();
    }
    handleSlideshowActionInAdmin() {
        if ("undefined" != typeof Shopify && Shopify.designMode) {
            let e = !0;
            document.addEventListener("shopify:section:load", (t) => {
                "slideshow" === JSON.parse(t.target.dataset.shopifyEditorSection).type &&
                    this.querySelectorAll(".js-slideshow-item").forEach((t) => {
                        t.classList.add("section-miw-100");
                    });
            }),
                document.addEventListener("shopify:section:select", (t) => {
                    t.target.id.includes("slideshow") &&
                        this.querySelectorAll(".js-slideshow-item").forEach((t) => {
                            t.classList.remove("section-miw-100");
                        });
                }),
                document.addEventListener("shopify:block:select", (t) => {
                    t.target.classList.contains("slider-slide") &&
                        ((e = !0),
                        t.target.closest(".js-slideshow-items").scrollTo({ left: t.target.offsetLeft }),
                        this.stopAutoPlay());
                }),
                document.addEventListener("shopify:block:deselect", (t) => {
                    t.target.classList.contains("slider-slide") &&
                        ((e = !1),
                        setTimeout(() => {
                            !e && JSON.parse(this.dataset.slideshowProperties).autoplay && this.resumeAutoPlay();
                        }, 500));
                });
        }
    }
    onStartNStopEventHandle(t) {
        t.preventDefault(), this.autoplay ? this.stopAutoPlay() : this.resumeAutoPlay();
    }
    stopAutoPlay() {
        clearInterval(this.autoplayInterval),
            this.pauseIcon.classList.add("d-none"),
            this.playIcon.classList.remove("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
            this.slideshowItems.setAttribute("aria-live", "polite"),
            (this.autoplay = !1);
    }
    resumeAutoPlay() {
        (this.autoplay = !0),
            this.pauseIcon.classList.remove("d-none"),
            this.playIcon.classList.add("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]),
            this.slideshowItems.setAttribute("aria-live", "off"),
            this.startAutoPlay();
    }
    onScrollEventHandle(t) {
        t.preventDefault(),
            this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout),
            (this.lastScrollTimeout = setTimeout(
                function () {
                    this.updateSort();
                }.bind(this),
                100
            )),
            this.updateCurrent();
    }
    prepare() {
        (this.totalElm.textContent = this.total),
            (this.currentElm.textContent = this.current),
            (this.separatorElm.textContent = this.properties.separatorText),
            this.autoplay &&
                (this.startNStopBtn.toggleAttribute("hidden", !1),
                this.startNStopBtn.querySelector(".js-slideshow-pause-icon").classList.remove("d-none"),
                this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
                this.slideshowItems.setAttribute("aria-live", "off"));
    }
    updateCurrent() {
        var t = this.$(".js-slideshow-image--current");
        t && (this.current = t.dataset.slideshowIndex), (this.currentElm.textContent = this.current);
    }
    prevSlide() {
        var t = this.slideshow.offsetWidth,
            e = this.slideshowItems.scrollLeft,
            e = Math.floor(e / t) * t - t;
        this.slideshowItems.scrollTo({ left: e, behavior: "smooth" });
    }
    nextSlide() {
        var t = this.slideshow.offsetWidth,
            e = this.slideshowItems.scrollLeft,
            e = Math.ceil(e / t) * t + t;
        this.slideshowItems.scrollTo({ left: e, behavior: "smooth" });
    }
    handleScrollbarWidth() {
        this.slideshowItems.style.setProperty(
            "--scrollbar-width",
            window.innerWidth - document.body.offsetWidth + "px"
        );
    }
}
customElements.define("sht-slideshow", SHTSlideShow);
class SHTSlideshowLazyLoadingImage extends SHTCustomComponent {
    constructor() {
        super(),
            (this.image = this.$(".js-image-lazy")),
            (this.imageMobile = this.$(".js-image-lazy-mobile")),
            (this.container = this.closest(".js-slideshow-items")),
            (this.currentItemClass = "js-slideshow-image--current"),
            (this.slideItem = this.closest(".js-slideshow-item")),
            (this.sectionId = this.dataset.sectionId),
            (this.section = SHTHelper.qs("#shopify-section-" + this.sectionId));
    }
    observeImage(s, i) {
        var t = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    t.target;
                    var e = this.parentNode;
                    t.isIntersecting && !this.getAttribute("loaded")
                        ? (s && s.removeAttribute("loading"),
                          i && i.removeAttribute("loading"),
                          this.setAttribute("loaded", !0),
                          e.classList.add(this.currentItemClass))
                        : 0 == t.intersectionRatio
                          ? e.classList.remove(this.currentItemClass)
                          : this.getAttribute("loaded") && e.classList.add(this.currentItemClass);
                });
            },
            { root: this.container, rootMargin: "100px -2px 100px -2px", threshold: 0 }
        );
        s && t.observe(s);
    }
    loadImage() {
        new ResizeObserver((t) => {
            window.matchMedia("(max-width: 767px)").matches && this.imageMobile
                ? this.observeImage(this.imageMobile, this.image)
                : this.image && this.observeImage(this.image, this.imageMobile);
        }).observe(document.body),
            window.matchMedia("(max-width: 767px)").matches && this.imageMobile
                ? this.observeImage(this.imageMobile, this.image)
                : this.image && this.observeImage(this.image, this.imageMobile);
    }
    execute() {
        this.loadImage();
    }
    connectedCallback() {
        this.execute();
    }
}
customElements.define("sht-slideshow-load-img", SHTSlideshowLazyLoadingImage);
class SHTVideo extends SHTCustomComponent {
    constructor() {
        super(), (this.mediaContent = this.$(".js-media-trigger")), (this.button = this.$(".js-load-media-trigger"));
    }
    execute() {
        this.bindEventHandlers();
    }
    connectedCallback() {
        this.execute();
    }
    bindEventHandlers() {
        this.addEventListener("click", () => {
            this.button.click(), this.mediaContent.classList.add("d-none-important"), this.classList.remove("sht-mask");
        });
    }
}
customElements.define("sht-video", SHTVideo);
class SHTHotsPot extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.cacheElements(), this.bindEventHandlers(), this.addResizeObserver();
    }
    cacheElements() {
        (this.triggers = this.$$(".js-carousel-trigger")),
            (this.hotspotItems = this.$$(".js-hotspot-item")),
            (this.hotspotContents = this.$$(".js-hotspot-content")),
            (this.closeBtn = this.$$(".js-hotspot-close-btn")),
            (this.carouselWebElement = SHTHelper.qs("#" + this.dataset.carouselTarget)),
            (this.dialogElement = SHTHelper.qs("#" + this.dataset.dialogId));
    }
    bindEventHandlers() {
        document.addEventListener("click", (t) => {
            var e = t.target.closest(".js-hotspot-content"),
                t = t.target.closest(".js-carousel-trigger");
            e || t || (this.hideAllContent(), this.setTriggersActiveState(!1));
        }),
            this.triggers.forEach((s) => {
                s.addEventListener("click", (t) => {
                    t.stopPropagation();
                    var e = s.classList.contains("active");
                    this.hideAllContent(), this.setTriggersActiveState(!1), e || this.prepare(t);
                });
            });
    }
    addResizeObserver() {
        new ResizeObserver((t) => {
            window.matchMedia("(max-width: 1024px)").matches
                ? this.hideAllContent()
                : this.dialogElement.hasAttribute("hidden") ||
                  (this.dialogElement.closeModal(), this.setTriggersActiveState(!1));
        }).observe(document.body);
    }
    prepare(t) {
        var e = t.target.parentElement.querySelector(".js-hotspot-content");
        window.matchMedia("(max-width: 1024px)").matches
            ? (this.dialogElement.handleProcessBodyContent(e),
              this.dialogElement.showModal(),
              (e = this.dialogElement.querySelector(".js-scroll-element")) &&
                  e.scrollHeight <= e.clientHeight &&
                  this.dialogElement.querySelector(".js-hotspot-content").classList.remove("gradient-overlay"),
              this.setTriggersActiveState(!1),
              this.setCurrentTriggerActive(t.target))
            : this.toggleContent(t);
    }
    toggleContent(t) {
        var e = t.target.parentElement.querySelector(".js-hotspot-content"),
            s = t.target;
        this.hideAllContent(),
            this.setTriggersActiveState(!1),
            this.setCurrentTriggerActive(t.target),
            e.classList.add("active"),
            s.classList.add("active"),
            this.handleScrollOverlay(e);
    }
    handleScrollOverlay(t) {
        var e = t.querySelector(".js-scroll-element");
        e && e.scrollHeight <= e.clientHeight && t.classList.remove("gradient-overlay");
    }
    hideAllContent() {
        this.hotspotContents.forEach((t) => {
            t.classList.remove("active");
        }),
            this.triggers.forEach((t) => {
                t.classList.remove("active");
            });
    }
    setTriggersActiveState(e) {
        this.triggers.forEach((t) => {
            t.classList.toggle("hotspot-item--active", e), t.setAttribute("aria-current", e ? "true" : null);
        });
    }
    setCurrentTriggerActive(t) {
        t.setAttribute("aria-current", "true"), t.classList.add("hotspot-item--active");
    }
}
customElements.define("sht-text-hotspot", SHTHotsPot);
class SHTDialogHotspot extends SHTDialogCore {
    constructor() {
        super();
    }
    handleProcessBodyContent(t) {
        var e;
        t && ((e = document.createElement("div")).appendChild(t.cloneNode(!0)), (this.body.innerHTML = e.innerHTML));
    }
}
customElements.define("sht-dialog-hotspot", SHTDialogHotspot);
class SHTProductSlideShow extends SHTCustomComponent {
    constructor() {
        super(),
            (this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`)),
            (this.thumb_carousel = SHTHelper.qs(`sht-slideshow-carousel[data-section="${this.dataset.section}"]`)),
            (this.hide_variant = this.dataset.hideVariantImage),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.$$(".js-slideshow-btn-thumb").forEach((t, e) => {
            0 === e && t.closest(".js-product-slideshow-thumb").classList.add("is-active-item"),
                t.addEventListener("click", this.setActiveMedia.bind(this, t));
        });
    }
    setActiveMedia(t) {
        var e = this.$(`[data-media-id="${t.dataset.target}"]`),
            t = t.closest("sht-slideshow-carousel-itm");
        window.matchMedia("(max-width: 1025px)").matches
            ? (this.pauseAllVideo(),
              this.$$(".js-product-slideshow-thumb").forEach((t) => {
                  t.classList.remove("is-active-item");
              }),
              t.classList.add("is-active-item"),
              this.carousel.querySelector(".js-carousel-items").scrollTo({ left: e.offsetLeft, behavior: "smooth" }))
            : (this.$$(".js-product-slideshow-item").forEach((t) => {
                  t.classList.remove("d-block"), "true" == this.hide_variant && t.classList.add("d-none");
              }),
              this.$$(".js-product-slideshow-thumb").forEach((t) => {
                  t.classList.remove("is-active-item");
              }),
              e.classList.add("d-block"),
              "true" == this.hide_variant && e.classList.remove("d-none"),
              t.classList.add("is-active-item"),
              this.playActiveVideo(e),
              this.playActiveModel(e));
    }
    pauseAllModel() {
        SHTHelper.qsa("sht-prd-media-itm-model").forEach((t) => {
            t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
    pauseAllVideo() {
        SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach((t) => {
            t.player && t.player?.pauseVideo();
        }),
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                t.playerVimeo && "function" == typeof t.playerVimeo.pause && t.playerVimeo.pause();
            }),
            SHTHelper.qsa(".js-media-item-video").forEach((t) => {
                "function" == typeof t.pause && t.pause();
            });
    }
    playActiveVideo(t) {
        this.pauseAllVideo();
        t = t.querySelector(".js-product-media-deferred-video");
        t && t.loadContent();
    }
    playActiveModel(t) {
        t = t.querySelector(".js-product-media-deferred-model");
        t && t.loadContent();
    }
}
customElements.define("sht-prd-slideshow", SHTProductSlideShow);
class SHTSlideShowCarousel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            (this.slideshow = SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`)),
            (this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`)),
            (this.carouselLayout = this.getAttribute("data-layout")),
            (this.window_width =
                window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth),
            this.transform(),
            window.addEventListener("resize", (t) => {
                var e = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                this.window_width != e && (this.transform(t), (this.window_width = e));
            });
    }
    transform(t) {
        window.matchMedia("(min-width: 1025px)").matches && "slideshow-below" != this.carouselLayout
            ? setTimeout(() => {
                  this.init(), this.bindEventHandlers(), void 0 !== t && this.setActiveMedia();
              }, 200)
            : setTimeout(() => {
                  this.horizontalInit(),
                      this.horizontalBindEventHandlers(),
                      void 0 !== t && this.horizontalSetActiveMedia();
              }, 200);
    }
    horizontalInit() {
        (this.itemsToShow = Array.from(this.carousels).filter((t) => 0 < t.clientWidth)),
            this.itemsToShow.length < 2
                ? this.horizontalTogglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.horizontalUpdateCarousel());
    }
    horizontalUpdateCarousel() {
        var t = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != t &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.horizontalIsItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement?.setAttribute("disabled", "disabled")
                : this.prevBtnElement?.removeAttribute("disabled"),
            this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement?.setAttribute("disabled", "disabled")
                : this.nextBtnElement?.removeAttribute("disabled"),
            1 < this.totalPages && this.horizontalTogglePagination(!0),
            this.totalPages <= 1 && this.horizontalTogglePagination(!1);
    }
    horizontalIsItemVisible(t, e = 0) {
        e = this.container.clientWidth + this.container.scrollLeft - e;
        return t.offsetLeft + t.clientWidth <= e && t.offsetLeft >= this.container.scrollLeft;
    }
    horizontalOnButtonClick(t) {
        t.preventDefault();
        let e = 1,
            s = 0;
        window.matchMedia("(min-width: 1025px)").matches && (e = t.currentTarget.dataset.step),
            (0 != this.container.scrollLeft &&
                !this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === t.currentTarget.name
                    ? this.container.scrollLeft - s + e * this.itemOffset
                    : this.container.scrollLeft + s - e * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    horizontalBindEventHandlers() {
        this.prevBtnElement && this.prevBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this)),
            this.nextBtnElement &&
                this.nextBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this)),
            this.container.addEventListener(
                "scroll",
                SHTHelper.debounce(this.horizontalUpdateCarousel.bind(this), 100)
            );
    }
    horizontalTogglePagination(t) {
        t
            ? (this.paginationElement?.classList.remove("d-none-important"),
              this.paginationElement?.classList.add("d-flex"))
            : (this.paginationElement?.classList.remove("d-flex"),
              this.paginationElement?.classList.add("d-none-important"));
    }
    horizontalSetActiveMedia() {
        var t = this.$("sht-slideshow-carousel-itm.is-active-item");
        t &&
            (this.container.scrollTo({ left: t.offsetLeft, behavior: "auto" }),
            (t = this.slideshow.$(`sht-carousel-itm[data-media-id="${t.dataset.mediaTargetId}"]`)),
            this.carousel.querySelector(".js-carousel-items").scrollTo({ left: t.offsetLeft, behavior: "auto" }));
    }
    init() {
        (this.itemsToShow = Array.from(this.carousels).filter((t) => 0 < t.clientWidth)),
            this.itemsToShow.length < 2
                ? this.togglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-top")) +
                      parseFloat(
                          window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-bottom")
                      )),
                  (this.itemOffset = this.itemsToShow[1].offsetTop - this.itemsToShow[0].offsetTop),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientHeight - this.itemsToShow[0].offsetTop) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel());
    }
    updateCarousel() {
        var t = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollTop / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != t &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollTop
                ? this.prevBtnElement?.setAttribute("disabled", "disabled")
                : this.prevBtnElement?.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement?.setAttribute("disabled", "disabled")
                : this.nextBtnElement?.removeAttribute("disabled"),
            1 < this.totalPages && this.togglePagination(!0),
            this.totalPages <= 1 && this.togglePagination(!1);
    }
    togglePagination(t) {
        t
            ? (this.paginationElement?.classList.remove("d-none-important"),
              this.paginationElement?.classList.add("d-flex"))
            : (this.paginationElement?.classList.remove("d-flex"),
              this.paginationElement?.classList.add("d-none-important"));
    }
    isItemVisible(t, e = 0) {
        e = this.container.clientHeight + this.container.scrollTop - e;
        return t.offsetTop + t.clientHeight - 1 <= Math.ceil(e) && t.offsetTop >= this.container.scrollTop;
    }
    onButtonClick(t) {
        t.preventDefault();
        let e = 1,
            s = 0;
        window.matchMedia("(min-width: 1025px)").matches && (e = t.currentTarget.dataset.step),
            (0 != this.container.scrollTop && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === t.currentTarget.name
                    ? this.container.scrollTop - s + e * this.itemOffset
                    : this.container.scrollTop + s - e * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ top: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
    }
    setActiveMedia() {
        var t = this.$("sht-slideshow-carousel-itm.is-active-item");
        t &&
            (this.container.scrollTo({ top: t.offsetTop, behavior: "auto" }),
            (t = this.slideshow.$(`sht-carousel-itm[data-media-id="${t.dataset.mediaTargetId}"]`)),
            this.slideshow.$$(".js-product-slideshow-item").forEach((t) => {
                t.classList.remove("d-block"), "true" == this.slideshow.hide_variant && t.classList.add("d-none");
            }),
            t.classList.add("d-block"),
            "true" == this.slideshow.hide_variant) &&
            t.classList.remove("d-none");
    }
}
customElements.define("sht-slideshow-carousel", SHTSlideShowCarousel);
class SHTZoomMedia extends SHTCustomComponent {
    constructor() {
        super(),
            (this.zoomView = this.querySelector(".js-zoom-view")),
            (this.mediaImage = this.querySelector(".js-media-image")),
            (this.wrapper = this.querySelector(".js-zoom-wrapper")),
            (this.galleryIcon = this.querySelector(".js-gallery-icon")),
            (this.scaleFactor = 1.5),
            (this.isActive = !1),
            (this.isHovering = !1),
            (this.pendingFrame = null),
            (this.mouseX = 0),
            (this.mouseY = 0),
            (this.boundOnEnter = this.onMouseEnterEvent.bind(this)),
            (this.boundOnLeave = this.onMouseLeaveEvent.bind(this)),
            (this.boundOnMove = this.onMouseMoveEvent.bind(this)),
            (this.onResizeHandler = SHTHelper.debounce(() => this.syncSizes(), 100));
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.bindEventHandlers(), this.syncSizes();
    }
    bindEventHandlers() {
        this.classList.contains("open-zoom") &&
            ((this.mq = window.matchMedia("(min-width: 1195px)")),
            (this.mqListener = () => this.toggleDesktopListeners(this.mq.matches)),
            this.mq.addEventListener
                ? this.mq.addEventListener("change", this.mqListener)
                : this.mq.addListener(this.mqListener),
            this.toggleDesktopListeners(this.mq.matches),
            window.addEventListener("resize", this.onResizeHandler, { passive: !0 }));
    }
    disconnectedCallback() {
        this.teardown();
    }
    teardown() {
        this.mq &&
            (this.toggleDesktopListeners(!1),
            this.mq.removeEventListener
                ? this.mq.removeEventListener("change", this.mqListener)
                : this.mq.removeListener(this.mqListener)),
            window.removeEventListener("resize", this.onResizeHandler),
            this.pendingFrame && (cancelAnimationFrame(this.pendingFrame), (this.pendingFrame = null));
    }
    toggleDesktopListeners(t) {
        t
            ? (this.addEventListener("mouseenter", this.boundOnEnter),
              this.addEventListener("mouseleave", this.boundOnLeave),
              this.addEventListener("mousemove", this.boundOnMove))
            : (this.removeEventListener("mouseenter", this.boundOnEnter),
              this.removeEventListener("mouseleave", this.boundOnLeave),
              this.removeEventListener("mousemove", this.boundOnMove),
              this.hideZoom());
    }
    onMouseEnterEvent(t) {
        (this.isHovering = !0), this.showZoom(), this.capturePointer(t);
    }
    onMouseLeaveEvent(t) {
        (this.isHovering = !1), this.hideZoom();
    }
    onMouseMoveEvent(t) {
        this.isHovering && (this.capturePointer(t), this.requestRender());
    }
    capturePointer(t) {
        var e = this.mediaImage?.getBoundingClientRect?.() || this.getBoundingClientRect();
        (this.mouseX = t.clientX - e.left), (this.mouseY = t.clientY - e.top), (this.mediaRect = e);
    }
    requestRender() {
        this.pendingFrame ||
            (this.pendingFrame = requestAnimationFrame(() => {
                (this.pendingFrame = null), this.renderZoom();
            }));
    }
    isRTL() {
        var t = (
                this.closest("[dir]")?.getAttribute("dir") ||
                document.documentElement.getAttribute("dir") ||
                ""
            ).toLowerCase(),
            e = getComputedStyle(document.documentElement).direction;
        return "rtl" === t || "rtl" === e;
    }
    syncSizes() {
        var t;
        this.mediaImage &&
            this.zoomView &&
            this.wrapper &&
            ((t = this.mediaImage.getBoundingClientRect()),
            (this.zoomView.style.width = t.width + "px"),
            (this.zoomView.style.height = t.height + "px"),
            (this.wrapperRect = this.wrapper.getBoundingClientRect()),
            (this.mediaRect = t),
            this.isHovering) &&
            this.renderZoom(!0);
    }
    showZoom() {
        this.wrapper && (this.wrapper.classList.remove("d-none"), (this.isActive = !0));
    }
    hideZoom() {
        this.wrapper && (this.wrapper.classList.add("d-none"), (this.isActive = !1));
    }
    clamp(t, e, s) {
        return Math.max(e, Math.min(s, t));
    }
    renderZoom(t = 0) {
        if (this.isActive && this.mediaRect && this.wrapper && this.zoomView) {
            var s = this.isRTL(),
                i = this.scaleFactor,
                r = this.mediaRect.width,
                a = this.mediaRect.height,
                n = this.wrapper.offsetWidth,
                o = this.wrapper.offsetHeight,
                l = this.clamp(this.mouseX, 0, r),
                d = this.clamp(this.mouseY, 0, a);
            let t, e;
            var h = r / 2 < l,
                h =
                    (h ? (t = l - n - 20) < -50 && (t = l + 20) : (t = l + 20) + n > r + 50 && (t = l - n - 20),
                    (e = this.clamp(d - o / 2, 0, a - o)),
                    (this.wrapper.style.top = e + "px"),
                    s
                        ? ((this.wrapper.style.right = r - t - n + "px"), (this.wrapper.style.left = "auto"))
                        : ((this.wrapper.style.left = t + "px"), (this.wrapper.style.right = "auto")),
                    r * i),
                s = o / 2 - d * i,
                r = o - a * i,
                d = this.clamp(n / 2 - l * i, n - h, 0),
                s = this.clamp(s, r, 0);
            this.zoomView.style.transform = `translate(${d}px, ${s}px) scale(${i})`;
        }
    }
}
customElements.define("sht-zoom-media", SHTZoomMedia);
class SHTProductSlideShowItem extends SHTCustomComponent {
    constructor() {
        super(),
            (this.openGalleryButton = this.$(".js-product-media-open-gallery-btn")),
            this.openGalleryButton &&
                this.openGalleryButton.addEventListener("click", (t) => {
                    this.openDialogGallery(t);
                }),
            (this.slideshow = this.closest("sht-prd-slideshow")),
            (this.parent = this.closest("sht-carousel-itm")),
            this.prepare();
    }
    openDialogGallery(t) {
        var e = SHTHelper.qs("#" + t.currentTarget.dataset.galleryDialogId);
        e && (e.showModal(t.currentTarget, !0), this.slideshow.pauseAllVideo());
    }
    prepare() {
        window.matchMedia("(max-width: 459px)").matches
            ? "true" == this.slideshow.hide_variant && this.parent.classList.remove("d-none")
            : this.parent.classList.contains("d-block") ||
              ("true" == this.slideshow.hide_variant && this.parent.classList.add("d-none")),
            new ResizeObserver((t) => {
                window.matchMedia("(max-width: 459px)").matches
                    ? "true" == this.slideshow.hide_variant && this.parent.classList.remove("d-none")
                    : this.parent.classList.contains("d-block") ||
                      ("true" == this.slideshow.hide_variant && this.parent.classList.add("d-none"));
            }).observe(document.body);
    }
}
customElements.define("sht-prd-slideshow-itm", SHTProductSlideShowItem);
class SHTQuantityInput extends SHTCustomComponent {
    constructor() {
        super(),
            (this.input = this.$(".js-quantity-input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            (this.allBtns = this.$$(".js-quantity-btn")),
            (this.productQuantity = parseInt(this.dataset.productQuantity)),
            (this.container = this.closest(".js-quantity-wrapper")),
            (this.message = this.container?.querySelector(".js-max-quantity-message")),
            (this.step = parseInt(this.input.step)),
            (this.currentCartItem = this.closest(".js-product-container")?.querySelector(".js-volume-cart-item")),
            (this.currentCartItemValue = parseInt(this.currentCartItem?.value)),
            (this.volumePricing = this.closest(".js-product-container")?.querySelector("quantity-pricing")),
            (this.quantityMessage = this.container?.querySelector(".js-quantity-pricing-message")),
            (this.minQuantityMessage = this.container?.querySelector(".js-min-quantity-pricing-message")),
            (this.maxQuantityMessage = this.container?.querySelector(".js-max-quantity-pricing-message")),
            (this.stepQuantityMessage = this.container?.querySelector(".js-step-quantity-pricing-message"));
    }
    connectedCallback() {
        this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.closest(".js-cart-item") &&
            ((this.currentCartItemValue = 0),
            (this.volumePricing = this.closest(".js-cart-item")?.querySelector("quantity-pricing"))),
            this.allBtns.forEach((t) => t.addEventListener("click", this.onButtonClickHandler.bind(this))),
            this.input.addEventListener("input", this.handleInputChange.bind(this)),
            this.input.addEventListener("change", this.updatePriceItem.bind(this)),
            this.updatePriceItem();
    }
    handleInputChange(t) {
        t.preventDefault();
        t = parseInt(this.input.value) || 0;
        t <= this.productQuantity || Number.isNaN(t) || 0 == t ? this.showMessage(!0) : this.showMessage(!1);
    }
    onButtonClickHandler(t) {
        t.preventDefault();
        var e = parseInt(this.input.value);
        let s;
        (s =
            "plus" === t.currentTarget.dataset.name
                ? parseInt(this.input.value) + this.step
                : parseInt(this.input.value) - this.step) <= parseInt(this.productQuantity)
            ? ("plus" === t.currentTarget.dataset.name ? this.input.stepUp() : this.input.stepDown(),
              this.showMessage(!0),
              this.toggleAnimation("animated"))
            : (this.showMessage(!1), this.toggleAnimation("error-animated")),
            e !== parseInt(this.input.value) && this.input.dispatchEvent(this.changeEvent);
    }
    toggleAnimation(t) {
        this.input.classList.remove("animated" === t ? "error-animated" : "animated"),
            this.input.classList.contains(t) && this.input.classList.remove(t),
            this.input.offsetWidth,
            this.input.classList.add(t);
    }
    validateQuantity(t) {
        var e = parseInt(this.input.min),
            s = parseInt(this.input.max),
            i = parseInt(this.input.step);
        const r = (t, e) => {
            t?.classList.toggle("d-none-important", !e);
        };
        var a = (t, e, s, i) => {
            r(this.quantityMessage, t),
                r(this.minQuantityMessage, e),
                r(this.maxQuantityMessage, s),
                r(this.stepQuantityMessage, i);
        };
        t < e ? a(!0, !0, !1, !1) : s < t ? a(!0, !1, !0, !1) : t % i != 0 ? a(!0, !1, !1, !0) : a(!1, !1, !1, !1);
    }
    updatePriceItem() {
        this.input && (this.inputValue = parseInt(this.input.value));
        let s = null;
        (this.currentValue = this.currentCartItemValue + this.inputValue),
            this.volumePricing?.querySelectorAll("li").forEach((t) => {
                var e = parseInt(t.querySelector(".js-pricing-item-quantity").textContent),
                    t = t.querySelector(".js-pricing-item-price")?.textContent;
                this.currentValue >= e && (s = t);
            });
        let t;
        (t = (
            this.closest(".js-product-container")
                ? this.closest(".js-product-container")
                : this.closest(".js-cart-item")
        )?.querySelector(".price-item")),
            null !== s && t && t.textContent !== s && (t.textContent = s);
    }
    showMessage(t) {
        this.message &&
            (t
                ? (this.message.classList.contains("d-none-important") ||
                      this.message.classList.add("d-none-important"),
                  0 < this.input.value && this.validateQuantity(this.input.value))
                : ([
                      this.quantityMessage,
                      this.minQuantityMessage,
                      this.maxQuantityMessage,
                      this.stepQuantityMessage,
                  ].forEach((t) => {
                      t && !t.classList.contains("d-none-important") && t.classList.add("d-none-important");
                  }),
                  this.message.classList.remove("d-none-important")));
    }
}
customElements.define("sht-qty-inp", SHTQuantityInput);
class SHTGiftCardRecipientForm extends SHTCustomComponent {
    constructor() {
        super(),
            (this.i_want_input = this.querySelector(".js-gift-card-recipient-form-i-want")),
            (this.i_want_input.disabled = !1),
            (this.hidden_i_want_input = this.querySelector(".js-gift-card-recipient-form-i-want-hidden")),
            (this.hidden_i_want_input.disabled = !0),
            (this.email_input = this.querySelector(".js-gift-card-recipient-form-email")),
            (this.name_input = this.querySelector(".js-gift-card-recipient-form-name")),
            (this.message_input = this.querySelector(".js-gift-card-recipient-form-message")),
            (this.send_on_input = this.querySelector(".js-gift-card-recipient-form-send_on")),
            (this.email_error = this.querySelector(".js-gift-card-recipient-form-email-error")),
            (this.toggle_recipient_form_lbl = this.querySelector(".js-gift-card-recipient-label")),
            (this.toggle_recipient_form_fields = this.querySelector(".js-gift-card-recipient-fields"));
    }
    connectedCallback() {
        this.handleBindEventsListener();
    }
    onChangeHandler() {
        this.i_want_input.checked || (this.clearInputFields(), this.clearErrorMessage());
    }
    handleBindEventsListener() {
        this.addEventListener("change", this.onChangeHandler.bind(this)), this.handleRecipientField();
    }
    handleRecipientField() {
        this.i_want_input.addEventListener("click", () => {
            this.i_want_input.checked
                ? this.toggle_recipient_form_fields.classList.remove("d-none")
                : this.toggle_recipient_form_fields.classList.add("d-none");
        });
    }
    clearErrorMessage() {
        this.querySelectorAll(".js-gift-card-recipient-form-error").forEach((t) => {
            t.classList.add("hidden");
            t = t.querySelector(".error-message");
            t && (t.innerText = "");
        }),
            [this.email_input, this.name_input, this.message_input, this.send_on_input].forEach((t) => {
                t.setAttribute("aria-invalid", !1),
                    t.removeAttribute("aria-describedby"),
                    t.removeAttribute("tabindex");
            });
    }
    clearInputFields() {
        (this.email_input.value = ""),
            (this.name_input.value = ""),
            (this.message_input.value = ""),
            (this.send_on_input.value = "");
    }
    handleErrorMessage(t, e) {
        Object.entries(t).forEach(([t, e]) => {
            var s = this.querySelector(`.js-gift-card-recipient-form-${t}-error`),
                i = `RecipientForm-${t}-error-` + this.dataset.sectionId,
                t = this.querySelector(".js-gift-card-recipient-form-" + t);
            (s.querySelector(".error-message").innerText = e),
                s.classList.remove("hidden"),
                t.setAttribute("aria-invalid", !0),
                t.setAttribute("aria-describedby", i),
                t.focus();
        });
    }
    resetRecipientForm() {
        this.i_want_input.checked &&
            ((this.i_want_input.checked = !1), this.clearInputFields(), this.clearErrorMessage());
    }
}
customElements.define("sht-gift-card-recipient-form", SHTGiftCardRecipientForm);
class SHTProductRecommendations extends SHTCustomComponent {
    constructor() {
        super();
        new IntersectionObserver(
            ((t, e) => {
                t[0].isIntersecting &&
                    (e.unobserve(this),
                    fetch(this.dataset.url)
                        .then((t) => t.text())
                        .then((t) => {
                            var e = document.createElement("div"),
                                t = ((e.innerHTML = t), e.querySelector("sht-prd-recom"));
                            t &&
                                t.innerHTML.trim().length &&
                                ((this.innerHTML = t.innerHTML), this.executeScriptElements(this));
                        })
                        .catch((t) => {
                            console.error(t);
                        }));
            }).bind(this)
        ).observe(this);
    }
    executeScriptElements(t) {
        t = t.querySelectorAll("script");
        Array.from(t).forEach((t) => {
            const e = document.createElement("script");
            Array.from(t.attributes).forEach((t) => {
                e.setAttribute(t.name, t.value);
            }),
                e.appendChild(document.createTextNode(t.innerHTML)),
                t.parentNode.replaceChild(e, t);
        });
    }
}
customElements.define("sht-prd-recom", SHTProductRecommendations);
class SHTProgressLinear extends SHTCustomComponent {
    constructor() {
        super(), (this.progress = this.$(".js-progress")), (this.animationDone = !1);
    }
    connectedCallback() {
        this.initObserver();
    }
    initObserver() {
        (this.progressValue = this.progress.getAttribute("data-progress")),
            new IntersectionObserver(
                (t) => {
                    t.forEach((t) => {
                        t.isIntersecting &&
                            !this.animationDone &&
                            requestAnimationFrame(() => {
                                this.progress.style.width = this.progressValue + "%";
                            });
                    });
                },
                { threshold: 0.5 }
            ).observe(this.progress);
    }
}
customElements.define("sht-progress-linear", SHTProgressLinear);
class SHTProgressCircular extends SHTCustomComponent {
    constructor() {
        super(), (this.progress = this.$(".js-progress")), (this.animationDone = !1);
    }
    connectedCallback() {
        this.initObserver();
    }
    initObserver() {
        (this.progressValue = this.progress.getAttribute("data-progress")),
            (this.circularProgress = this.$(".js-circular-progress"));
        var t = 2 * Math.PI * 30;
        const e = t - (this.progressValue / 100) * t;
        new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting &&
                        !this.animationDone &&
                        requestAnimationFrame(() => {
                            this.circularProgress.style.strokeDashoffset = e;
                        });
                });
            },
            { threshold: 0.5 }
        ).observe(this);
    }
}
customElements.define("sht-progress-circular", SHTProgressCircular);
class SHTVariantSelector extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.container = this.closest(".js-product-container")),
            (this.quickView = this.closest(".js-quick-view-block")),
            (this.selectors = {
                price: ".js-product-price",
                inventory: ".js-inventory-tracking",
                variantPicker: ".js-variant-picker",
                qtyContainer: ".js-product-quantity-container",
                qtyInput: ".js-product-quantity",
                sku: ".js-product-sku",
                slideshow: `sht-prd-slideshow[data-section="${this.dataset.section}"]`,
            }),
            (this.elms = {
                radios: this.$$(".js-variant-radio-item"),
                radioContainers: this.$$(".js-variant-radio-container"),
                form: this.container.querySelector(".js-product-form"),
                installmentForm: SHTHelper.qs("#productFormInstallment-" + this.dataset.section),
                productForm: this.container.querySelector(".js-sht-product-form"),
                price: this.container.querySelector(this.selectors.price),
                inventory: this.container.querySelector(this.selectors.inventory),
                variantPicker: this.container.querySelector(this.selectors.variantPicker),
                qtyContainer: this.container.querySelector(this.selectors.qtyContainer),
                qtyInput: this.container.querySelector(this.selectors.qtyInput),
                slideshow: SHTHelper.qs(this.selectors.slideshow),
                thumbCarousel: SHTHelper.qs(`sht-slideshow-carousel[data-section="${this.dataset.section}"]`),
                stickyInfo: SHTHelper.qs("#productStickyInfo-" + this.dataset.section),
                carousel: SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`),
                variantOptions: this.$$(".js-variant-option-value"),
                sku: this.container.querySelector(this.selectors.sku),
            }),
            (this.variantData = this.setSelectedVariants(this)),
            this.updateProductStickyInfo(this.variantData),
            this.updateSelectedVariants(this.variantData),
            this.bindEvents();
    }
    bindEvents() {
        this.addEventListener("change", () => this.onVariantChangeHandle());
    }
    onVariantChangeHandle() {
        this.toggleAddButton(!0), this.removeErrorMessage(), this.renderProductInfo();
    }
    async renderProductInfo() {
        var t = this.dataset.url,
            e = this.getSelectedVariantValue(),
            t = this.buildRequestUrlWithParams(t, e);
        try {
            var s = await fetch(t);
            if (!s.ok) throw new Error("Network response was not ok");
            var i = await s.text(),
                r = new DOMParser().parseFromString(i, "text/html"),
                a = this.setSelectedVariants(r);
            if (!(this.disabledSubmitBtn = a)) return this.setUnavailable();
            this.updateUI(r, a);
        } catch (t) {
            console.error("Error fetching product info:", t), this.setUnavailable();
        }
    }
    updateUI(t, e) {
        this.updatePickupAvailability(e),
            this.checkInventory(t),
            this.updateVariantInput(e),
            this.updateOptionValues(t),
            this.closest(".js-quick-buy-block") ||
                this.quickView ||
                this.closest(".js-bundle-product") ||
                this.updateURL(e),
            this.setActiveMedia(e),
            this.updatePrice(t),
            this.updateSku(t),
            this.updateQuantity(t),
            this.updateProductStickyInfo(e),
            this.updateSelectOptions(t, e),
            this.updateSlideshow(t),
            this.updateAddToCartState(t, e);
    }
    updatePrice(t) {
        t = t.querySelector(this.selectors.price);
        t &&
            this.elms.price &&
            ((this.elms.price.innerHTML = t.innerHTML), this.elms.price.classList.remove("d-none-important"));
    }
    updateSku(t) {
        t = t.querySelector(this.selectors.sku);
        this.elms.sku && (this.elms.sku.innerHTML = t?.innerHTML ?? "");
    }
    updateQuantity(t) {
        var e = this.elms.qtyContainer?.querySelector(".js-max-quantity-message"),
            s = t.querySelector(this.selectors.qtyContainer)?.querySelector(".js-max-quantity-message"),
            e =
                (e && (e.classList.add("d-none-important"), (e.innerHTML = s?.innerHTML ?? "")),
                t.querySelector(this.selectors.qtyInput));
        this.elms.qtyInput && (this.elms.qtyInput.innerHTML = e?.innerHTML ?? "");
    }
    updateSelectOptions(t, e) {
        t = t.querySelectorAll("sht-select .js-variant-select-item");
        const s = this.querySelectorAll("sht-select .js-variant-select-item");
        t.forEach((t, e) => {
            s[e] && (s[e].innerHTML = t.innerHTML);
        }),
            this.updateSelectedVariants(e);
    }
    updateSelectedVariants(t) {
        t?.options &&
            t.options.forEach((t, e) => {
                var s,
                    i,
                    e = (t + "-" + e).replace(/"/g, '\\"'),
                    e = this.$(`.js-variant-item[data-variant-value="${e}"]`);
                e &&
                    ((s = e.getAttribute("data-variant-name") || e.getAttribute("name")),
                    (e = e.dataset.optionVariantValue),
                    s) &&
                    ((i = this.$(`.js-variant-radio-option-name[data-option-name="${s.replace(/"/g, '\\"')}"]`)) &&
                        (i.innerHTML = t),
                    (i = this.$(`.js-variant-select-option-name[data-option-name="${s.replace(/"/g, '\\"')}"]`))) &&
                    (i.innerHTML = e || t);
            });
    }
    updateSlideshow(t) {
        "false" === this.elms.slideshow?.hide_variant &&
            (t = t.querySelector(this.selectors.slideshow)) &&
            this.elms.slideshow &&
            ((this.elms.slideshow.innerHTML = t.innerHTML), this.elms.slideshow.bindEventHandlers());
    }
    updateAddToCartState(t, e) {
        t =
            t.querySelector(".js-product-form-submit-btn")?.dataset.preOrder ??
            this.container.querySelector(".js-product-form-submit-btn")?.dataset.preOrder;
        this.toggleAddButton(!e.available, SHTLanguage.product.PRODUCT_SOLD_OUT, !0, t),
            this.toggleAddButtonSticky(!e.available, SHTLanguage.product.PRODUCT_SOLD_OUT, !0, t);
    }
    updateProductStickyInfo(t) {
        var e, s, i;
        this.elms.stickyInfo &&
            (((e = this.elms.stickyInfo).querySelector(".js-product-sticky-info-variant").innerHTML = t?.title ?? ""),
            this.elms.price && (e.querySelector(".js-product-sticky-info-price").innerHTML = this.elms.price.innerHTML),
            t?.featured_media &&
                ((i = t.featured_media.id),
                (s = e.querySelector(".js-product-sticky-info-media")),
                (i = this.elms.slideshow?.querySelector(
                    `sht-carousel-itm[data-media-id="${this.dataset.section}-${i}"] .js-media-wrapper .media`
                )),
                s) &&
                i &&
                ((s.innerHTML = ""), s.appendChild(i.cloneNode(!0))),
            (e.querySelector(".js-quantity-input").value = 1),
            (e.querySelector('[name="id"]').value = t?.id ?? ""));
    }
    removeErrorMessage() {
        this.elms.productForm instanceof SHTGiftCardRecipientForm && this.elms.productForm.handleErrorMessage();
    }
    updatePickupAvailability(e) {
        const s = this.getAttribute("data-section");
        SHTHelper.qsa("sht-pickup-avail[data-section]").forEach((t) => {
            t.dataset.section === s &&
                (console.log(t.dataset.section, s),
                e
                    ? t.fetchAvailability(e.id)
                    : (t.removeAttribute("available"),
                      t.classList.remove("d-block"),
                      t.classList.add("d-none"),
                      (t.innerHTML = "")));
        });
    }
    checkInventory(t) {
        var e = this.elms.inventory,
            t = t.querySelector(this.selectors.inventory);
        e && (e.innerHTML = t?.innerHTML ?? "");
    }
    updateOptionValues(t) {
        var t = t.querySelector(this.selectors.variantPicker),
            e = this.elms.variantPicker;
        t && e && (e.innerHTML = t.innerHTML);
    }
    updateVariantInput(e) {
        var t;
        e &&
            ((t = [this.elms.form, this.elms.installmentForm]),
            SHTHelper.qs(".js-inventory-tracking")?.classList.remove("d-none"),
            t.forEach((t) => {
                t &&
                    (t = t.querySelector('input[name="id"]')) &&
                    ((t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 })));
            }));
    }
    updateURL(t) {
        t &&
            "false" !== this.dataset.updateUrl &&
            window.history.replaceState({}, "", this.dataset.url + "?variant=" + t.id);
    }
    setActiveMedia(t) {
        var e;
        t?.featured_media &&
            this.elms.slideshow &&
            ((t = t.featured_media.id),
            (e = this.elms.slideshow?.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${t}"]`)),
            (t = this.elms.slideshow?.querySelector(
                `sht-slideshow-carousel-itm[data-media-target-id="${this.dataset.section}-${t}"]`
            )),
            window.matchMedia("(max-width: 1024px)").matches
                ? (this.elms.carousel
                      ?.querySelector(".js-carousel-items")
                      .scrollTo({ left: e.offsetLeft, behavior: "smooth" }),
                  t &&
                      (this.elms.slideshow?.querySelectorAll("sht-slideshow-carousel-itm").forEach((t) => {
                          t.classList.remove("is-active-item");
                      }),
                      t.classList.add("is-active-item"),
                      this.elms.thumbCarousel
                          ?.querySelector(".js-carousel-items")
                          .scrollTo({ left: t.offsetLeft, behavior: "auto" })))
                : (this.elms.slideshow?.querySelectorAll(".js-product-slideshow-item").forEach((t) => {
                      t.classList.remove("d-block"),
                          "true" == this.elms.slideshow.hide_variant && t.classList.add("d-none");
                  }),
                  this.elms.slideshow?.querySelectorAll(".js-product-slideshow-thumb").forEach((t) => {
                      t.classList.remove("is-active-item");
                  }),
                  e?.classList.add("d-block"),
                  "true" == this.elms.slideshow?.hide_variant && e?.classList.remove("d-none"),
                  "carousel" == this.elms.thumbCarousel?.getAttribute("data-layout") &&
                      this.elms.carousel
                          .querySelector(".js-carousel-items")
                          .scrollTo({ left: e.offsetLeft, behavior: "smooth" }),
                  t &&
                      (this.elms.slideshow?.querySelectorAll("sht-slideshow-carousel-itm").forEach((t) => {
                          t.classList.remove("is-active-item");
                      }),
                      t.classList.add("is-active-item"),
                      "carousel-vertical" == this.elms.thumbCarousel?.getAttribute("data-layout")
                          ? this.elms.thumbCarousel
                                .querySelector(".js-carousel-items")
                                .scrollTo({ top: t.offsetTop, behavior: "auto" })
                          : this.elms.thumbCarousel
                                ?.querySelector(".js-carousel-items")
                                .scrollTo({ left: t.offsetLeft, behavior: "auto" }))),
            this.elms.slideshow?.pauseAllVideo());
    }
    pauseAllVideo() {
        SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube'])").forEach((t) => {
            t.player?.pauseVideo();
        }),
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                t.playerVimeo?.pause();
            }),
            SHTHelper.qsa(".js-media-item-video").forEach((t) => t.pause());
    }
    setUnavailable() {
        var t = this.elms.form;
        t &&
            ((t = t.querySelector(".js-product-form-submit-btn")?.querySelector(".js-product-form-submit-btn-text")),
            SHTHelper.qs(".js-inventory-tracking")?.classList.add("d-none"),
            t && (t.textContent = SHTLanguage.product.PRODUCT_UNAVAILABLE),
            this.elms.price?.classList.add("d-none-important"));
    }
    toggleAddButton(t = !0, e, s, i = !1) {
        var r = this.elms.form?.querySelector(".js-product-form-submit-btn"),
            a = r?.querySelector(".js-product-form-submit-btn-text");
        r &&
            (t
                ? (r.setAttribute("disabled", "disabled"), e && (a.textContent = e))
                : (r.removeAttribute("disabled"),
                  (a.textContent =
                      "true" === i ? SHTLanguage.product.PRODUCT_PRE_ORDER : SHTLanguage.product.PRODUCT_ADD_TO_CART)));
    }
    toggleAddButtonSticky(t = !0, e, s, i = !1) {
        var r = SHTHelper.qs("#productStickyForm-" + this.dataset.section)?.querySelector(
                ".js-product-form-submit-btn"
            ),
            a = r?.querySelector(".js-product-form-submit-btn-text");
        r &&
            (t
                ? (r.setAttribute("disabled", "disabled"), e && (a.textContent = e))
                : (r.removeAttribute("disabled"),
                  (a.textContent =
                      "true" === i ? SHTLanguage.product.PRODUCT_PRE_ORDER : SHTLanguage.product.PRODUCT_ADD_TO_CART)));
    }
    setSelectedVariants(t) {
        return JSON.parse(t.querySelector('[data-selected-variant][type="application/json"]').textContent);
    }
    getSelectedVariantValue() {
        return Array.from(this.querySelectorAll(".js-variant-item:checked")).map((t) => t.dataset.optionValueId);
    }
    buildRequestUrlWithParams(t, e) {
        var s = new URLSearchParams({ section_id: this.dataset.section });
        return e.length && s.append("option_values", e.join(",")), t + "?" + s.toString();
    }
}
class SHTVariantRadios extends SHTVariantSelector {
    constructor() {
        super(), (this.select_type = "button");
    }
}
customElements.define("sht-variant-radios", SHTVariantRadios);
class SHTVariantSelects extends SHTVariantSelector {
    constructor() {
        super(), (this.select_type = "dropdown");
    }
}
customElements.define("sht-variant-selects", SHTVariantSelects);
class SHTVariantSwatchSelect extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.radios = this.$$(".js-variant-radio-item")),
            (this.select_id = this.dataset.selectId),
            (this.select_element = document.querySelector("#" + this.select_id)),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.radios.forEach((t) => {
            t.addEventListener("click", (t) => {
                t.preventDefault(),
                    Array.from(this.radios, (t) => {
                        t.checked = !1;
                    }),
                    setTimeout(() => {
                        t.target.checked = !0;
                    }),
                    this.select_element &&
                        ((this.select_element.querySelector(
                            `option[value="${t.target.dataset.optionValue.replace(/"/g, '\\"')}"]`
                        ).selected = !0),
                        this.select_element.dispatchEvent(new Event("change", { bubbles: !0 })));
            });
        });
    }
    connectedCallback() {
        this.init();
    }
}
customElements.define("sht-variant-swatch-select", SHTVariantSwatchSelect);
class SHTProductForm extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.elms = {
            form: this.$("form"),
            submit_btn: this.$('[type="submit"]'),
            error_wrapper: this.$(".js-product-form-error-wrapper"),
            error_message: this.$(".js-product-form-error-message"),
            spinner: this.$(".js-product-form-spinner"),
            quantity_input_container: this.closest(".js-product-container")?.querySelector(".js-product-quantity"),
            submit_btn_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-submit-btn"),
            error_wrapper_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-wrapper"),
            error_message_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-message"),
            spinner_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-spinner"),
            sticky_header: SHTHelper.qs("sht-sticky-header"),
            header: SHTHelper.qs("sht-header"),
            announcement_bar: SHTHelper.qs("sht-ann-bar"),
            header_cart_status: SHTHelper.qs("#headerCartStatus"),
            main_product_form: this.$(".js-main-product-form"),
        }),
            (this.cartNotiType = document.body.getAttribute("data-cart-noti-type")),
            (this.cartType = document.body.getAttribute("data-cart-type")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.quickViewDialog = SHTHelper.qs("sht-dialog-quickview")),
            (this.quickBuyDialog = SHTHelper.qs("sht-dialog-quick-buy")),
            (this.quickAddForm = "true" === this.getAttribute("data-quick-add-form")),
            (this.cartDrawer = SHTHelper.qs("sht-cart-drwr")),
            (this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm")),
            (this.mainCartForm = SHTHelper.qs("sht-cart-frm")),
            (this.cardRecipientForm = SHTHelper.qs("sht-gift-card-recipient-form")),
            (this.interactionPopup = SHTHelper.qs("sht-interaction-popup")),
            (this.giftCardForm = SHTHelper.qs(".js-gift-card-recipient-fields")),
            this.elms.form && ((this.elms.form.querySelector("[name=id]").disabled = !1), this.bindEventHandlers());
    }
    connectedCallback() {
        this.init();
    }
    bindEventHandlers() {
        this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }
    onSubmitHandler(s) {
        if ((s.preventDefault(), !this.elms.submit_btn.classList.contains("loading"))) {
            this.quickAddForm || this.hideErrorMessage(),
                this.toggleSubmitButtons(!1),
                this.elms.spinner?.classList.remove("hidden"),
                this.elms.spinner_sticky && this.elms.spinner_sticky.classList.remove("hidden"),
                this.elms.header_cart_status &&
                    this.elms.header_cart_status.classList.remove("header-cart-status--animate");
            let t = [],
                i =
                    (this.cartNotification && (t = this.cartNotification.getSectionsToRender()),
                    this.cartDrawer && (t = [...t, ...this.cartDrawer.getSectionsToRender()]),
                    this.mainCartForm && (t = [...t, ...this.mainCartForm.getSectionsToRender(!1)]),
                    new FormData(this.elms.form)),
                e = void 0 !== s.submitter ? this.elms.submit_btn : this.elms.submit_btn_sticky;
            var r = this.closest(".js-product-container")?.querySelectorAll(".js-customization-code-type");
            r &&
                r.forEach((t) => {
                    var e = t.querySelector(".js-customization-code-input"),
                        s = t.querySelector(".js-customization-code-label").textContent,
                        t =
                            "text" === t.dataset.customizationCodeType
                                ? e.value
                                : e.checked
                                  ? e.dataset.selectedValue
                                  : null;
                    t && i.append(`properties[${s}]`, t);
                }),
                t.length &&
                    i.append(
                        "sections",
                        t.map((t) => t.id)
                    ),
                i.append("sections_url", window.location.pathname),
                (SHTHelper.fetchConfigHTTP.body = i),
                fetch("" + routes.cart_add_url, SHTHelper.fetchConfigHTTP)
                    .then((t) => t.json())
                    .then((t) => {
                        if (t.status)
                            this.handleQuickAddErrorMessage(s.target, !0),
                                this.handleErrorMessage(t.description, t?.message);
                        else {
                            switch (
                                (t.id || (t.id = i.get("id")),
                                this.elms.sticky_header &&
                                    this.elms.sticky_header.dataset.isEnabled &&
                                    this.elms.sticky_header.reveal(),
                                this.cartNotiType)
                            ) {
                                case "popover_notification":
                                    this.handlePopoverNotification(t, e);
                                    break;
                                case "cart_noti":
                                    this.handleCartNotification(t, e);
                                    break;
                                case "do_nothing":
                                    this.handleDoNothingNotification(t, e);
                            }
                            this.interactionPopup && this.interactionPopup.handleShowPopupAddToCart(),
                                this.elms.quantity_input_container &&
                                    "add-to-cart" == this.elms.quantity_input_container.dataset.show &&
                                    (this.elms.quantity_input_container.classList.remove("d-none"),
                                    (this.elms.quantity_input_container.querySelector("input").value = 1)),
                                this.cardRecipientForm &&
                                    (this.cardRecipientForm.resetRecipientForm(),
                                    this.giftCardForm.classList.add("d-none"));
                        }
                    })
                    .catch((t) => {
                        console.error(t);
                    })
                    .finally(() => {
                        this.toggleSubmitButtons(!0),
                            this.elms.submit_btn_sticky &&
                                (this.elms.submit_btn_sticky.classList.remove("loading"),
                                this.elms.submit_btn_sticky.removeAttribute("aria-disabled"),
                                this.elms.submit_btn_sticky.removeAttribute("disabled")),
                            this.elms.spinner?.classList.add("hidden"),
                            this.elms.spinner_sticky && this.elms.spinner_sticky.classList.add("hidden");
                    });
        }
    }
    handleQuickAddErrorMessage(t, e) {
        t = t.closest(".js-product-card-block")?.querySelector(".js-quick-buy-error-message");
        e
            ? t?.classList.remove("d-none-important")
            : t?.classList.contains("d-none-important") || t?.classList.add("d-none-important");
    }
    toggleSubmitButtons(t = !0) {
        var e = !t;
        this.elms.submit_btn.classList[t ? "remove" : "add"]("loading"),
            this.elms.submit_btn.setAttribute("aria-disabled", e),
            t ? this.elms.submit_btn.removeAttribute("disabled") : this.elms.submit_btn.setAttribute("disabled", !0);
    }
    handlePopoverNotification(t, e) {
        this.quickViewDialog &&
            !this.quickViewDialog.hasAttribute("hidden") &&
            (this.quickViewDialog.closeModal(), (e = this.quickViewDialog.opener)),
            this.quickBuyDialog &&
                !this.quickBuyDialog.hasAttribute("hidden") &&
                (this.quickBuyDialog.closeModal(), (e = this.quickBuyDialog.opener));
        var s = this.quickAddForm ? 1 : this.elms.quantity_input_container.querySelector("input").value;
        this.cartNotification?.renderContents(t, !0, e, s), this.cartDrawerForm?.renderContents(t);
    }
    handleCartNotification(t, e) {
        "drawer" === this.cartType
            ? (this.cartNotification?.renderContents(t, !1),
              this.cartDrawerForm?.renderContents(t),
              this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage(),
              this.closeDialogAndOpenDrawer(this.quickViewDialog) ||
                  this.closeDialogAndOpenDrawer(this.quickBuyDialog) ||
                  this.cartDrawer?.openDrawer(e))
            : "page" === this.cartType &&
              (this.cartNotification?.renderContents(t, !1), window.location.assign(window.routes.cart_url));
    }
    handleDoNothingNotification(t, e) {
        this.cartNotification?.renderContents(t, !1, e),
            this.cartDrawerForm?.renderContents(t),
            this.quickViewDialog && !this.quickViewDialog.hasAttribute("hidden") && this.quickViewDialog.closeModal(),
            this.quickBuyDialog && !this.quickBuyDialog.hasAttribute("hidden") && this.quickBuyDialog.closeModal();
    }
    closeDialogAndOpenDrawer(t) {
        return !(
            !t ||
            t.hasAttribute("hidden") ||
            (t.closeModal(), t.animationsComplete().then(() => this.cartDrawer.openDrawer(t.opener)), 0)
        );
    }
    hideErrorMessage() {
        this.elms.error_wrapper.toggleAttribute("hidden", !0),
            this.elms.error_wrapper_sticky &&
                this.elms.error_message_sticky &&
                this.elms.error_wrapper_sticky.toggleAttribute("hidden", !0);
    }
    handleErrorMessage(t = !1, e = "") {
        t &&
            (SHTHelper.qsa(".js-max-quantity-message").forEach((t) => t.classList.add("d-none-important")),
            "string" == typeof t &&
                (this.elms.error_wrapper &&
                    this.elms.error_message &&
                    (this.elms.error_wrapper?.toggleAttribute("hidden", !t), (this.elms.error_message.textContent = t)),
                this.elms.main_product_form) &&
                this.elms.error_wrapper_sticky &&
                this.elms.error_message_sticky &&
                (this.elms.error_wrapper_sticky.toggleAttribute("hidden", !t),
                (this.elms.error_message_sticky.textContent = t)),
            this.cardRecipientForm) &&
            "object" == typeof t &&
            this.cardRecipientForm.handleErrorMessage(t, e);
    }
    checkCartDrawerState() {
        document.addEventListener("DOMContentLoaded", () => {
            this.cartDrawer || !0 === Shopify.designMode
                ? this.cartDrawer.setAttribute("data-state", "visible")
                : this.cartDrawer.setAttribute("data-state", "hidden");
        });
    }
}
customElements.define("sht-prd-frm", SHTProductForm);
class SHTProductMediaItemDeferredVideo extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.itemDeferredVideoImageElem = this.$(".js-product-media-item-deferred-video-image")),
            (this.idVideo = this.dataset.idVideo),
            (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
            (this.typeVideo = this.$(".js-media-item")?.dataset.type),
            (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
            (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
            this.itemDeferredVideoImageElem &&
                this.itemDeferredVideoImageElem.addEventListener("click", this.handlePlayVideo.bind(this));
    }
    handlePlayVideo() {
        this.loadContent();
        const t = this.querySelector(".js-media-item-video");
        t &&
            t.addEventListener("play", () => {
                this.pauseAllVideo(t), t.play();
            });
    }
    onYouTubeIframeAPIReady(t) {
        var e, s;
        if (
            ((this.youtubeId = this.eleVideo),
            1 == t && (this.youtubeId = this.eleVideo + "-videoInZoomModal"),
            "undefined" == typeof YT || void 0 === YT.Player || this.player)
        )
            this.player ||
                (((e = document.createElement("script")).src = "https://www.youtube.com/iframe_api"),
                (e.id = "sht-iframe-api"),
                (e.onload = () => {
                    this.onYouTubeIframeAPIReady(t);
                }),
                (s = document.getElementsByTagName("script")[0]).parentNode.insertBefore(e, s));
        else
            try {
                this.player = new YT.Player(this.youtubeId, {
                    videoId: this.idVideo,
                    playerVars: { playsinline: 1 },
                    events: { onReady: this.onPlayerYTReady, onStateChange: this.onPlayerStateYTChange },
                });
            } catch (t) {
                console.error("Error when creating YouTube player:", t);
            }
    }
    onVimeoIframeAPIReady(t) {
        if (
            ((this.vimeoId = this.eleVideo),
            1 == t && (this.vimeoId = this.eleVideo + "-videoInZoomModal"),
            "undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
        )
            try {
                var e = { id: this.idVideo, autoplay: 1 };
                (this.playerVimeo = new Vimeo.Player(this.vimeoId, e)),
                    this.playerVimeo.on("play", () => {
                        this.pauseAllVideo(this.playerVimeo);
                    });
            } catch (t) {
                console.error("Error when creating Vimeo player:", t);
            }
        else {
            var e = document.createElement("script"),
                s =
                    ((e.src = "https://player.vimeo.com/api/player.js"),
                    (e.onload = () => {
                        this.onVimeoIframeAPIReady(t);
                    }),
                    document.getElementsByTagName("script")[0]);
            s.parentNode.insertBefore(e, s);
        }
    }
    onPlayerYTReady = () => {
        this.player.playVideo();
    };
    onPlayerStateYTChange = (t) => {
        1 == t.data && this.onPlayerPlay();
    };
    onPlayerPlay = () => {
        this.pauseAllVideo(this.player);
    };
    loadContent(t) {
        var e;
        if (!this.getAttribute("loaded"))
            return (
                this.$("template")
                    ? ((e = this.$("template").content.firstElementChild.cloneNode(!0)),
                      this.appendChild(e),
                      this.isLoaded(!0),
                      this.itemDeferredVideoImageElem && this.itemDeferredVideoImageElem.remove())
                    : (this.itemDeferredVideoImageElem?.classList.add("d-none"),
                      this.$(".js-media-item").classList.add("d-flex"),
                      "youtube" == this.typeVideo ? this.onYouTubeIframeAPIReady(t) : this.onVimeoIframeAPIReady(t)),
                !0
            );
    }
    pauseAllVideo(e) {
        SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach((t) => {
            t.player && e !== t.player && t.player?.pauseVideo();
        }),
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                t.playerVimeo !== e && t.playerVimeo?.pause();
            }),
            SHTHelper.qsa(".js-media-item-video").forEach((t) => {
                t !== e && t.pause();
            });
    }
    isLoaded(t) {
        t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
    }
}
customElements.define("sht-prd-media-itm-deferred-video", SHTProductMediaItemDeferredVideo);
class SHTProductMediaItemModel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.btnIcon3d = this.parentElement.querySelector(".js-btn-icon-3d")),
            (this.itemModelImageElem = this.$(".js-product-media-item-model-image")),
            [this.itemModelImageElem, this.btnIcon3d]?.forEach((t) => {
                t?.addEventListener("click", () => {
                    this.pauseAllMedia(), this.loadContent();
                });
            });
    }
    pauseAllMedia() {
        SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach((t) => {
            t.player?.pauseVideo();
        }),
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                t.playerVimeo?.pause();
            }),
            SHTHelper.qsa(".js-media-item-video").forEach((t) => {
                t.pause();
            }),
            SHTHelper.qsa("sht-prd-media-itm-model").forEach((t) => {
                t.modelViewerUI && t.modelViewerUI.pause();
            });
    }
    loadModelViewerUICss() {
        var t;
        SHTHelper.qs("#model-viewer-ui") ||
            ((t = document.createElement("link")).setAttribute(
                "href",
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
            ),
            t.setAttribute("rel", "stylesheet"),
            t.setAttribute("media", "all"),
            t.setAttribute("id", "model-viewer-ui"),
            document.getElementsByTagName("head")[0].appendChild(t));
    }
    loadContent() {
        var t;
        this.btnIcon3d?.classList.add("d-none-important"),
            this.getAttribute("loaded") ||
                ((t = document.createElement("div")).appendChild(
                    this.$("template").content.firstElementChild.cloneNode(!0)
                ),
                this.setAttribute("loaded", !0),
                this.itemModelImageElem && this.itemModelImageElem.remove(),
                this.appendChild(t.querySelector("model-viewer")).focus(),
                this.loadModelViewerUICss(),
                Shopify.loadFeatures([
                    { name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) },
                ]));
    }
    setupModelViewerUI(t) {
        t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.$("model-viewer")));
    }
}
customElements.define("sht-prd-media-itm-model", SHTProductMediaItemModel),
    (window.SHTProductMediaItemModel = {
        isMouseenter: !1,
        loadShopifyXR() {
            Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(t) {
            t ||
                (window.ShopifyXR
                    ? (SHTHelper.qsa('[id^="ProductJSON-"]').forEach((t) => {
                          window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
                      }),
                      window.ShopifyXR.setupXRElements())
                    : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()));
        },
    }),
    Shopify.designMode
        ? (SHTHelper.qsa("[data-shopify-xr-hidden]").forEach((t) => t.classList.add("hidden")),
          window.SHTProductMediaItemModel && window.SHTProductMediaItemModel.loadShopifyXR())
        : window.SHTProductMediaItemModel &&
          (window.addEventListener(
              "scroll",
              function (t) {
                  window.SHTProductMediaItemModel.isMouseenter || window.SHTProductMediaItemModel.loadShopifyXR(),
                      (window.SHTProductMediaItemModel.isMouseenter = !0);
              },
              !1
          ),
          ["mouseenter", "touchstart", "mouseover"].forEach(function (t) {
              SHTHelper.qs("body").addEventListener(t, function (t) {
                  window.SHTProductMediaItemModel.isMouseenter || window.SHTProductMediaItemModel.loadShopifyXR(),
                      (window.SHTProductMediaItemModel.isMouseenter = !0);
              });
          })),
    customElements.get("sht-pickup-avail") ||
        customElements.define(
            "sht-pickup-avail",
            class extends HTMLElement {
                constructor() {
                    super(),
                        (this.$ = this.querySelector.bind(this)),
                        (this.errorHtml = this.$("template").content.firstElementChild.cloneNode(!0)),
                        (this.onClickRefreshListHandleEvent = this.onClickRefreshListHandleEvent.bind(this)),
                        (this.sectionId = this.dataset.sectionId),
                        this.fetchAvailability(this.dataset.variantId);
                }
                fetchAvailability(t) {
                    let e = routes.root_url;
                    e.endsWith("/") || (e += "/");
                    t = e + `variants/${t}/?section_id=pickup-availability`;
                    fetch(t)
                        .then((t) => t.text())
                        .then((t) => {
                            t = new DOMParser().parseFromString(t, "text/html").querySelector(".shopify-section");
                            this.renderPreview(t);
                        })
                        .catch((t) => {
                            var e = this.$("button");
                            e && e.removeEventListener("click", this.onClickRefreshListHandleEvent), this.renderError();
                        });
                }
                onClickRefreshListHandleEvent(t) {
                    this.fetchAvailability(this.dataset.variantId);
                }
                renderError() {
                    (this.innerHTML = ""),
                        this.appendChild(this.errorHtml),
                        this.$("button").addEventListener("click", this.onClickRefreshListHandleEvent);
                }
                renderPreview(t) {
                    let e = t.querySelector("#drawerPickupAvailability");
                    e && (e.id = "drawerPickupAvailability-" + this.sectionId);
                    var t = t.querySelector("sht-pickup-avail-prwv");
                    t
                        ? ((this.innerHTML = t.outerHTML),
                          this.setAttribute("available", ""),
                          this.classList.add("d-block"),
                          this.classList.remove("d-none"),
                          "true" == this.dataset.showExpectedPickupTime &&
                              e.classList.add("pickup_availability--show-pickup-time"),
                          document.body.appendChild(e),
                          (t = this.$("button")) &&
                              t.addEventListener("click", (t) => {
                                  e.openDrawer(t.target);
                              }))
                        : ((this.innerHTML = ""),
                          this.removeAttribute("available"),
                          this.classList.remove("d-block"),
                          this.classList.add("d-none"));
                }
            }
        );
class SHTDialog extends SHTDialogCore {
    constructor() {
        super();
    }
}
customElements.define("sht-dialog", SHTDialog);
class SHTDialogEditAddress extends SHTDialogCore {
    constructor() {
        super(),
            setTimeout(() => {
                this.closest(".js-account-addresses").style.transform = "none";
            }, 500);
    }
}
if ((customElements.define("sht-dialog-edit-address", SHTDialogEditAddress), !customElements.get("sht-gallery"))) {
    class Aj extends HTMLElement {
        constructor() {
            super(),
                (this.$ = this.querySelector.bind(this)),
                (this.$$ = this.querySelectorAll.bind(this)),
                (this.dialog = SHTHelper.qs("sht-dialog#" + this.dataset.galleryDialogId)),
                (this.slides = this.$$(".js-gallery-slide")),
                this.$$(".js-gallery-btn-thumb").forEach((t) => {
                    t.addEventListener("click", this.setActiveMedia.bind(this, t));
                }),
                (this.thumbCarousel = this.$("sht-horiz-carousel"));
        }
        init() {
            this.dialog.addEventListener("opening", (e) => {
                try {
                    window.SHTProductMediaItemModel && window.SHTProductMediaItemModel.loadShopifyXR(),
                        this.$$(".js-gallery-thumb").forEach((t) => {
                            if (t.dataset.mediaTargetId == e.detail.opener.dataset.dialogMediaId)
                                throw (
                                    (t.classList.add("is-active-gallery-thumb"),
                                    this.scrollToThumb(t.dataset.mediaTargetId),
                                    "done")
                                );
                        });
                } catch (e) {}
            }),
                this.dialog.addEventListener("closing", (t) => {
                    this.$$(".js-gallery-thumb").forEach((t) => {
                        t.classList.remove("is-active-gallery-thumb");
                    });
                });
        }
        scrollToThumb(t) {
            t = this.thumbCarousel.querySelector(`[data-media-target-id="${t}"]`);
            t &&
                this.thumbCarousel
                    .querySelector(".js-carousel-items")
                    .scrollTo({ left: t.offsetLeft, behavior: "auto" });
        }
        setActiveMedia(t) {
            var e = this.$("sht-gallery-slide.is-active-gallery-slide"),
                e =
                    (e && (e = e.querySelector("sht-zoom")) && e.reset(),
                    this.$(`[data-media-id="${t.dataset.target}"]`)),
                s = e.querySelector("sht-zoom"),
                t = t.closest("sht-horiz-carousel-itm");
            this.$$(".js-gallery-slide").forEach((t) => {
                t.classList.remove("is-active-gallery-slide", "d-flex"), t.classList.add("d-none");
            }),
                this.$$(".js-gallery-thumb").forEach((t) => {
                    t.classList.remove("is-active-gallery-thumb");
                }),
                e.classList.add("is-active-gallery-slide", "d-flex"),
                e.classList.remove("d-none"),
                t.classList.add("is-active-gallery-thumb"),
                this.playActiveVideo(e),
                this.playActiveModel(e),
                s && s.init();
        }
        pauseAllVideo() {
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach((t) => {
                t.player?.pauseVideo();
            }),
                SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                    t.playerVimeo?.pause();
                }),
                SHTHelper.qsa(".js-media-item-video").forEach((t) => {
                    t.pause();
                });
        }
        playActiveVideo(t) {
            this.pauseAllVideo();
            t = t.querySelector(".js-product-media-deferred-video");
            t && t.loadContent(!0);
        }
        playActiveModel(t) {
            t = t.querySelector(".js-product-media-deferred-model");
            t && t.loadContent();
        }
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {}
    }
    customElements.define("sht-gallery", Aj);
}
class SHTHorizontalCarousel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            this.init(),
            this.bindEventHandlers();
    }
    init() {
        (this.itemsToShow = Array.from(this.carousels).filter((t) => 0 < t.clientWidth)),
            this.itemsToShow.length < 2
                ? this.horizontalTogglePagination(!1)
                : (this.horizontalTogglePagination(!0),
                  (this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel());
    }
    horizontalTogglePagination(t) {
        t
            ? (this.paginationElement?.classList.remove("d-none-important"),
              this.paginationElement?.classList.add("d-flex"))
            : (this.paginationElement?.classList.remove("d-flex"),
              this.paginationElement?.classList.add("d-none-important"));
    }
    updateCarousel() {
        var t = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != t &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement.setAttribute("disabled", "disabled")
                : this.prevBtnElement.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement.setAttribute("disabled", "disabled")
                : this.nextBtnElement.removeAttribute("disabled");
    }
    isItemVisible(t, e = 0) {
        e = this.container.clientWidth + this.container.scrollLeft - e + 1;
        return t.offsetLeft + t.clientWidth <= e && t.offsetLeft >= this.container.scrollLeft;
    }
    onButtonClick(t) {
        t.preventDefault();
        let e = 1,
            s = 0;
        window.matchMedia("(min-width: 769px)").matches && (e = t.currentTarget.dataset.step),
            (0 != this.container.scrollLeft && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === t.currentTarget.name
                    ? this.container.scrollLeft - s + e * this.itemOffset
                    : this.container.scrollLeft + s - e * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        new ResizeObserver((t) => this.init()).observe(this.container);
        new IntersectionObserver(
            ((t, e) => {
                t[0].isIntersecting && (this.init(), e.unobserve(this));
            }).bind(this)
        ).observe(this),
            this.prevBtnElement && this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement && this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
    }
}
if ((customElements.define("sht-horiz-carousel", SHTHorizontalCarousel), !customElements.get("sht-gallery-slides"))) {
    class k9 extends HTMLElement {
        constructor() {
            super(),
                (this.$ = this.querySelector.bind(this)),
                (this.$$ = this.querySelectorAll.bind(this)),
                (this.gallery = this.closest("sht-gallery")),
                (this.dialog = SHTHelper.qs("sht-dialog#" + this.gallery.dataset.galleryDialogId)),
                (this.slides = this.$$(".js-gallery-slide")),
                (this.totalSlides = this.slides.length),
                (this.prevBtnElement = this.$(".js-slide-prev-btn")),
                (this.nextBtnElement = this.$(".js-slide-next-btn")),
                (this.currentSlideElement = this.$(".js-slide-current")),
                (this.totalElement = this.$(".js-slide-total")),
                (this.paginationElement = this.$(".js-slide-pagination")),
                (this.currentIndex = 1);
        }
        init() {
            this.dialog.addEventListener("opening", (s) => {
                try {
                    this.slides.forEach((t) => {
                        var e;
                        if (
                            (t.classList.add("d-none"),
                            t.classList.remove("is-active-gallery-slide", "d-flex"),
                            t.dataset.mediaId == s.detail.opener.dataset.dialogMediaId)
                        )
                            throw (
                                (t.classList.remove("d-none"),
                                t.classList.add("is-active-gallery-slide", "d-flex"),
                                (e = t.querySelector("sht-zoom")) && e.init(),
                                (this.currentIndex = t.dataset.itemIndex),
                                "done")
                            );
                    });
                } catch (s) {}
            });
        }
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {}
    }
    customElements.define("sht-gallery-slides", k9);
}
if (!customElements.get("sht-zoom")) {
    class o9 extends HTMLElement {
        constructor() {
            super(),
                (this.$ = this.querySelector.bind(this)),
                (this.$$ = this.querySelectorAll.bind(this)),
                (this.image = this.$(".js-zoom-item")),
                (this.container = SHTHelper.qs("#" + this.dataset.containerId)),
                (this.image_natural_dimension = {}),
                (this.container_dimension = {}),
                (this.rendered_aspect_ratio = {}),
                (this.image_dimension = {}),
                (this.is_able_to_zoom = !0),
                this.bindEventHandlers();
        }
        init() {
            this.getImageDimension(), this.getContainerDimension();
            var t = this.image.src,
                e = this.image.srcset;
            (this.image.scr = t), (this.image.srcset = e);
        }
        ableToZoom() {
            return !(
                this.rendered_aspect_ratio.container <= this.rendered_aspect_ratio.image ||
                (this.image_natural_dimension.width <= this.container_dimension.width &&
                    this.image_natural_dimension.height <= this.container_dimension.height)
            );
        }
        bindEventHandlers() {
            this.image.addEventListener("click", (t) => {
                t.preventDefault(), this.image.hasAttribute("zoomed") ? this.zoomOut() : this.zoomIn();
            });
        }
        zoomIn() {
            var t = window.matchMedia("(max-width: 459px)");
            (this.image.style.height = "auto"),
                (this.image.style.objectFit = "unset"),
                this.image.setAttribute("zoomed", !0),
                (this.image.style.cursor = "zoom-out"),
                t.matches
                    ? ((this.image.style.width = "150%"), (this.image.style.maxWidth = "unset"))
                    : (this.image.style.width = "100%"),
                this.image.offsetHeight <= this.container_dimension.height &&
                    this.classList.add("d-flex", "fd-column", "center-xs"),
                this.container.classList.add("o-scroll"),
                this.container.scrollTo({
                    top: this.container.scrollHeight / 2 - this.container.offsetHeight / 2,
                    behavior: "auto",
                }),
                t.matches &&
                    this.container.scrollTo({
                        left: this.container.scrollWidth / 2 - this.container.offsetWidth / 2,
                        behavior: "auto",
                    });
        }
        zoomOut() {
            (this.image.style.width = "100%"),
                (this.image.style.height = "100%"),
                (this.image.style.objectFit = "contain"),
                this.image.removeAttribute("zoomed"),
                (this.image.style.cursor = "zoom-in"),
                this.classList.remove("d-flex", "fd-column", "center-xs"),
                this.container.classList.remove("o-scroll"),
                (this.image.style.maxWidth = null);
        }
        reset() {
            this.zoomOut();
        }
        calculateRenderedAspectRatio() {
            this.rendered_aspect_ratio = {
                image: this.image_natural_dimension.width / this.image_natural_dimension.height,
                container: this.container_dimension.width / this.container_dimension.height,
            };
        }
        getImageNaturalDimension() {
            this.image_natural_dimension = {
                width: parseInt(this.image.getAttribute("width")),
                height: parseInt(this.image.getAttribute("height")),
            };
        }
        getImageDimension() {
            this.image_dimension = { width: this.image.offsetWidth, height: this.image.offsetHeight };
        }
        getContainerDimension() {
            this.container_dimension = { width: this.container.offsetWidth, height: this.container.offsetHeight };
        }
    }
    customElements.define("sht-zoom", o9);
}
if (!customElements.get("sht-gallery-slide")) {
    class u9 extends HTMLElement {
        constructor() {
            super(),
                (this.$ = this.querySelector.bind(this)),
                (this.$$ = this.querySelectorAll.bind(this)),
                (this.dialog = SHTHelper.qs("sht-dialog#" + this.dataset.galleryDialogId)),
                (this.mediaId = this.dataset.mediaId),
                (this.zoomElement = this.$("sht-zoom"));
        }
        init() {
            this.dialog.addEventListener("closing", (t) => {
                this.classList.add("d-none"),
                    this.classList.remove("is-active-gallery-slide", "d-flex"),
                    this.zoomElement && this.zoomElement.reset(),
                    this.pauseAllVideo();
            });
        }
        pauseAllVideo() {
            SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach((t) => {
                t.player?.pauseVideo();
            }),
                SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach((t) => {
                    t.playerVimeo?.pause();
                }),
                SHTHelper.qsa(".js-media-item-video").forEach((t) => {
                    t.pause();
                });
        }
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {}
    }
    customElements.define("sht-gallery-slide", u9);
}
class SHTDrawerPickup extends SHTCoreDrawer {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.mainDrawer = this.$(".js-drawer-wrapper")),
            (this.mainProduct = SHTHelper.qs(".js-main-product")),
            this.mainProduct &&
                this.mainProduct.dataset.color &&
                this.mainDrawer.classList.add(this.mainProduct.dataset.color);
    }
}
customElements.define("sht-drwr-pickup", SHTDrawerPickup);
class SHTProductRecentlyViewed extends HTMLElement {
    constructor() {
        super(), (this.cookieName = "sht-recently-viewed");
    }
    connectedCallback() {
        this.init();
    }
    init() {
        const e = this.dataset.productId;
        var t,
            s,
            i = this.dataset.productUrl;
        Shopify.designMode ||
            ((t = JSON.parse(window.localStorage.getItem(this.cookieName) || "[]")),
            (i = { id: e, url: i }),
            -1 !== (s = t.findIndex((t) => t.id === e)) && t.splice(s, 1),
            t.unshift(i),
            window.localStorage.setItem(this.cookieName, JSON.stringify(t.slice(0, 10))));
    }
}
customElements.define("sht-product-recently-viewed", SHTProductRecentlyViewed);
class SHTRecentlyViewed extends SHTCarousel {
    static fetchedProducts = null;
    static fetchPromise = null;
    constructor() {
        super(),
            (this.cookieName = "sht-recently-viewed"),
            (this.limitProduct = parseInt(this.dataset.limit)),
            (this.productsArray = this.getArrayFromLocalStorage().slice(0, this.limitProduct)),
            (this.totalItems = parseInt(this.productsArray.length)),
            (this.settings = {
                rowMobile: parseInt(this.dataset.itemPerRowMobile),
                rowDesktop: parseInt(this.dataset.itemPerRowDesktop),
                widthMobile: this.dataset.widthMobile,
                widthDesktop: this.dataset.widthDesktop,
                enableVendor: this.toBoolean(this.dataset.enableVendor),
                enableBadge: this.toBoolean(this.dataset.enableBadge),
                enableQuickView: this.toBoolean(this.dataset.enableQuickView),
                enableVariantSwatches: this.toBoolean(this.dataset.enableVariantSwatches),
                enablePrice: this.toBoolean(this.dataset.enablePrice),
                enableMobile: this.toBoolean(this.dataset.enableMobile),
                enableDesktop: this.toBoolean(this.dataset.enable),
                optionQuickBuy: this.dataset.optionQuickBuy,
                enableRating: this.toBoolean(this.dataset.enableRating),
            }),
            (this.recentlyViewedSections = SHTHelper.qsa(".js-recently-viewed-section")),
            (this.body = this.$(".js-product-recently-viewed")),
            (this.sliderScrollBar = this.$(".js-slider-scrollbar"));
    }
    connectedCallback() {
        super.connectedCallback(), this.checkRecentlyViewedState(), this.processData();
    }
    toBoolean(t) {
        return "true" === t;
    }
    async fetchProductHTML(e) {
        try {
            var t = await (await fetch(e)).text(),
                s = new DOMParser().parseFromString(t, "text/html").querySelector(".section-recently-viewed");
            return window.Shopify?.PaymentButton && Shopify.PaymentButton.init(), s?.innerHTML || null;
        } catch (t) {
            return console.error(`Failed to fetch product from ${e}:`, t), null;
        }
    }
    async fetchAllProducts() {
        var t;
        return this.productsArray.length
            ? ((t = this.productsArray.map((t) => t.url + "?view=show-recently-viewed")),
              Promise.all(t.map((t) => this.fetchProductHTML(t))))
            : [];
    }
    toggleFeatures(s) {
        var t = {
            ".js-rv-vendor": this.settings.enableVendor,
            ".js-rv-badge": this.settings.enableBadge,
            ".js-rv-view": this.settings.enableQuickView,
            ".js-rv-variant": this.settings.enableVariantSwatches,
            ".js-rv-price": this.settings.enablePrice,
            ".js-rv-rating": this.settings.enableRating,
        };
        Object.entries(t).forEach(([t, e]) => {
            t = s.querySelector(t);
            t && t.classList.toggle("d-none-important", !e);
        });
    }
    renderProducts(i) {
        i.length &&
            (i.forEach((t, e) => {
                var s;
                t &&
                    (((s = document.createElement("div")).innerHTML = t),
                    (t = s.firstElementChild),
                    this.toggleFeatures(t),
                    "not_use" == this.settings.optionQuickBuy && t.$(".js-rv-buy")?.classList.add("d-none-important"),
                    t.$(".js-rv-buy")?.setAttribute("data-quick-buy", this.settings.optionQuickBuy),
                    t.setAttribute("aria-label", `Slide ${e + 1} of ` + i.length),
                    (t.dataset.itemIndex = e + 1),
                    t.style.setProperty("--w-xs", this.settings.widthMobile),
                    t.style.setProperty("--w-md", this.settings.widthDesktop),
                    t.classList.toggle("carousel__item-xs", this.settings.enableMobile),
                    t.classList.toggle("carousel__item-md", this.settings.enableDesktop),
                    this.body.appendChild(t));
            }),
            this.executeScriptElements(this.body),
            this.handleCarousel(),
            window.SHTProductMediaItemModel) &&
            window.SHTProductMediaItemModel.loadShopifyXR();
    }
    getArrayFromLocalStorage() {
        return JSON.parse(localStorage.getItem(this.cookieName)) || [];
    }
    removeDataFromLocalStorage() {
        localStorage.removeItem(this.cookieName);
    }
    async processData() {
        if (this.getArrayFromLocalStorage().slice(0, this.limitProduct).length)
            try {
                SHTRecentlyViewed.fetchPromise || (SHTRecentlyViewed.fetchPromise = this.fetchAllProducts()),
                    (SHTRecentlyViewed.fetchedProducts = await SHTRecentlyViewed.fetchPromise),
                    this.renderProducts(SHTRecentlyViewed.fetchedProducts);
            } catch (t) {
                console.error("Error processing recently viewed products:", t);
            }
    }
    handleCarousel() {
        this.carousels = this.body.querySelectorAll(".js-carousel-item");
        var t = this.totalItems;
        this.scrollbarTrack?.style.setProperty("--width-thumb-desktop", (100 * this.settings.rowDesktop) / t + "%"),
            this.scrollbarTrack?.style.setProperty("--width-thumb-tablet", 200 / t + "%"),
            this.scrollbarTrack?.style.setProperty("--width-thumb-mobile", 100 / t + "%"),
            this.toggleScrollBar(this.settings.enableDesktop, this.settings.rowDesktop, t, "d-flex-md", "d-none-md"),
            this.toggleScrollBar(this.settings.enableMobile, this.settings.rowMobile, t, "d-flex", "d-none");
    }
    toggleScrollBar(t, e, s, i, r) {
        this.sliderScrollBar?.classList.toggle(i, t && e < s), this.sliderScrollBar?.classList.toggle(r, !(t && e < s));
    }
    executeScriptElements(t) {
        t = t.querySelectorAll("script");
        Array.from(t).forEach((t) => {
            const e = document.createElement("script");
            Array.from(t.attributes).forEach((t) => {
                e.setAttribute(t.name, t.value);
            }),
                e.appendChild(document.createTextNode(t.innerHTML)),
                t.parentNode.replaceChild(e, t);
        });
    }
    checkRecentlyViewedState() {
        !0 === Shopify.designMode && this.removeDataFromLocalStorage(),
            this.recentlyViewedSections.forEach((t) => {
                t.classList.toggle("d-none-important", !0 === Shopify.designMode || this.totalItems < 1);
            });
    }
}
customElements.define("sht-recently-viewed", SHTRecentlyViewed);
class SHTFreeShippingBar extends SHTCustomComponent {
    constructor() {
        super(),
            (this.total_price = this.dataset.totalPrice),
            (this.threshold = 0),
            (this.original_free_shipping_price = this.dataset.freeShippingOriginalPrice),
            (this.free_shipping_price = this.dataset.freeShippingPrice),
            (this.free_shipping_progress = this.$(".js-free-shipping-progress")),
            (this.free_shipping_progress_content = this.$(".js-free-shipping-progress-content")),
            (this.free_shipping_progress_message = this.$(".js-free-shipping-message")),
            this.init();
    }
    calculateCurrencyRate() {
        this.threshold = Math.round(this.free_shipping_price * (Shopify.currency.rate || 1));
    }
    init() {
        this.calculateCurrencyRate(),
            (this.free_shipping_progress.max = this.threshold),
            (this.free_shipping_progress.value = this.total_price),
            (this.free_shipping_progress_content.innerHTML = SHTHelper.formatMoney(
                this.threshold,
                window.theme_variables.settings.money_with_currency_format
            ));
        var t = this.threshold - this.total_price;
        this.free_shipping_progress_message.innerHTML =
            t <= 0
                ? SHTLanguage.free_shipping_bar.FULFILLED
                : SHTLanguage.free_shipping_bar.UNFULFILLED.replaceAll(
                      "[amount]",
                      SHTHelper.formatMoney(t, window.theme_variables.settings.money_with_currency_format)
                  );
    }
}
customElements.define("sht-free-shipping-bar", SHTFreeShippingBar);
class SHTCartNotificationPanel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.elms = {
                notification_wrapper: this.$(".js-cart-notification-panel-wrapper"),
                close_buttons: this.$$(".js-cart-notification-panel-close-btn"),
                notification_product_quantity: this.$(".js-cart-notification-product-quantity"),
                notification_progress: this.$(".js-cart-notification-progress"),
                notification_message: this.$(".js-cart-notification-message"),
            }),
            (this.dismiss_timeout = null),
            (this.element_to_focus = null),
            (this.previousFocusedElement = null);
        for (let t = 0, e = this.elms.close_buttons.length; t < e; t++)
            this.elms.close_buttons[t].addEventListener("click", this.close.bind(this));
    }
    open() {
        this.dispatchEvent(new Event("opened")),
            this.togglePanel(!0),
            setTimeout(() => {
                SHTHelper.trapFocus(this);
            });
    }
    close() {
        this.clearDismissTimeout(),
            this.togglePanel(!1),
            this.dispatchEvent(new Event("closed")),
            this.element_to_focus
                ? (SHTHelper.removeTrapFocus(this.element_to_focus), (this.element_to_focus = null))
                : SHTHelper.removeTrapFocus();
    }
    clearDismissTimeout() {
        clearTimeout(this.dismiss_timeout);
    }
    renderQuantityContents(t = !0, e, s = null) {
        (this.element_to_focus = s),
            0 < e &&
                ((this.elms.notification_product_quantity.innerHTML = e),
                (this.elms.notification_message.textContent =
                    1 == e ? SHTLanguage.cart_noti.MESSAGE_ONE_ITEM : SHTLanguage.cart_noti.MESSAGE_MULTIPLE_ITEMS),
                this.setDismissTimeout(),
                this.elms.notification_progress.classList.remove("progress"),
                setTimeout(() => {
                    this.elms.notification_progress.classList.add("progress");
                }, 10),
                t) &&
                this.open();
    }
    renderContents(s, t = !0, e = null, i) {
        (this.productId = s.id),
            (this.element_to_focus = e),
            (this.elms.notification_product_quantity.innerHTML = i),
            (this.elms.notification_message.textContent =
                1 == i ? SHTLanguage.cart_noti.MESSAGE_ONE_ITEM : SHTLanguage.cart_noti.MESSAGE_MULTIPLE_ITEMS),
            t && this.setDismissTimeout(),
            this.elms.notification_progress.classList.remove("progress"),
            setTimeout(() => {
                this.elms.notification_progress.classList.add("progress");
            }, 10);
        var r = this.getSectionsToRender();
        for (let t = 0, e = r.length; t < e; t++) {
            var a = SHTHelper.qs(r[t].space_selector);
            a &&
                ("#headerCartStatus" == r[t].space_selector && a.classList.add("header-cart-status--animate"),
                (a.innerHTML = this.getSectionInnerHTML(s.sections[r[t].id], r[t].selector)));
        }
        t && this.open();
    }
    getSectionsToRender() {
        return [{ id: "header-cart-status", section: "header-cart-status", space_selector: "#headerCartStatus" }];
    }
    getSectionInnerHTML(t, e = ".shopify-section") {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML;
    }
    togglePanel(t) {
        t ? (this.classList.add("show"), this.removeAttribute("hidden")) : this.classList.remove("show");
    }
    setDismissTimeout() {
        clearTimeout(this.dismiss_timeout),
            (this.previousFocusedElement = document.activeElement),
            (this.dismiss_timeout = setTimeout(() => {
                this.close(), this.previousFocusedElement && SHTHelper.trapFocus(this.previousFocusedElement);
            }, 3e3));
    }
}
customElements.define("sht-cart-noti", SHTCartNotificationPanel);
class SHTQuantityInputQuickBuy extends SHTQuantityInput {
    constructor() {
        super(),
            (this.deleteBtn = this.container?.querySelector(".js-delete-variant-btn")),
            (this.dialog = this.closest("sht-dialog-quick-buy")),
            (this.previousValue = parseInt(this.input.value)),
            (this.productAddedQuantity = 0),
            (this.container = this.closest(".js-quantity-wrapper")),
            (this.sellingPlanErrorMessage = this.container?.querySelector(".js-selling-plan-error-message")),
            (this.sellingPlan = this.dataset.sellingPlan),
            (this.cartDrawerNumber = SHTHelper.qs(".js-cart-drawer-count-number")),
            (this.cartCountNumber = SHTHelper.qs(".js-cart-count-number")),
            (this.volumePricing = this.closest(".js-variant-bulk-item")?.querySelector("quantity-pricing"));
    }
    connectedCallback() {
        super.connectedCallback(),
            this.updateQuickBuyState(),
            this.input.addEventListener("input", () => {
                this.updateQuickBuyState(), this.showSellingPlanMessage(this.sellingPlan);
            }),
            this.input.addEventListener("blur", this.ensureNonNegativeInput.bind(this));
    }
    updatePriceItem() {
      console.log("here");
        // Get current quantity
        if (this.input) {
          this.inputValue = parseInt(this.input.value, 10);
        }

        console.log('Input Value:', this.inputValue);

        this.currentValue = this.inputValue;

        let matchedPrice = null;

        // Loop through volume pricing rows
        this.volumePricing?.querySelectorAll('li').forEach((item) => {
          const qtyElement = item.querySelector('.js-pricing-item-quantity');
          const priceElement = item.querySelector('.js-pricing-item-price');

          const quantityBreak = parseInt(qtyElement?.textContent, 10);
          const price = priceElement?.textContent;

          console.log('Checking:', {
            quantityBreak,
            price,
            currentValue: this.currentValue
          });

          if (this.currentValue >= quantityBreak) {
            matchedPrice = price;
          }
        });
        const lowestPrice = this.volumePricing
        ?.querySelector('li .js-pricing-item-price')
        ?.textContent;

        console.log('Lowest Price:', lowestPrice);
        console.log('Matched Price:', matchedPrice);

        // Find price element on product row
        const priceItem = this.closest('.js-variant-bulk-item')
        ?.querySelector('.product-bulk-price .price-item');
        const row = this.closest('.js-variant-bulk-item');
        const unit = row?.dataset.unit || '';
        console.log(unit);
        if(this.inputValue == 0){
            priceItem.textContent = lowestPrice + unit;
        }else if(matchedPrice && priceItem) {

          if (priceItem.textContent !== matchedPrice) {
            
              priceItem.textContent = matchedPrice+ unit;
          }
        }
    }
    onButtonClickHandler(t) {
        (this.cartDrawerNumber.innerHTML = this.cartCountNumber.innerHTML),
            super.onButtonClickHandler(t),
            this.updateQuickBuyState(),
            this.showSellingPlanMessage(this.sellingPlan);
        t = new CustomEvent("on:cart-input:change", {
            bubbles: !0,
            composed: !0,
            detail: { element: t.currentTarget, value: this.input.value, previousValue: this.previousValue },
        });
        this.dispatchEvent(t);
    }
    updateQuickBuyState() {
        this.input.value && this.input.value <= 0 && (this.input.value = 0),
            (this.productAddedQuantity = parseInt(this.input.value) - this.previousValue),
            this.deleteBtn?.classList.toggle("d-none-important", !this.input.value || this.input.value <= 0);
    }
    showSellingPlanMessage(t) {
        this.sellingPlanErrorMessage &&
            ("false" == t
                ? this.sellingPlanErrorMessage.classList.contains("d-none-important") ||
                  this.sellingPlanErrorMessage.classList.add("d-none-important")
                : this.sellingPlanErrorMessage.classList.remove("d-none-important"));
    }
    ensureNonNegativeInput() {
        this.input.value || ((this.input.value = 0), this.updateQuickBuyState());
    }
}
customElements.define("sht-qty-inp-quick-buy", SHTQuantityInputQuickBuy);
class SHTCartDrawerCartNote extends SHTCustomComponent {
    constructor() {
        super(),
            this.addEventListener(
                "change",
                SHTHelper.debounce((t) => {
                    t = JSON.stringify({ note: t.target.value });
                    fetch("" + window.routes.cart_update_url, { ...SHTHelper.fetchConfigJSON, body: t });
                }, 300)
            );
    }
}
customElements.define("sht-cart-drwr-note", SHTCartDrawerCartNote);
class SHTCartDrawerQuantityInput extends SHTCustomComponent {
    constructor() {
        super(),
            (this.input = this.$(".js-cart-drawer-quantity-input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            (this.productQuantity = parseInt(this.dataset.productQuantity)),
            (this.cartNumber = SHTHelper.qs(".js-cart-drawer-count")),
            (this.cartDrawerNumber = SHTHelper.qs(".js-cart-drawer-count-number")),
            this.renderCartNumbers(),
            (this.button = this.$$(".js-cart-drawer-quantity-btn")),
            (this.container = this.closest(".js-cart-drawer-quantity")),
            (this.message = this.container?.querySelector(".js-max-quantity-message")),
            (this.volumePricing = this.container?.querySelector("quantity-pricing")),
            (this.quantityMessage = this.container?.querySelector(".js-quantity-pricing-message")),
            (this.minQuantityMessage = this.container?.querySelector(".js-min-quantity-pricing-message")),
            (this.maxQuantityMessage = this.container?.querySelector(".js-max-quantity-pricing-message")),
            (this.stepQuantityMessage = this.container?.querySelector(".js-step-quantity-pricing-message"));
        for (let t = 0, e = this.button.length; t < e; t++)
            this.button[t].addEventListener("click", this.onButtonClickHandler.bind(this));
        this.input.addEventListener("input", this.handleInputChange.bind(this)),
            this.input.addEventListener("change", this.updatePriceItem.bind(this)),
            this.updatePriceItem();
    }
    handleInputChange(t) {
        t.preventDefault();
        t = parseInt(this.input.value) || 0;
        t <= this.productQuantity || Number.isNaN(t) || 0 == t ? this.showMessage(!0) : this.showMessage(!1);
    }
    onButtonClickHandler(t) {
        t.preventDefault();
        var e = parseInt(this.input.value);
        let s;
        (s =
            "plus" === t.currentTarget.dataset.name
                ? parseInt(this.input.value) + 1
                : parseInt(this.input.value) - 1) <= parseInt(this.productQuantity)
            ? ("plus" === t.currentTarget.dataset.name ? this.input.stepUp() : this.input.stepDown(),
              this.showMessage(!0),
              this.toggleAnimation("animated"))
            : (this.showMessage(!1), this.toggleAnimation("error-animated")),
            e !== parseInt(this.input.value) && this.input.dispatchEvent(this.changeEvent),
            this.renderCartNumbers(),
            this.handleQuickOrderListForm();
    }
    validateQuantity(t) {
        var e = parseInt(this.input.min),
            s = parseInt(this.input.max),
            i = parseInt(this.input.step);
        const r = (t, e) => {
            t?.classList.toggle("d-none-important", !e);
        };
        var a = (t, e, s, i) => {
            r(this.quantityMessage, t),
                r(this.minQuantityMessage, e),
                r(this.maxQuantityMessage, s),
                r(this.stepQuantityMessage, i);
        };
        t < e ? a(!0, !0, !1, !1) : s < t ? a(!0, !1, !0, !1) : t % i != 0 ? a(!0, !1, !1, !0) : a(!1, !1, !1, !1);
    }
    toggleAnimation(t) {
        this.input.classList.remove("animated" === t ? "error-animated" : "animated"),
            this.input.classList.contains(t) && this.input.classList.remove(t),
            this.input.offsetWidth,
            this.input.classList.add(t);
    }
    showMessage(t) {
        this.message &&
            (t
                ? (this.message.classList.contains("d-none-important") ||
                      this.message.classList.add("d-none-important"),
                  0 < this.input.value && this.validateQuantity(this.input.value))
                : ([
                      this.quantityMessage,
                      this.minQuantityMessage,
                      this.maxQuantityMessage,
                      this.stepQuantityMessage,
                  ].forEach((t) => {
                      t && !t.classList.contains("d-none-important") && t.classList.add("d-none-important");
                  }),
                  this.message.classList.remove("d-none-important")));
    }
    updatePriceItem() {
        let s = null,
            i = parseInt(this.input.value);
        this.volumePricing?.querySelectorAll("li").forEach((t) => {
            var e = parseInt(t.querySelector(".js-pricing-item-quantity").textContent),
                t = t.querySelector(".js-pricing-item-price")?.textContent;
            i >= e && (s = t);
        });
        var t = this.closest(".js-cart-drawer-item")?.querySelector(".price-item");
        null !== s && t && t.textContent !== s && (t.textContent = s);
    }
    handleQuickOrderListForm() {
        const s = this.closest(".js-cart-drawer-quantity")?.dataset.variantId;
        SHTHelper.qsa(".js-order-list-item").forEach((t) => {
            var e;
            t.dataset.variantId == s &&
                (((t = t.querySelector(".js-quantity-input")).value = this.input.value),
                (e = new Event("change", { bubbles: !0 })),
                t.dispatchEvent(e));
        });
    }
    renderCartNumbers() {
        if (this.cartNumber && this.cartDrawerNumber) {
            let e = 0;
            SHTHelper.qsa(".js-cart-drawer-quantity-input").forEach((t) => {
                e += parseInt(t.value, 10);
            }),
                (this.cartNumber.innerHTML = e),
                (this.cartDrawerNumber.innerHTML = e);
        }
    }
}
customElements.define("sht-cart-drwr-qty-inp", SHTCartDrawerQuantityInput);
class SHTCartDrawerRemoveButton extends SHTCustomComponent {
    constructor() {
        super(),
            this.addEventListener("click", (t) => {
                t.preventDefault(),
                    this.closest("sht-cart-drwr-frm").updateQuantity(this.dataset.index, 0),
                    this.handleQuickOrderListForm();
            });
    }
    handleQuickOrderListForm() {
        const s = this.closest(".js-cart-drawer-quantity")?.dataset.variantId;
        SHTHelper.qsa(".js-order-list-item").forEach((t) => {
            var e;
            t.dataset.variantId == s &&
                ((e = t.querySelector(".js-quantity-input")),
                (t = t.querySelector("sht-remove-btn")),
                (e.value = 0),
                t.classList.add("d-none-important"),
                (t = new Event("change", { bubbles: !0 })),
                e.dispatchEvent(t));
        });
    }
}
customElements.define("sht-cart-drwr-rmv-btn", SHTCartDrawerRemoveButton);
class SHTCartDrawerForm extends SHTCustomComponent {
    constructor() {
        super(),
            (this.totalItems = Array.from(this.$$(".js-cart-drawer-quantity-input")).reduce(
                (t, e) => t + parseInt(e.value),
                0
            )),
            (this.drawerCartElement = SHTHelper.qs("sht-cart-drwr")),
            (this.wrapperElement = this.drawerCartElement.querySelector(".js-cart-drawer-wrapper")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.cartDrawerNumber = SHTHelper.qs(".js-cart-drawer-count-number")),
            (this.linkToCart = SHTHelper.qs(".js-link-to-cart")),
            (this.quantityPricingBtn = this.$$(".js-quantity-pricing-btn")),
            (this.isProcessingCartUpdate = !1),
            this.addEventListener(
                "change",
                SHTHelper.debounce((t) => {
                    this.onChange(t);
                }, 300)
            ),
            document.addEventListener("cart:update", this.handleCartUpdate.bind(this)),
            this.onClickQuantityPricingBtn();
    }
    handleCartUpdate(t) {
        if (!this.isProcessingCartUpdate) {
            this.isProcessingCartUpdate = !0;
            let i = this.getSectionsToRender();
            this.cartNotification && (i = [...i, ...this.cartNotification.getSectionsToRender()]),
                fetch("" + window.routes.cart_url, {
                    ...SHTHelper.fetchConfig,
                    headers: { Accept: "application/json" },
                })
                    .then((t) => t.json())
                    .then((t) => {
                        var e, s;
                        0 === t.item_count
                            ? ((t = SHTHelper.qs(".js-drawer-empty")),
                              (e = SHTHelper.qs(".js-cart-drawer-wrapper")),
                              (s = SHTHelper.qs(".js-cart-count-number")),
                              (e.innerHTML = t.innerHTML),
                              (s.innerHTML = 0))
                            : fetch("?sections=" + i.map((t) => t.section).join(","))
                                  .then((t) => t.text())
                                  .then((t) => {
                                      t = JSON.parse(t);
                                      this.renderContentsDiscount({ sections: t });
                                  })
                                  .catch((t) => {
                                      console.error("Error fetching cart sections:", t);
                                  });
                    })
                    .catch((t) => {
                        console.error("Error fetching cart:", t);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.isProcessingCartUpdate = !1;
                        }, 500);
                    });
        }
    }
    disconnectedCallback() {
        this.cartUpdateHandler &&
            (document.removeEventListener("cart:update", this.cartUpdateHandler),
            (window.cartUpdateListenerRegistered = !1));
    }
    renderContentsDiscount(i) {
        this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty"),
            this.getSectionsToRenderDiscount().forEach((s) => {
                s.selectors?.forEach((t) => {
                    var e = SHTHelper.qid(s.id);
                    e &&
                        i.sections[s.section] &&
                        (e.querySelector(t).innerHTML = this.getSectionInnerHTML(i.sections[s.section], t));
                });
            });
    }
    getSectionsToRenderDiscount() {
        return [
            {
                id: "cartDrawer",
                section: "cart-drawer",
                selectors: [
                    ".js-cart-items",
                    ".js-discount-pills",
                    ".js-cart-total",
                    ".js-free-shipping-notification-message",
                    ".js-cart-level-discount-applications",
                ],
            },
            {
                id: "mainCart",
                section: "main-cart",
                selectors: [
                    ".js-cart-items",
                    ".js-discount-pills",
                    ".js-cart-total",
                    ".js-free-shipping-notification-message",
                    ".js-cart-level-discount-applications",
                ],
            },
        ];
    }
    onChange(t) {
        this.updateQuantity(t.target.dataset.index, t.target.value, document.activeElement.dataset.name);
    }
    onClickQuantityPricingBtn() {
        this.quantityPricingBtn?.forEach((e) => {
            window.matchMedia("(max-width: 1024px)").matches
                ? e.addEventListener("click", (t) => {
                      t.preventDefault(), e.classList.toggle("active");
                  })
                : (e.parentElement.addEventListener("mouseleave", () => {
                      e.classList.remove("active");
                  }),
                  e.parentElement.addEventListener("mouseenter", () => {
                      e.classList.add("active");
                  })),
                document.addEventListener("click", (t) => {
                    e.parentElement.contains(t.target) || e.classList.remove("active");
                });
        });
    }
    renderContents(i) {
        this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty"),
            this.getSectionsToRender().forEach((s) => {
                s.selectors?.forEach((t) => {
                    var e = SHTHelper.qid(s.id);
                    e &&
                        i.sections[s.section] &&
                        ((e.querySelector(t) || e).innerHTML = this.getSectionInnerHTML(i.sections[s.section], t));
                });
            });
    }
    getSectionsToRender() {
        return [
            { id: "cartDrawer", section: "cart-drawer", selectors: [".js-cart-drawer-wrapper"] },
            { id: "mainCart", section: "main-cart", selectors: ["#mainCartContainer"] },
        ];
    }
    updateQuantity(i, r, a) {
        let t = this.getSectionsToRender(),
            n;
        this.cartNotification && (t = [...t, ...this.cartNotification.getSectionsToRender()]);
        var e = JSON.stringify({
            line: i,
            quantity: r,
            sections: t.map((t) => t.section),
            sections_url: window.location.pathname,
        });
        this.updateButtonState(!0),
            fetch("" + window.routes.cart_change_url, { ...SHTHelper.fetchConfigJSON, body: e })
                .then((t) => t.text())
                .then((t) => {
                    var e, s;
                    (n = JSON.parse(t)),
                        this.closest(".js-cart-drawer-wrapper").classList.toggle("is-empty", 0 === n.item_count),
                        0 == n.item_count
                            ? ((t = SHTHelper.qs(".js-drawer-empty")),
                              (s = SHTHelper.qs(".js-cart-drawer-wrapper")),
                              (e = SHTHelper.qs(".js-cart-count-number")),
                              (s.innerHTML = t.innerHTML),
                              (e.innerHTML = 0),
                              (this.cartDrawerNumber.innerHTML = 0))
                            : (this.getSectionsToRender().forEach((i) => {
                                  i.selectors.forEach((t) => {
                                      var e,
                                          s = SHTHelper.qid(i.id);
                                      s &&
                                          ((s = s.querySelector(t) || s),
                                          "cartDrawer" === i.id && 0 < r
                                              ? ((e = s.querySelector(".js-cart-drawer-items")) &&
                                                    (e.innerHTML = this.getSectionInnerHTML(
                                                        n.sections[i.section],
                                                        ".js-cart-drawer-items"
                                                    )),
                                                (e = s.querySelector(".js-cart-drawer-free-shipping")) &&
                                                    (e.innerHTML = this.getSectionInnerHTML(
                                                        n.sections[i.section],
                                                        ".js-cart-drawer-free-shipping"
                                                    )),
                                                (e = s.querySelector(".js-cart-drawer-footer")) &&
                                                    (e.innerHTML = this.getSectionInnerHTML(
                                                        n.sections[i.section],
                                                        ".js-cart-drawer-footer"
                                                    )))
                                              : (s.innerHTML = this.getSectionInnerHTML(n.sections[i.section], t)));
                                  });
                              }),
                              (s = SHTHelper.qid("cartDrawerItem-" + i)) &&
                                  (t = s.querySelector(".js-cart-drawer-quantity-btn-" + a)) &&
                                  t.focus(),
                              this.cartNotification &&
                                  this.cartNotification.getSectionsToRender().forEach((t) => {
                                      "header-cart-status" == t.id &&
                                          (SHTHelper.qs(t.space_selector).innerHTML =
                                              this.cartNotification.getSectionInnerHTML(n.sections[t.id], t.selector));
                                  }));
                })
                .catch((t) => {
                    this.$(".js-cart-drawer-errors").textContent = SHTLanguage.cart.ERROR;
                })
                .finally(() => {
                    this.updateButtonState(!1);
                });
    }
    getSectionInnerHTML(t, e) {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML;
    }
    updateButtonState(t) {
        var s = this.$$(".js-cart-drawer-btn"),
            e = this.drawerCartElement.querySelector(".js-cart-drawer-submit-btn");
        if (t) {
            for (let t = 0, e = s.length; t < e; t++) s[t].setAttribute("disabled", "disabled");
            e && e.setAttribute("disabled", "disabled");
        } else {
            for (let t = 0, e = s.length; t < e; t++) s[t].removeAttribute("disabled", "disabled");
            e && e.removeAttribute("disabled");
        }
    }
}
customElements.define("sht-cart-drwr-frm", SHTCartDrawerForm);
class SHTDialogQuickShop extends SHTDialogCore {
    constructor() {
        super(),
            (this.viewFullBtn = this.querySelector(".js-view-full-btn")),
            (this.body = this.querySelector(".js-dialog-body")),
            this.constructor.cache || (this.constructor.cache = new Map());
    }
    showModal(t, e) {
        SHTHelper.preventStickyHeaderReveal(),
            (this.opener = t),
            this.processData(t, e),
            this.toggleAttribute("hidden", !1),
            this.offsetHeight,
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.classList.toggle("is-active", !0),
                        this.opener?.removeAttribute("disabled"),
                        this.classList.remove("hidden-xs");
                });
            });
    }
    processData(t, e) {
        const s = t.getAttribute("data-product-url");
        this.productElement = null;
        t = this.constructor.cache.get(s);
        t
            ? this.updateProductElements(t)
            : fetch(s)
                  .then((t) => {
                      if (t.ok) return t.text();
                      throw new Error("Failed to fetch data: " + t.statusText);
                  })
                  .then((t) => {
                      (t = new DOMParser().parseFromString(t, "text/html")), (t = this.extractProductData(t));
                      this.constructor.cache.set(s, t), this.updateProductElements(t);
                  })
                  .catch((t) => {
                      console.error("Error fetching product data:", t);
                  })
                  .finally(() => {
                      SHTHelper.trapFocus(this);
                  });
    }
    extractProductData(t) {
        return {
            productElement: t.querySelector(".section-product-quick-view .js-quick-view-container"),
            viewFullBtnElement: t.querySelector(".section-product-quick-view .js-quick-view-footer"),
            colorScheme: t.querySelector(".section-product-quick-view .js-main-product")?.getAttribute("data-color"),
        };
    }
    updateProductElements({ productElement: t, viewFullBtnElement: e, colorScheme: s }) {
        (this.body.innerHTML = t?.innerHTML || ""),
            s && this.classList.add(s),
            this.viewFullBtn && (this.viewFullBtn.innerHTML = e?.innerHTML || ""),
            window.Shopify?.PaymentButton && Shopify.PaymentButton.init(),
            window.SHTProductMediaItemModel && window.SHTProductMediaItemModel.loadShopifyXR();
    }
    closeModal() {
        this.offsetHeight,
            this.classList.add("drawer-out"),
            setTimeout(() => {
                this.toggleVisibility(!1),
                    this.classList.replace("drawer-out", "hidden-xs"),
                    (this.viewFullBtn.innerHTML = ""),
                    (this.body.innerHTML = "");
            }, 300);
    }
    toggleVisibility(t) {
        this.toggleAttribute("hidden", !t), this.classList.toggle("is-active", t);
    }
}
customElements.define("sht-dialog-quickview", SHTDialogQuickShop);
class SHTMessageAddToCartSuccess extends SHTCustomComponent {
    constructor() {
        super();
    }
    setActiveMessage(t = !0) {
        t ? this.classList.add("d-flex") : this.classList.remove("d-flex");
    }
}
customElements.define("sht-message-success", SHTMessageAddToCartSuccess);
class SHTRecentlyViewedDrawer extends SHTCustomComponent {
    constructor() {
        super(),
            (this.cookieName = "sht-recently-viewed"),
            (this.limitProduct = parseInt(this.dataset.limit)),
            (this.productsArray = this.getArrayFromLocalStorage().slice(0, this.limitProduct)),
            (this.totalItems = parseInt(this.productsArray.length)),
            (this.enableVendor = "true" === this.dataset.enableVendor),
            (this.enablePrice = "true" === this.dataset.enablePrice),
            (this.enableRating = "true" === this.dataset.enableRating),
            (this.body = this.$(".js-drawer-recently-viewed")),
            (this.recentlyViewedDrawer = SHTHelper.qs(".js-recently-viewed-drawer")),
            (this.recentlyViewedEmpty = this.$(".js-rv-empty"));
    }
    connectedCallback() {
        this.checkRecentlyViewedState(), this.processData();
    }
    processData() {
        var t = this.getArrayFromLocalStorage()
            .slice(0, this.limitProduct)
            .map((t) => t.url + "?view=show-drawer-recently-viewed");
        return Promise.all(t.map((t) => this.fetchProductHTML(t)))
            .then((t) => {
                t.forEach((t, e) => {
                    var s;
                    t &&
                        (((s = document.createElement("div")).innerHTML = t),
                        (t = s.firstElementChild),
                        this.enableVendor || t.querySelector(".js-rv-vendor").classList.add("d-none-important"),
                        this.enablePrice || t.querySelector(".js-rv-price").classList.add("d-none-important"),
                        this.enableRating || t.querySelector(".js-rv-rating").classList.add("d-none-important"),
                        this.body.appendChild(t));
                }),
                    this.executeScriptElements(this.body),
                    window.SHTProductMediaItemModel && window.SHTProductMediaItemModel.loadShopifyXR();
            })
            .catch((t) => {
                console.error(t);
            });
    }
    getArrayFromLocalStorage() {
        var t = localStorage.getItem(this.cookieName);
        return JSON.parse(t) || [];
    }
    removeDataFromLocalStorage() {
        localStorage.removeItem(this.cookieName);
    }
    async fetchProductHTML(e) {
        try {
            var t = await (await fetch(e)).text(),
                s = new DOMParser().parseFromString(t, "text/html").querySelector(".section-drawer-recently-viewed");
            return window.Shopify?.PaymentButton && Shopify.PaymentButton.init(), s?.innerHTML || null;
        } catch (t) {
            return console.error(`Failed to fetch product from ${e}:`, t), null;
        }
    }
    executeScriptElements(t) {
        t = t.querySelectorAll("script");
        Array.from(t).forEach((t) => {
            const e = document.createElement("script");
            Array.from(t.attributes).forEach((t) => {
                e.setAttribute(t.name, t.value);
            }),
                e.appendChild(document.createTextNode(t.innerHTML)),
                t.parentNode.replaceChild(e, t);
        });
    }
    checkRecentlyViewedState() {
        !0 === Shopify.designMode && this.removeDataFromLocalStorage(),
            this.recentlyViewedDrawer.classList.toggle(
                "d-none-important",
                !0 === Shopify.designMode && 0 < this.totalItems
            ),
            this.recentlyViewedEmpty.classList.toggle("d-none-important", 0 < this.totalItems);
    }
}
customElements.define("sht-recently-viewed-drawer", SHTRecentlyViewedDrawer);
class SHTDialogQuickBuy extends SHTDialogCore {
    constructor() {
        super(),
            (this.cartNotiType = SHTHelper.qs("body").getAttribute("data-cart-noti-type")),
            (this.cartType = SHTHelper.qs("body").getAttribute("data-cart-type")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.quickBuyDialog = SHTHelper.qs("sht-dialog-quick-buy")),
            (this.cache = new Map()),
            (this.cartDrawer = SHTHelper.qs("sht-cart-drwr")),
            (this.checkBulk = !1),
            (this.interactionPopup = SHTHelper.qs("sht-interaction-popup"));
    }
    handleSellingPlanErrorMessage(t, e) {
        t = t.closest(".js-product-card-block")?.querySelector(".js-selling-plan-error-message");
        "true" === e
            ? t?.classList.remove("d-none-important")
            : t?.classList.contains("d-none-important") || t?.classList.add("d-none-important");
    }
    checkSellingPlan(t, e) {
        var s = t.dataset.sellingPlan;
        this.handleSellingPlanErrorMessage(t, s);
    }
    async showModal(t, e) {
        var s = t.dataset.sellingPlan;
        this.handleSellingPlanErrorMessage(t, s),
            "true" !== s &&
                (SHTHelper.preventStickyHeaderReveal(),
                (this.opener = t),
                await this.processData(t),
                this.toggleAttribute("hidden", !1),
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.classList.add("is-active"),
                            this.offsetHeight,
                            this.classList.remove("hidden-xs"),
                            this.calculateDialogHeights();
                    });
                }));
    }
    async processData(t) {
        this.productElement = null;
        var e = t.dataset.quickBuy,
            t = t.getAttribute("data-product-url");
        if (this.cache.has(t)) this.renderQuickBuyContent(this.cache.get(t), e);
        else
            try {
                var s = await (await fetch(t)).text(),
                    i = new DOMParser().parseFromString(s, "text/html").querySelector(".js-quick-buy-content-wrapper");
                this.cache.set(t, i), this.renderQuickBuyContent(i, e);
            } catch (t) {
                console.error("Error fetching product data:", t);
            }
    }
    renderQuickBuyContent(t, e) {
        var s, i;
        t &&
            ((this.querySelector(".js-quick-buy-dialog-content").innerHTML = t.innerHTML),
            (t = this.querySelectorAll(".js-quick-buy-standard-container")),
            (s = this.querySelectorAll(".js-quick-buy-bulk-container")),
            (i = this.querySelector("sht-scroll-gradient-overlay")),
            "standard" === e
                ? (s.forEach((t) => t.classList.add("d-none")),
                  t.forEach((t) => t.classList.remove("d-none")),
                  i.classList.remove("gradient-overlay"))
                : "bulk" === e &&
                  ((this.checkBulk = !0),
                  t.forEach((t) => t.classList.add("d-none")),
                  s.forEach((t) => t.classList.remove("d-none")),
                  i.classList.contains("gradient-overlay") || i.classList.add("gradient-overlay")),
            setTimeout(() => {
                this.calculateDialogHeights();
            }, 50));
    }
    calculateDialogHeights() {
        var t = this.querySelector(".dialog__header"),
            e = this.querySelector(".dialog__footer");
        t
            ? ((t = t.offsetHeight), this.style.setProperty("--header-dialog", t + "px"))
            : this.style.setProperty("--header-dialog", "0px"),
            e
                ? ((t = e.offsetHeight), this.style.setProperty("--footer-dialog", t + "px"))
                : this.style.setProperty("--footer-dialog", "0px");
    }
    scrollTop() {
        var t = this.querySelector(".js-quick-buy-bulk-scroll");
        t && t.scrollTo({ top: 0, behavior: "instant" });
    }
    closeModal() {
        this.setAttribute("hidden", !0),
            this.checkBulk && this.handleCartNotification(),
            this.offsetHeight,
            this.classList.add("drawer-out"),
            setTimeout(() => {
                this.classList.remove("is-active"),
                    this.classList.replace("drawer-out", "hidden-xs"),
                    (this.querySelector(".js-quick-buy-dialog-content").innerHTML = "");
            }, 300);
    }
    handleCartNotification() {
        var t = Number(this.querySelector(".js-total-product-bulk")?.value);
        switch (this.cartNotiType) {
            case "popover_notification":
                this.cartNotification &&
                    (this.quickBuyDialog &&
                        !this.quickBuyDialog.hasAttribute("hidden") &&
                        this.quickBuyDialog.closeModal(),
                    this.cartNotification.renderQuantityContents(!0, t, this.quickBuyDialog.opener));
                break;
            case "cart_noti":
                if ("drawer" === this.cartType) {
                    this.closeDialogAndOpenDrawer(this.quickBuyDialog),
                        this.cartDrawer && this.cartDrawer.querySelector(".js-drawer-message")?.setActiveMessage();
                    break;
                }
                if ("page" == this.cartType) {
                    window.location.assign(window.routes.cart_url);
                    break;
                }
        }
        this.interactionPopup && this.interactionPopup.handleShowPopupAddToCart();
    }
    closeDialogAndOpenDrawer(t) {
        t && t.animationsComplete().then(() => this.cartDrawer.openDrawer(t.opener));
    }
}
customElements.define("sht-dialog-quick-buy", SHTDialogQuickBuy);
class SHTQuickOrderList extends SHTCustomComponent {
    constructor() {
        super(),
            (this.quickForm = this.$("sht-quick-shop-frm")),
            (this.cartNotiType = SHTHelper.qs("body").getAttribute("data-cart-noti-type")),
            (this.cartType = SHTHelper.qs("body").getAttribute("data-cart-type")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.cartDrawer = SHTHelper.qs("sht-cart-drwr")),
            (this.quantityContainer = this.$$(".js-quantity-wrapper")),
            (this.deleteBtn = this.$$(".js-delete-variant-btn")),
            (this.allInputs = this.$$(".js-quantity-input")),
            (this.totalProductBulk = this.$(".js-variant-selector-quantity")?.textContent.replace(/\sitems?/, "")),
            (this.interactionPopup = SHTHelper.qs("sht-interaction-popup")),
            (this.eventsTriggered = { change: !1, blur: !1 }),
            (this.isLoading = !1);
    }
    connectedCallback() {
        this.initEventListeners(),
            this.quickForm.addEventListener(
                "total-product-bulk-updated",
                this.handleTotalProductBulkUpdated.bind(this)
            );
    }
    initEventListeners() {
        (this.quantityContainer = this.$$(".js-quantity-wrapper")),
            (this.deleteBtn = this.$$(".js-delete-variant-btn")),
            (this.allInputs = this.$$(".js-quantity-input")),
            this.quickForm && this.quickForm.addEventListener("change", this.handleChange.bind(this)),
            this.quantityContainer.forEach((t) => {
                t.addEventListener("mouseleave", this.handleBlur.bind(this)),
                    t.addEventListener("mouseenter", this.handleEnter.bind(this));
            }),
            this.deleteBtn.forEach((t) => t.addEventListener("click", this.handleChange.bind(this))),
            this.allInputs.forEach((t) => t.addEventListener("blur", this.handleBlur.bind(this))),
            this.addEventListener("on:cart-input:change", (t) => {
                this.elementFocus = t.detail.element;
            }),
            this.querySelectorAll(".js-pagination-item").forEach((e) => {
                e.addEventListener("click", async (t) => {
                    if ((t.preventDefault(), t.stopPropagation(), !this.isLoading && !e.hasAttribute("disabled"))) {
                        t = new URL(t.currentTarget.href).searchParams.get("page") || "1";
                        this.toggleTableLoading(!0), this.scrollTop();
                        try {
                            await this.refresh(t);
                        } catch (t) {
                            console.error("Pagination error:", t);
                        } finally {
                            this.toggleTableLoading(!1);
                        }
                    }
                });
            });
    }
    get currentPage() {
        return this.querySelector(".js-pagination-wrapper")?.dataset?.page ?? "1";
    }
    async refresh(t = null) {
        var e = this.dataset.url || window.location.pathname;
        try {
            var s = await fetch(`${e}?section_id=${this.dataset.section}&page=` + (t || this.currentPage));
            if (!s.ok) throw new Error("HTTP error! status: " + s.status);
            var i = await s.text(),
                r = new DOMParser().parseFromString(i, "text/html").querySelector("#" + this.id);
            if (r) return (this.innerHTML = r.innerHTML), this.initEventListeners(), !0;
            throw new Error("Quick order list section not found in response");
        } catch (t) {
            throw (console.error("Error refreshing quick order list:", t), t);
        }
    }
    toggleTableLoading(e) {
        this.isLoading = e;
        var t = this.querySelector(".js-quick-shop-form-wrapper"),
            s = this.querySelectorAll(".js-pagination-item");
        t && t.classList.toggle("is-loading", e),
            s.forEach((t) => {
                t.classList.toggle("is-disabled", e);
            });
    }
    scrollTop() {
        var t = this.getBoundingClientRect()["top"];
        const e = document.querySelector("sht-header-sticky");
        var s,
            i = e?.querySelector("sht-header");
        let r = 0;
        e && i && (("always_reveal" !== (s = e.dataset.stickyState) && "true" !== s) || (r = i.offsetHeight));
        const a = e?.onScrollHandle;
        e && a && (e.onScrollHandle = () => {}),
            window.scrollTo({ top: t + window.scrollY - r - 20, behavior: "instant" }),
            e &&
                a &&
                setTimeout(() => {
                    e.onScrollHandle = a;
                }, 50);
    }
    handleEnter() {
        this.eventsTriggered.blur = !1;
    }
    handleChange() {
        (this.eventsTriggered.change = !0), this.handleTotalProductBulkUpdated();
    }
    handleBlur() {
        (this.eventsTriggered.blur = !0), this.handleTotalProductBulkUpdated();
    }
    checkAndHandleCartNotification(t) {
        this.eventsTriggered.change &&
            this.eventsTriggered.blur &&
            (setTimeout(() => this.handleCartNotification(t), 300),
            (this.eventsTriggered.change = !1),
            (this.eventsTriggered.blur = !1));
    }
    handleTotalProductBulkUpdated(t) {
        t?.detail &&
            ((t = t.detail["totalProductBulk"]),
            (this.totalProductBulk = t),
            this.checkAndHandleCartNotification(this.totalProductBulk));
    }
    handleCartNotification(t) {
        switch (this.cartNotiType) {
            case "popover_notification":
                this.cartNotification && this.cartNotification.renderQuantityContents(!0, t, this.elementFocus);
                break;
            case "cart_noti":
                if ("drawer" === this.cartType) {
                    this.cartDrawer &&
                        (this.cartDrawer.openDrawer(this.elementFocus),
                        this.cartDrawer.querySelector(".js-drawer-message")?.setActiveMessage());
                    break;
                }
                if ("page" === this.cartType) {
                    window.location.assign(window.routes.cart_url);
                    break;
                }
        }
        this.interactionPopup && this.interactionPopup.handleShowPopupAddToCart();
    }
}
customElements.define("sht-quick-order-list", SHTQuickOrderList);
class SHTQuickShopForm extends SHTCustomComponent {
    constructor() {
        super(),
            (this.form = this.$("form")),
            (this.totalItems = Array.from(this.$$(".js-quantity-input")).reduce((t, e) => t + parseInt(e.value), 0)),
            (this.variantId = ""),
            (this.errorMessage = this.$$(".js-max-quantity-message")),
            (this.sellingPlanErrorMessage = this.$$(".js-selling-plan-error-message")),
            (this.quantityErrorMessage = this.$$(".js-quantity-pricing-message")),
            (this.totalProductBulk = this.closest(".js-quick-shop-container")?.querySelector(".js-total-product-bulk")),
            (this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm")),
            (this.headerCartStatus = SHTHelper.qs("#headerCartStatus")),
            (this.allInputs = this.$$(".js-quantity-input")),
            (this.previousItems = []),
            (this.quantityPricingBtn = this.$$(".js-quantity-pricing-btn")),
            (this.isLoading = !1);
    }
    connectedCallback() {
        this.initEventListeners();
    }
    initEventListeners() {
        (this.allInputs = this.$$(".js-quantity-input")),
            (this.errorMessage = this.$$(".js-max-quantity-message")),
            (this.sellingPlanErrorMessage = this.$$(".js-selling-plan-error-message")),
            (this.quantityErrorMessage = this.$$(".js-quantity-pricing-message")),
            (this.quantityPricingBtn = this.$$(".js-quantity-pricing-btn"));
        var t = this.closest(".js-quick-shop-container")?.querySelector(".js-variant-selector-quantity");
        this.totalProductBulk && (this.totalProductBulk.value = Number(t?.textContent.replace(/\sitems?/, ""))),
            this.addEventListener("change", SHTHelper.debounce(this.onChange.bind(this), 300)),
            this.allInputs.forEach((t) => {
                t.addEventListener("input", this.onChange.bind(this));
            }),
            this.onClickQuantityPricingBtn(),
            this.querySelectorAll(".js-pagination-item").forEach((s) => {
                s.addEventListener("click", async (t) => {
                    if ((t.preventDefault(), t.stopPropagation(), !this.isLoading && !s.hasAttribute("disabled"))) {
                        var t = new URL(t.currentTarget.href).searchParams.get("page") || "1",
                            e = (this.toggleTableLoading(!0), this.closest("sht-dialog-quick-buy"));
                        e && e.scrollTop();
                        try {
                            await this.refresh(t);
                        } catch (t) {
                            console.error("Quick-buy pagination error:", t);
                        } finally {
                            this.toggleTableLoading(!1);
                        }
                    }
                });
            });
    }
    onClickQuantityPricingBtn() {
        this.quantityPricingBtn?.forEach((e) => {
            window.matchMedia("(max-width: 1024px)").matches
                ? e.addEventListener("click", (t) => {
                      t.preventDefault(), e.classList.toggle("active");
                  })
                : (e.parentElement.addEventListener("mouseleave", () => {
                      e.classList.remove("active");
                  }),
                  e.parentElement.addEventListener("mouseenter", () => {
                      e.classList.add("active");
                  })),
                document.addEventListener("click", (t) => {
                    e.parentElement.contains(t.target) || e.classList.remove("active");
                });
        });
    }
    onChange(t) {
        var e, s, i;
        function r(t) {
            return Array.from(t).every((t) => t.classList.contains("d-none-important"));
        }
        "note" !== t.target.name &&
            (s = t.target.closest(".js-variant-bulk-item")) &&
            ((this.variantId = s.dataset.variantId),
            (e = { [this.variantId]: parseInt(t.target.value) }),
            (s = r(this.errorMessage)),
            (t = r(this.sellingPlanErrorMessage)),
            (i = r(this.quantityErrorMessage)),
            s) &&
            t &&
            i &&
            this.updateQuantity(e, this.variantId);
    }
    getSectionsToRender() {
        return [
            {
                id: "quickShopForm-" + this.id,
                section: this.dataset.sectionId,
                selectors: [".js-quick-shop-form-wrapper"],
            },
            { id: "cartDrawer", section: "cart-drawer", selectors: [".js-cart-drawer-wrapper"] },
            { id: "HeaderCartStatus", section: "header-cart-status", selectors: [".shopify-section"] },
        ];
    }
    updateQuantity(t, r) {
        const a = [".js-variant-selector-quantity", ".js-bulk-total-price"];
        var e = this.getSectionsToRender().map((t) => t.section),
            t = JSON.stringify({ updates: t, sections: e, sections_url: this.dataset.url });
        fetch("" + window.routes.cart_update_url, { ...SHTHelper.fetchConfigJSON, body: t })
            .then((t) => t.text())
            .then((e) => {
                let s = JSON.parse(e);
                if (!s.errors) {
                    let t = s.items.find((t) => t.id == r);
                    var e = this.querySelector(`#totalPrice-${this.dataset.sectionId}-` + r),
                        i = this.closest(".js-quick-shop-container")?.querySelector(".js-variant-selector-quantity"),
                        e =
                            (0 < this.previousItems.length &&
                                this.previousItems.length > s.items.length &&
                                ((t = this.previousItems.filter(
                                    (e) => !s.items.some((t) => e.id === t.id)
                                )[0]).quantity = 0),
                            this.cartDrawerForm &&
                                t &&
                                ((t.sections = s.sections), this.cartDrawerForm.renderContents(t)),
                            this.headerCartStatus &&
                                (this.headerCartStatus.innerHTML = this.getSectionInnerHTML(
                                    s.sections["header-cart-status"],
                                    ".shopify-section"
                                )),
                            a.forEach((t) => {
                                var e = this.closest(".js-quick-shop-container")?.querySelector(t);
                                e && (e.innerHTML = this.getSectionInnerHTML(s.sections[this.dataset.sectionId], t));
                            }),
                            e &&
                                (e.innerHTML = this.getSectionInnerHTML(
                                    s.sections[this.dataset.sectionId],
                                    `#totalPrice-${this.dataset.sectionId}-` + r
                                )),
                            (this.variantId = ""),
                            Number(i?.textContent.replace(/\sitems?/, "")));
                    this.totalProductBulk && (this.totalProductBulk.value = e),
                        this.dispatchEvent(
                            new CustomEvent("total-product-bulk-updated", {
                                detail: { totalProductBulk: e },
                                bubbles: !0,
                                composed: !0,
                            })
                        ),
                        (this.previousItems = s.items);
                }
            })
            .catch((t) => {
                console.log(t);
            });
    }
    getSectionInnerHTML(t, e) {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML;
    }
    get currentPage() {
        return this.querySelector(".js-pagination-wrapper")?.dataset?.page ?? "1";
    }
    async refresh(t = null) {
        var e = this.dataset.url || window.location.pathname;
        try {
            var s = await fetch(`${e}?section_id=${this.dataset.sectionId}&page=` + (t || this.currentPage));
            if (!s.ok) throw new Error("HTTP error! status: " + s.status);
            var i = await s.text(),
                r = new DOMParser().parseFromString(i, "text/html").querySelector("#" + this.id);
            if (r) return (this.innerHTML = r.innerHTML), this.initEventListeners(), !0;
            throw new Error("Quick shop form section not found in response");
        } catch (t) {
            throw (console.error("Error refreshing quick shop form:", t), t);
        }
    }
    toggleTableLoading(e) {
        this.isLoading = e;
        var t = this.querySelector(".js-quick-shop-form-wrapper"),
            s = this.querySelectorAll(".js-pagination-item");
        t && t.classList.toggle("is-loading", e),
            s.forEach((t) => {
                t.classList.toggle("is-disabled", e);
            });
    }
}
customElements.define("sht-quick-shop-frm", SHTQuickShopForm);
class SHTRemoveButton extends SHTCustomComponent {
    constructor() {
        super(),
            (this.queue = []),
            (this.requestStarted = !1),
            (this.container = this.closest(".js-quantity-wrapper")),
            (this.message = this.container?.querySelector(".js-max-quantity-message")),
            (this.sellingPlanMessage = this.container?.querySelector(".js-selling-plan-error-message")),
            (this.cartDrawerNumber = SHTHelper.qs(".js-cart-drawer-count-number")),
            (this.cartCountNumber = SHTHelper.qs(".js-cart-count-number"));
    }
    connectedCallback() {
        this.bindEventHandlers();
    }
    bindEventHandlers() {

        const removeVariant = (e) => {
            console.log("here removing");

            e.preventDefault();

            // Reset displayed price to first tier price
            const lowestPrice = this.closest('.js-variant-bulk-item')
            ?.querySelector('.js-pricing-item-price')
            ?.textContent;

            const priceItem = this.closest('.js-variant-bulk-item')
            ?.querySelector('.product-bulk-price .price-item');
            const row = this.closest('.js-variant-bulk-item');
            const unit = row?.dataset.unit || '';
            if (lowestPrice && priceItem) {
            priceItem.textContent = lowestPrice+ unit;
            }

            this.updateVariant(this.dataset.variantId, 0);
            this.updateErrorMessage();
        };

        this.addEventListener("click", removeVariant);

        this.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                removeVariant(e);
            }
        });
         
    }
    updateErrorMessage() {
        [
            this.container?.querySelector(".js-max-quantity-message"),
            this.container?.querySelector(".js-selling-plan-error-message"),
            this.container?.querySelector(".js-quantity-pricing-message"),
        ].forEach((t) => t.classList.add("d-none-important"));
    }
    updateVariant(t, e) {
        this.queue.push({ variantId: t, quantity: e });
        const s = setInterval(() => {
            0 < this.queue.length
                ? this.requestStarted ||
                  (this.sendRequest(this.queue, t).then(() => {
                      this.requestStarted = !1;
                  }),
                  (this.closest(".js-quantity-wrapper").querySelector(".js-quantity-input").value = 0),
                  [this, this.message, this.sellingPlanMessage].forEach((t) => t.classList.add("d-none-important")))
                : clearInterval(s);
        }, 250);
    }
    async sendRequest(e, t) {
        this.requestStarted = !0;
        const s = {};
        e.forEach((t) => {
            s[parseInt(t.variantId)] = t.quantity;
        }),
            (this.queue = this.queue.filter((t) => !e.includes(t))),
            this.closest("sht-quick-shop-frm").updateQuantity(s, t);
    }
}
customElements.define("sht-remove-btn", SHTRemoveButton);
class SHTCartDrawerComplementary extends SHTCarousel {
    constructor() {
        super(),
            (this.textListIds = this.dataset.productId),
            (this.url = this.dataset.url),
            (this.body = this.$(".js-cart-complementary-product-main")),
            (this.cartDrawerSection = SHTHelper.qs("#shtCartDrawer")),
            (this.limitProduct = parseInt(this.cartDrawerSection.dataset.limit)),
            (this.complementaryHeading = this.cartDrawerSection.dataset.heading),
            (this.complementaryHeadingContent = this.$(".js-cart-complementary-heading-content")),
            (this.arrayIds = this.handleListId(this.textListIds)),
            (this.complementaryProductIds = new Set());
    }
    connectedCallback() {
        super.connectedCallback(), this.handleIntersection();
    }
    handleListId(t) {
        return t.split(",");
    }
    async handleIntersection() {
        try {
            var t = this.arrayIds.map((t) => "" + this.url + t),
                e = await Promise.all(t.map((t) => this.fetchProductHTML(t))),
                s = this.querySelector(".js-cart-complementary-product-list"),
                i = this.querySelector(".js-cart-complementary-product-btn");
            if (s) {
                let t = 0;
                var r = parseInt(this.limitProduct, 10);
                for (const d of e) {
                    if (t >= r) break;
                    var a = document.createElement("div"),
                        n =
                            ((a.innerHTML = d),
                            i.classList.add("d-none-important"),
                            (this.complementaryHeadingContent.innerHTML = this.complementaryHeading),
                            a.querySelectorAll(".js-cart-complementary-product-item"));
                    for (const h of n) {
                        if (t >= r) break;
                        var o,
                            l = h.dataset.id;
                        l &&
                            !this.complementaryProductIds.has(l) &&
                            (this.body.classList.remove("d-none"),
                            this.complementaryProductIds.add(l),
                            (o = h.cloneNode(!0)),
                            s.appendChild(o),
                            t++);
                    }
                }
                1 === s.childElementCount
                    ? (s.classList.add("complementary-one-value"), i.classList.add("d-none-important"))
                    : 2 === s.childElementCount
                      ? (s.classList.remove("complementary-one-value"), i.classList.add("d-none-important"))
                      : (s.classList.remove("complementary-one-value"), i.classList.remove("d-none-important")),
                    (this.carousels = this.body.querySelectorAll(".js-carousel-item")),
                    this.updateVisibility();
            }
        } catch (t) {
            console.error("Error fetching complementary products:", t);
        }
    }
    updateVisibility() {
        var { enableVendor: t, enablePrice: e } = this.cartDrawerSection.dataset;
        [
            { isEnabled: "false" !== t, elements: this.$$(".js-cart-complementary-product-item .js-mini-card-vendor") },
            { isEnabled: "false" !== e, elements: this.$$(".js-cart-complementary-product-item .js-mini-card-price") },
        ].forEach(({ isEnabled: t, elements: e }) => {
            t || e.forEach((t) => t.classList.add("d-none-important"));
        });
    }
    async fetchProductHTML(e) {
        try {
            var t,
                s,
                i,
                r = await fetch(e);
            return r.ok
                ? ((t = await r.text()),
                  ((s = document.createElement("div")).innerHTML = t),
                  (i = s.querySelector(".js-cart-complementary-product-list")) && i.innerHTML.trim().length
                      ? i.innerHTML
                      : null)
                : (console.error(`Failed to fetch product from ${e}:`, r.statusText), null);
        } catch (t) {
            return console.error(`Error fetching product from ${e}:`, t), null;
        }
    }
}
customElements.define("sht-cart-drwr-cpry", SHTCartDrawerComplementary);
class SHTSpotlightQuote extends SHTCustomComponent {
    constructor() {
        super(),
            (this.spotlightItems = this.$(".js-spotlight-items")),
            (this.isRTL =
                "rtl" === document.documentElement.dir ||
                "rtl" === getComputedStyle(document.documentElement).direction),
            this.spotlightItems && (this.spotlightItems.style.direction = "ltr"),
            (this.totalElm = this.$(".js-spotlight-total")),
            (this.currentElm = this.$(".js-spotlight-current")),
            (this.separatorElm = this.$(".js-spotlight-separator")),
            (this.prevBtn = this.$(".js-spotlight-prev-btn")),
            (this.nextBtn = this.$(".js-spotlight-next-btn")),
            (this.startNStopBtn = this.$(".js-spotlight-start-n-stop-btn")),
            (this.imageItems = this.$$(".js-spotlight-content")),
            (this.pauseIcon = this.startNStopBtn?.querySelector(".js-spotlight-pause-icon")),
            (this.playIcon = this.startNStopBtn?.querySelector(".js-spotlight-play-icon")),
            (this.properties = JSON.parse(this.dataset.spotlightProperties)),
            (this.autoplay = this.properties.autoplay || !1),
            (this.image = null),
            (this.template = null),
            (this.current = 1),
            (this.anchors = []),
            (this.lastScrollTimeout = null),
            (this.autoplayInterval = null),
            (this.content = this.spotlightItems.children),
            (this.total = this.content.length),
            (this.spotlightItems.scrollLeft = 0),
            (this.observer = null),
            (this.isPaused = !1),
            (this.pagination = this.$(".js-spotlight-pagination")),
            (this.pagination_items = this.pagination?.querySelectorAll(".js-spotlight-pagination-item"));
    }
    cloneSlideItem() {
        var t, e;
        2 == this.total &&
            ((t = this.spotlightItems.querySelector(".js-spotlight-item:first-of-type")),
            (e = this.spotlightItems.querySelector(".js-spotlight-item:last-of-type")) &&
                ((e = e.cloneNode(!0)).classList.add("slider-slide--clone"), this.spotlightItems.append(e)),
            t) &&
            ((e = t.cloneNode(!0)).classList.add("slider-slide--clone"), this.spotlightItems.append(e));
    }
    execute() {
        this.total <= 1 ||
            (this.cloneSlideItem(), this.observerSlideShow(), this.prepare(), this.bindEventHandlers(), this.init());
    }
    connectedCallback() {
        this.execute();
    }
    init() {
        (this.slideItems = this.$$(".js-spotlight-item")),
            (this.currentItemClass = "js-spotlight-content--current"),
            (this.slideContainer = this.$(".js-spotlight-items")),
            (this.containerObserver = this.$(".js-spotlight")),
            (this.slideContent = this.$$(".js-spotlight-content")),
            this.autoplay && (this.resumeAutoPlay(), (this.isPaused = !0)),
            this.updateSort();
    }
    updateSort() {
        var t, e, s, i;
        this.total <= 1 ||
            ((t = this.spotlightItems.scrollLeft),
            (e = Math.round(t)),
            (s = this.spotlightItems.offsetWidth),
            (i = this.spotlightItems.scrollWidth),
            e < s &&
                (this.spotlightItems.prepend(this.content[this.total - 1]), (this.spotlightItems.scrollLeft = e + s)),
            Math.floor(i - t) <= s &&
                (this.spotlightItems.append(this.content[0]), (this.spotlightItems.scrollLeft = e - s)));
    }
    startAutoPlay() {
        this.autoplay &&
            (this.autoplayInterval = setInterval(
                function () {
                    this.isRTL ? this.prevSlide() : this.nextSlide();
                }.bind(this),
                this.properties.duration
            ));
    }
    bindEventHandlers() {
        this.spotlightItems.addEventListener(
            "wheel",
            function (t) {
                5 == Math.abs(t.deltaX) && this.stopAutoPlay();
            }.bind(this),
            { passive: !0 }
        ),
            this.spotlightItems.addEventListener(
                "scroll",
                SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100)
            ),
            this.nextBtn.addEventListener(
                "click",
                SHTHelper.debounce(
                    function () {
                        this.isRTL ? this.prevSlide() : this.nextSlide(), this.stopAutoPlay();
                    }.bind(this),
                    300
                )
            ),
            this.prevBtn.addEventListener(
                "click",
                SHTHelper.debounce(
                    function () {
                        this.isRTL ? this.nextSlide() : this.prevSlide(), this.stopAutoPlay();
                    }.bind(this),
                    300
                )
            ),
            this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this)),
            "undefined" != typeof Shopify && Shopify.designMode && this.handleScrollToItemInAdmin();
    }
    onStartNStopEventHandle(t) {
        t.preventDefault(), this.autoplay ? this.stopAutoPlay() : this.resumeAutoPlay();
    }
    stopAutoPlay() {
        clearInterval(this.autoplayInterval),
            this.pauseIcon.classList.add("d-none"),
            this.playIcon.classList.remove("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
            this.spotlightItems.setAttribute("aria-live", "polite"),
            (this.autoplay = !1);
    }
    resumeAutoPlay() {
        (this.autoplay = !0),
            this.pauseIcon.classList.remove("d-none"),
            this.playIcon.classList.add("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]),
            this.spotlightItems.setAttribute("aria-live", "off"),
            this.startAutoPlay();
    }
    onScrollEventHandle(t) {
        t.preventDefault(),
            this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout),
            (this.lastScrollTimeout = setTimeout(
                function () {
                    this.updateSort();
                }.bind(this),
                100
            )),
            this.updateCurrent(),
            this.updatePagination();
    }
    updatePagination() {
        var t;
        this.pagination &&
            (t = this.pagination.querySelector(`li[data-spotlight-index="${this.current}"]`)) &&
            (this.pagination_items.forEach((t) => t.classList.remove("is-active")), t.classList.add("is-active"));
    }
    prepare() {
        (this.totalElm.textContent = this.total),
            (this.currentElm.textContent = this.current),
            (this.separatorElm.textContent = this.properties.separatorText),
            this.autoplay &&
                (this.startNStopBtn.toggleAttribute("hidden", !1),
                this.startNStopBtn.querySelector(".js-spotlight-pause-icon").classList.remove("d-none"),
                this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
                this.spotlightItems.setAttribute("aria-live", "off"));
    }
    updateCurrent() {
        var t = this.$(".js-spotlight-content--current");
        t && (this.current = t.dataset.spotlightIndex), (this.currentElm.textContent = this.current);
    }
    prevSlide() {
        if (2 < this.total) {
            let t = +this.current - 1;
            1 == this.current && (t = this.total);
            var e = this.$(`div[data-item-index="${t}"]`);
            e &&
                this.spotlightItems.scrollTo({
                    left: this.spotlightItems.scrollLeft - e.offsetWidth,
                    behavior: "smooth",
                });
        } else {
            (e = 2 == this.$(".slider-slide--active").dataset.itemIndex ? 1 : 2),
                (e = this.$(`div[data-item-index="${e}"]`));
            e &&
                this.spotlightItems.scrollTo({
                    left: this.spotlightItems.scrollLeft - e.offsetWidth,
                    behavior: "smooth",
                });
        }
    }
    nextSlide() {
        if (2 < this.total) {
            let t = +this.current + 1;
            this.current == this.total && (t = 1);
            var e = this.$(`div[data-item-index="${t}"]`);
            e &&
                this.spotlightItems.scrollTo({
                    left: this.spotlightItems.scrollLeft + e.offsetWidth,
                    behavior: "smooth",
                });
        } else {
            e = this.$(".slider-slide--active + .js-spotlight-item");
            e &&
                this.spotlightItems.scrollTo({
                    left: this.spotlightItems.scrollLeft + e.offsetWidth,
                    behavior: "smooth",
                });
        }
    }
    observerSlideShow() {
        (this.observer = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    var e = t.target.querySelector(".js-spotlight-content"),
                        s = e.closest(".js-spotlight-item");
                    t.isIntersecting
                        ? e &&
                          (this.clearAllCurrentItemClass(),
                          this.clearAllActiveItemClass(),
                          e.classList.add(this.currentItemClass),
                          this.setSlideItemVisibility(!0, s))
                        : this.setSlideItemVisibility(!1, s);
                });
            },
            { root: this.containerObserver, rootMargin: "100px -2px 100px -2px", threshold: 0.5 }
        )),
            (this.slideItems = this.$$(".js-spotlight-item")),
            this.slideItems.forEach((t) => {
                t && this.observer.observe(t);
            });
    }
    clearAllCurrentItemClass() {
        this.slideContent.forEach((t) => {
            t.classList.remove(this.currentItemClass),
                t.closest(".js-spotlight-item").classList.remove(this.currentItemClass);
        });
    }
    clearAllActiveItemClass() {
        this.slideItems.forEach((t) => {
            t.classList.remove(this.currentItemClass);
        });
    }
    setSlideItemVisibility(t, e) {
        t
            ? (e.setAttribute("aria-hidden", "false"),
              e.removeAttribute("tabindex"),
              e.classList.add("slider-slide--active"))
            : (e.setAttribute("aria-hidden", "true"),
              e.setAttribute("tabindex", "-1"),
              e.classList.remove("slider-slide--active"));
    }
    handleScrollToItemInAdmin() {
        let e = !0;
        document.addEventListener("shopify:block:select", (t) => {
            t.target.classList.contains("slider-slide") &&
                ((e = !0),
                t.target.closest(".js-spotlight-items").scrollTo({ left: t.target.offsetLeft }),
                this.stopAutoPlay());
        }),
            document.addEventListener("shopify:block:deselect", (t) => {
                t.target.classList.contains("slider-slide") &&
                    ((e = !1),
                    setTimeout(() => {
                        !e && JSON.parse(this.dataset.spotlightProperties).autoplay && this.resumeAutoPlay();
                    }, 500));
            });
    }
}
customElements.define("sht-spotlight-quote", SHTSpotlightQuote);
class SHTCopyToClipboard extends SHTCustomComponent {
    constructor() {
        super(),
            (this.copyButton = this.$(".js-copy-button")),
            (this.copyText = this.$(".js-copy-text")),
            (this.successMessage = this.$(".js-copy-success-message")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.copyButton?.addEventListener("click", this.handleCopy.bind(this));
    }
    async handleCopy() {
        try {
            var t = this.copyText.textContent;
            await navigator.clipboard.writeText(t),
                this.copyButton.classList.add("copied"),
                (this.successMessage.style.display = "flex"),
                setTimeout(() => {
                    this.copyButton.classList.remove("copied"), (this.successMessage.style.display = "none");
                }, 3e3);
        } catch (t) {
            console.error("Failed to copy text: ", t);
        }
    }
}
customElements.define("sht-copy-clipboard", SHTCopyToClipboard),
    document.addEventListener("DOMContentLoaded", () => {
        var t = SHTHelper.qs(".js-cart-drawer-trigger");
        !SHTHelper.qs("sht-cart-drwr") &&
            t &&
            "undefined" != typeof Shopify &&
            Shopify.designMode &&
            "drawer" === t.dataset.event &&
            (t.removeAttribute("onclick"),
            t.addEventListener("click", (t) => {
                t.preventDefault(),
                    alert(
                        "Cart is unavailable due to a conflict in the cart settings. Please unhide the ‘Cart Drawer’ section or change the search behavior to ‘Cart Page’ to resolve this issue. This message is only visible in the theme editor. In the live store, the system will automatically default to the ‘Cart Page’."
                    );
            }));
    });
class SHTDialogProductBundle extends SHTDialogCore {
    constructor() {
        super(), (this.bundlePanel = null), (this.sectionId = this.dataset.section);
    }
    showModal(t, e) {
        (this.opener = t),
            this.opener?.setAttribute("disabled", "disabled"),
            this.processData(t, e),
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.offsetHeight, this.classList.add("is-active"), this.classList.remove("hidden-xs");
                });
            });
    }
    processData(s, i) {
        fetch(s.getAttribute("data-product-url"))
            .then((t) => t.text())
            .then((t) => {
                var t = new DOMParser().parseFromString(t, "text/html").querySelector(".section-product-bundle-dialog"),
                    e =
                        (window.Shopify?.PaymentButton && Shopify.PaymentButton.init(),
                        (this.body.innerHTML = t.innerHTML),
                        this.body.querySelector(".js-btn-add-to-bundle")),
                    t = t.querySelector(".js-scroll-element");
                this.handleInitOverflow(t),
                    (this.bundlePanel = SHTHelper.qs(`sht-product-bundle-panel[data-section="${i}"]`)),
                    this.bundlePanel?.initialize(e, s);
            })
            .finally(() => {
                this.toggleAttribute("hidden", !1), this.opener?.removeAttribute("disabled");
            });
    }
    handleInitOverflow(t) {
        t &&
            t.scrollHeight <= t.clientHeight &&
            this.querySelector(".js-bundle-body").classList.remove("gradient-overlay");
    }
    closeModal() {
        this.setAttribute("hidden", !0),
            this.offsetHeight,
            this.classList.add("drawer-out"),
            setTimeout(() => {
                this.classList.remove("is-active"), this.classList.replace("drawer-out", "hidden-xs");
            }, 300),
            setTimeout(() => {
                (this.body.innerHTML = ""), (this.bundlePanel = null);
            }, 300);
    }
}
customElements.define("sht-dialog-product-bundle", SHTDialogProductBundle);
class SHTProductBundlePanel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionId = this.dataset.section),
            (this.dialogBundle = SHTHelper.qs("sht-dialog-product-bundle")),
            (this.bundleItems = this.querySelector(".js-bundle-panel-items")),
            (this.placeholderBundle = this.querySelector(".js-placeholder-compare")),
            (this.bundleForm = this.querySelector("sht-prd-bundle-frm")),
            (this.productCount = 0),
            (this.minProducts = parseInt(this.dataset.minProducts) || 2),
            (this.enableUnlimitedAdd = "true" === this.dataset.enableUnlimitedAdd),
            (this.boundHandleBundleItemsClick = this.handleBundleItemsClick.bind(this)),
            (this.bundlePanelHeader = this.querySelector(".js-bundle-panel-header")),
            (this.bundlePanelBody = this.querySelector(".js-bundle-panel-body")),
            (this.bundlePanelFooter = this.querySelector(".js-bundle-panel-footer")),
            (this.bundlePanelCarousel = this.bundlePanelBody.querySelector(".sht-carousel")),
            (this.bundlePanelButton = this.bundlePanelFooter.querySelector(".js-bundle-button")),
            this.calculateBundleHeight();
    }
    initialize(t, e, s = !1) {
        this.updateBundleState(), this.bindEventHandlers(t, e, s), this.initializeScrollBehavior();
    }
    bindEventHandlers(e, s, t) {
        this.bundleItems?.removeEventListener("click", this.boundHandleBundleItemsClick),
            t
                ? this.handleAddToBundle(e, s, t)
                : e.addEventListener("click", (t) => {
                      t.preventDefault(), (e.disabled = !0), this.handleAddToBundle(e, s);
                  }),
            this.bundleItems?.addEventListener("click", this.boundHandleBundleItemsClick);
    }
    handleBundleItemsClick(t) {
        t.preventDefault(), t.stopPropagation();
        var e,
            t = t.target.closest(".js-remove-product-bundle");
        t &&
            (e = t.closest("sht-carousel-itm")) &&
            (this.removeFromBundle(e, t), (t = e?.getAttribute("data-item-index"))) &&
            this.bundleForm.removeBundleProduct(t);
    }
    handleAddToBundle(t, e, s = !1) {
        var i, r;
        s
            ? ((r = t.getAttribute("data-product-url")),
              (i = t.getAttribute("data-product-id")),
              this.addToBundle(i, r, e, s))
            : ((i = t.getAttribute("data-product-url")),
              (r = t.parentElement.querySelector('input[name="id"]')) && ((s = r.value), this.addToBundle(s, i, e)));
    }
    addToBundle(t, e, s) {
        this.bundleItems &&
            this.renderProductInfo(t, e, s)
                .then(() => {
                    this.updateBundleState(),
                        this.initializeCarousel(),
                        this.bundleForm?.addBundleProduct(t),
                        this.container &&
                            this.container.scrollTo({ left: this.container.scrollWidth, behavior: "smooth" }),
                        SHTHelper.removeTrapFocus(s),
                        1 <= this.productCount && this.classList.contains("expanded")
                            ? ((this.bundlePanelBody.style.display = "block"),
                              requestAnimationFrame(() => {
                                  (this.bundlePanelBody.style.opacity = "1"),
                                      (this.bundlePanelBody.style.height = "100%"),
                                      this.calculateBundleHeight();
                              }))
                            : 1 === this.productCount &&
                              (this.classList.add("expanded"),
                              (this.bundlePanelButton.style.width = window.innerWidth <= 459 ? "100%" : "auto"),
                              this.addEventListener(
                                  "transitionend",
                                  () => {
                                      (this.bundlePanelBody.style.display = "block"),
                                          requestAnimationFrame(() => {
                                              (this.bundlePanelBody.style.opacity = "1"),
                                                  (this.bundlePanelBody.style.height = "100%"),
                                                  this.calculateBundleHeight();
                                          });
                                  },
                                  { once: !0 }
                              )),
                        3 <= this.productCount && this.placeholderBundle.classList.add("d-none-important");
                })
                .catch((t) => {
                    console.error("Error adding to bundle:", t);
                });
    }
    renderProductInfo(t, e, n) {
        return fetch(e + `?variant=${t}&section_id=product-bundle-mini-card`)
            .then((t) => {
                if (t.ok) return t.text();
                throw new Error("Network response was not ok");
            })
            .then((t) => {
                t = new DOMParser().parseFromString(t, "text/html").querySelector(".section-mini-card-product-bundle");
                if (!t) throw new Error("Product mini card not found");
                var e,
                    s,
                    i = document.createElement("div"),
                    t = ((i.innerHTML = t.innerHTML), (n.disabled = !1), i.querySelector("sht-carousel-itm"));
                t &&
                    ((e = this.productCount + 1),
                    (s = this.minProducts),
                    t.setAttribute("aria-label", `Slide ${e} of ` + s),
                    t.setAttribute("data-item-index", e.toString()),
                    (s = n.getAttribute("data-id-product-bundle")),
                    !this.enableUnlimitedAdd) &&
                    s &&
                    t.querySelector(".js-remove-product-bundle").setAttribute("data-id-bundle", s);
                const r = document.createDocumentFragment(),
                    a = Array.from(i.children);
                a.forEach((t) => {
                    (t.style.opacity = "0"), r.appendChild(t);
                }),
                    this.bundleItems.appendChild(r),
                    requestAnimationFrame(() => {
                        a.forEach((t) => {
                            t.style.opacity = "1";
                        });
                    }),
                    this.updateButtonSelected(n),
                    this.productCount++,
                    this.dialogBundle.closeModal();
            })
            .catch((t) => {
                console.error("Error rendering product info:", t);
            });
    }
    updateCarouselItemsAttributes() {
        this.bundleItems &&
            this.bundleItems.querySelectorAll("sht-carousel-itm").forEach((t, e) => {
                var e = e + 1,
                    s = this.minProducts;
                t.setAttribute("aria-label", `Slide ${e} of ` + s), t.setAttribute("data-item-index", e.toString());
            });
    }
    updateButtonSelected(t) {
        t &&
            !this.enableUnlimitedAdd &&
            (t.dataset.originalText || (t.dataset.originalText = t.innerHTML),
            (t.disabled = !0),
            (t.innerHTML = "Added to bundle"));
    }
    removeFromBundle(t, e) {
        var e = e.getAttribute("data-id-bundle");
        !this.enableUnlimitedAdd &&
            e &&
            (e = document.querySelector(`[data-id-product-bundle="${e}"]`)) &&
            ((e.disabled = !1), e.dataset.originalText) &&
            (e.innerHTML = e.dataset.originalText),
            t &&
                (t.remove(),
                (this.productCount = Math.max(0, this.productCount - 1)),
                this.updateCarouselItemsAttributes(),
                this.updateBundleState(),
                this.initializeCarousel(),
                0 === this.productCount &&
                    (this.classList.remove("expanded"),
                    (this.bundlePanelButton.style.width =
                        window.innerWidth <= 459 ? "100%" : "calc(320px - var(--fix-s)*2)"),
                    this.addEventListener(
                        "transitionstart",
                        () => {
                            (this.bundlePanelBody.style.display = "none"),
                                requestAnimationFrame(() => {
                                    (this.bundlePanelBody.style.opacity = "0"),
                                        (this.bundlePanelBody.style.height = "0"),
                                        this.calculateBundleHeight();
                                });
                        },
                        { once: !0 }
                    )),
                this.productCount < 3) &&
                this.placeholderBundle.classList.remove("d-none-important");
    }
    updateBundleState() {
        var t = this.querySelector(".js-quatity-product-bundle"),
            t =
                (t && (t.textContent = this.productCount),
                this.querySelector(".js-bundle-panel-footer .js-bundle-button")),
            t =
                (t && (t.disabled = this.productCount < this.minProducts),
                this.querySelector(".js-product-bundle-form-submit-btn-text"));
        t &&
            (t.textContent =
                this.productCount < this.minProducts
                    ? `Add ${this.minProducts - this.productCount} more`
                    : "Add to cart");
    }
    initializeCarousel() {
        (this.carousels = this.querySelectorAll(".js-carousel-item")),
            (this.container = this.querySelector(".js-carousel-items")),
            (this.prevButton = this.querySelector(".js-carousel-prev-btn")),
            (this.nextButton = this.querySelector(".js-carousel-next-btn")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            (this.itemsToShow = Array.from(this.carousels).filter((t) => 0 < t.clientWidth)),
            this.itemsToShow.length < 2
                ? this.togglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel(),
                  this.container &&
                      this.prevButton &&
                      this.nextButton &&
                      (this.prevButton?.addEventListener("click", (t) => {
                          this.onButtonClick(t);
                      }),
                      this.nextButton?.addEventListener("click", (t) => {
                          this.onButtonClick(t);
                      }),
                      this.container.addEventListener("scroll", () => {
                          SHTHelper.debounce(this.updateCarousel(), 100);
                      })));
    }
    onButtonClick(t) {
        t.preventDefault();
        let e = 0;
        (0 != this.container.scrollLeft && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
            (e = this.gutter),
            (this.itemScrollPosition =
                "next" === t.currentTarget.name
                    ? this.container.scrollLeft - e + +this.itemOffset
                    : this.container.scrollLeft + e - +this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    updateCarousel() {
        var t = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML = this.currentPage),
            this.currentPage != t &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this.container,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevButton?.setAttribute("disabled", "disabled")
                : this.prevButton?.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextButton?.setAttribute("disabled", "disabled")
                : this.nextButton?.removeAttribute("disabled"),
            1 < this.totalPages && this.togglePagination(!0),
            this.totalPages <= 1 && this.togglePagination(!1);
    }
    isItemVisible(t, e = 0) {
        var s;
        return (
            void 0 !== t &&
            ((s = this.container.clientWidth + this.container.scrollLeft),
            Math.floor(t.getBoundingClientRect().width + t.offsetLeft) <= Math.round(s)) &&
            t.offsetLeft >= this.container.scrollLeft
        );
    }
    togglePagination(t) {
        t
            ? this.paginationElement?.classList.remove("d-none-important")
            : this.paginationElement?.classList.add("d-none-important");
    }
    initializeScrollBehavior() {
        var t = this.querySelector(".js-scroll-element"),
            e = this.querySelector(".js-bundle-body");
        t?.scrollHeight <= t?.clientHeight && e?.classList.remove("gradient-overlay");
    }
    calculateBundleHeight() {
        var t = this.bundlePanelHeader.scrollHeight,
            e = this.bundlePanelBody.scrollHeight,
            s = this.bundlePanelFooter.scrollHeight,
            e = this.classList.contains("expanded") ? t + e + s : t + s,
            t = this.classList.contains("expanded") ? "var(--fix-m)*2" : "var(--fix-m)";
        this.style.height = `calc(${e}px + var(--fix-s)*2 + ${t})`;
    }
}
customElements.define("sht-product-bundle-panel", SHTProductBundlePanel);
class SHTProductBundle extends SHTCustomComponent {
    constructor() {
        super(),
            (this.bundlePanel = this.querySelector("sht-product-bundle-panel")),
            (this.sectionId = this.bundlePanel?.dataset.section),
            (this.dialog = SHTHelper.qs("sht-dialog-product-bundle")),
            (this.bundleBtnNoVariants = this.$$(".js-btn-add-to-bundle")),
            (this.expandPanelBtn = this.$(".js-expand-panel")),
            (this.triggers = this.$$(".js-product-add-bundle")),
            (this.togglePanel = this.togglePanel.bind(this));
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.expandPanelBtn && this.expandPanelBtn.addEventListener("click", (t) => this.togglePanel(t)),
            this.triggers.forEach((t) => {
                t.addEventListener("click", (t) => {
                    this.dialog.showModal(t.target, this.sectionId);
                });
            }),
            this.bundleBtnNoVariants &&
                this.bundleBtnNoVariants.forEach((e) =>
                    e.addEventListener("click", (t) => {
                        this.addToBundle(t, e), (e.disabled = !0);
                    })
                );
    }
    togglePanel(t) {
        t.preventDefault();
        t = this.bundlePanel.classList.toggle("expanded");
        t
            ? ((this.bundlePanel.bundlePanelButton.style.width = window.innerWidth <= 459 ? "100%" : "auto"),
              this.bundlePanel.addEventListener(
                  "transitionend",
                  () => {
                      (this.bundlePanel.bundlePanelBody.style.display = "block"),
                          requestAnimationFrame(() => {
                              (this.bundlePanel.bundlePanelBody.style.opacity = "1"),
                                  (this.bundlePanel.bundlePanelBody.style.height = "100%"),
                                  this.bundlePanel.calculateBundleHeight();
                          });
                  },
                  { once: !0 }
              ))
            : ((this.bundlePanel.bundlePanelButton.style.width =
                  window.innerWidth <= 459 ? "100%" : "calc(320px - var(--fix-s)*2)"),
              this.bundlePanel.addEventListener(
                  "transitionstart",
                  () => {
                      (this.bundlePanel.bundlePanelBody.style.display = "none"),
                          requestAnimationFrame(() => {
                              (this.bundlePanel.bundlePanelBody.style.opacity = "0"),
                                  (this.bundlePanel.bundlePanelBody.style.height = "0"),
                                  this.bundlePanel.calculateBundleHeight();
                          });
                  },
                  { once: !0 }
              )),
            this.expandPanelBtn.setAttribute(
                "aria-label",
                t ? SHTLanguage.bundle.EXPAND_MODAL : SHTLanguage.bundle.COLLAPSE_MODAL
            );
    }
    addToBundle(t, e) {
        t.preventDefault(),
            this.bundlePanel &&
                "function" == typeof this.bundlePanel.initialize &&
                this.bundlePanel.initialize(e, e, !0);
    }
}
customElements.define("sht-product-bundle", SHTProductBundle);
class SHTProductBundleForm extends SHTCustomComponent {
    constructor() {
        super(),
            (this.bundleProducts = []),
            (this.cartNotiType = document.body.getAttribute("data-cart-noti-type")),
            (this.cartType = document.body.getAttribute("data-cart-type")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.cartDrawer = SHTHelper.qs("sht-cart-drwr")),
            (this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm")),
            (this.mainCartForm = SHTHelper.qs("sht-cart-frm")),
            (this.header_cart_status = SHTHelper.qs("#headerCartStatus")),
            (this.sectionId = this.closest("sht-product-bundle-panel")?.dataset.section),
            (this.interactionPopup = SHTHelper.qs("sht-interaction-popup")),
            this.header_cart_status?.classList.remove("header-cart-status--animate");
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.spinner = this.$(".js-product-form-spinner")),
            (this.bundleAddToCartBtn = this.$(".js-bundle-button")),
            (this.bundlePanel = this.closest("sht-product-bundle-panel")),
            (this.enableUnlimitedAdd = "true" === this.bundlePanel?.dataset.enableUnlimitedAdd),
            (this.placeholderBundle = this.bundlePanel?.querySelector(".js-placeholder-compare")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.bundleAddToCartBtn.addEventListener("click", this.onSubmitHandler.bind(this));
    }
    addBundleProduct(t, e = 1) {
        this.bundleProducts.push({ id: parseInt(t), quantity: e });
    }
    removeBundleProduct(t) {
        0 <= t && t < this.bundleProducts.length && this.bundleProducts.splice(t, 1);
    }
    getBundleItems() {
        if (this.enableUnlimitedAdd) return this.bundleProducts;
        {
            const s = new Map();
            return (
                this.bundleProducts.forEach((t) => {
                    var e = s.get(t.id);
                    e ? (e.quantity += t.quantity) : s.set(t.id, { ...t });
                }),
                Array.from(s.values())
            );
        }
    }
    onSubmitHandler(t) {
        if (
            (t.preventDefault(), !this.bundleAddToCartBtn.classList.contains("loading") && this.bundleProducts.length)
        ) {
            t = parseInt(this.bundlePanel?.dataset.minProducts || 2);
            if (!(this.bundleProducts.length < t)) {
                this.toggleSubmitButtons(!1), this.spinner?.classList.remove("hidden");
                let t = [];
                this.cartNotification && (t = this.cartNotification.getSectionsToRender()),
                    this.cartDrawer && (t = [...t, ...this.cartDrawer.getSectionsToRender()]),
                    this.mainCartForm && (t = [...t, ...this.mainCartForm.getSectionsToRender(!1)]);
                const i = { items: this.getBundleItems() };
                t.length && ((i.sections = t.map((t) => t.id)), (i.sections_url = window.location.pathname));
                let s = this.bundleAddToCartBtn;
                fetch("" + routes.cart_add_url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify(i),
                })
                    .then((t) => t.json())
                    .then((t) => {
                        var e;
                        if (422 === t.status || 400 === t.status)
                            (e = t.description || "Error adding products to cart"),
                                this.handleErrorMessage(e, t?.message);
                        else {
                            switch ((this.resetBundleButtons(), this.cartNotiType)) {
                                case "popover_notification":
                                    this.handlePopoverNotification(t, s, i.items.length);
                                    break;
                                case "cart_noti":
                                    this.handleCartNotification(t);
                                    break;
                                case "do_nothing":
                                    this.handleDoNothingNotification(t, s);
                            }
                            this.interactionPopup && this.interactionPopup.handleShowPopupAddToCart();
                        }
                    })
                    .catch((t) => {
                        console.error(t), this.handleErrorMessage("An error occurred while adding products to cart");
                    })
                    .finally(() => {
                        this.toggleSubmitButtons(!0),
                            this.spinner?.classList.add("hidden"),
                            (this.bundleProducts = []),
                            this.clearBundlePanel();
                    });
            }
        }
    }
    resetBundleButtons() {
        this.bundlePanel?.querySelectorAll("[data-id-bundle]").forEach((t) => {
            t = document.querySelector(`[data-id-product-bundle="${t.dataset.idBundle}"]`);
            t && ((t.disabled = !1), (t.innerHTML = t.dataset.originalText || t.innerHTML));
        });
    }
    clearBundlePanel() {
        var t = this.querySelector(".js-product-bundle-form-submit-btn-text");
        t && ((t.textContent = `Add ${this.minProducts} more`), (t.parentElement.disabled = !0)),
            this.bundlePanel &&
                ((this.bundlePanel.bundleItems.innerHTML = ""),
                (this.bundlePanel.productCount = 0),
                this.bundlePanel.updateBundleState(),
                this.bundlePanel.initializeCarousel(),
                this.bundlePanel.classList.remove("expanded"),
                this.placeholderBundle?.classList.remove("d-none-important"),
                (this.bundlePanel.bundlePanelBody.style.display = "none"),
                this.bundlePanel.calculateBundleHeight());
    }
    toggleSubmitButtons(t = !0) {
        var e = !t;
        this.bundleAddToCartBtn.classList[t ? "remove" : "add"]("loading"),
            this.bundleAddToCartBtn.setAttribute("aria-disabled", e),
            t
                ? this.bundleAddToCartBtn.removeAttribute("disabled")
                : this.bundleAddToCartBtn.setAttribute("disabled", !0);
    }
    handlePopoverNotification(t, e, s) {
        this.cartNotification?.renderContents(t, !0, e, s), this.cartDrawerForm?.renderContents(t);
    }
    handleCartNotification(t) {
        "drawer" === this.cartType
            ? (this.cartNotification?.renderContents(t, !1),
              this.cartDrawerForm?.renderContents(t),
              this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage(),
              this.cartDrawer?.openDrawer())
            : "page" === this.cartType &&
              (this.cartNotification?.renderContents(t, !1), window.location.assign(window.routes.cart_url));
    }
    handleDoNothingNotification(t, e) {
        this.cartNotification?.renderContents(t, !1, e), this.cartDrawerForm?.renderContents(t);
    }
    handleErrorMessage(t = !1, e) {
        var s, i;
        t &&
            ((s = SHTHelper.qs(`sht-product-bundle[data-section="${this.sectionId}"] .js-product-form-error-wrapper`)),
            (i = SHTHelper.qs(`sht-product-bundle[data-section="${this.sectionId}"] .js-product-form-error-message`)),
            "string" == typeof t) &&
            (s.toggleAttribute("hidden", !t), (i.textContent = t));
    }
}
customElements.define("sht-prd-bundle-frm", SHTProductBundleForm);
class SHTBeforeAfterImages extends SHTCustomComponent {
    constructor() {
        super(),
            (this.$ = this.querySelector.bind(this)),
            (this.isClicked = !1),
            (this.posSplitCursor = 20),
            (this.isRTL = "rtl" === document.documentElement.dir || "rtl" === document.body.dir),
            (this.rafId = null),
            (this.afterImage = this.$(".js-after-image")),
            (this.splitCursor = this.$(".js-split-cursor")),
            (this.stepSize = 1),
            (this.elements = [this.afterImage, this.splitCursor]),
            this.afterImage && this.splitCursor && this.init();
    }
    connectedCallback() {
        this.observeResize(), this.firstLoadAnimation();
    }
    firstLoadAnimation() {
        const e = new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting &&
                        (this.closest(".section").classList.add("is-animated"),
                        this.querySelectorAll(".tag").forEach((t) => t.classList.add("is-animated")),
                        this.updateSplitPosition(50),
                        this.elements.forEach((t) => {
                            t.classList.add("animation-init"),
                                t.addEventListener("transitionend", this.handleTransitionEnd.bind(this), { once: !0 });
                        }),
                        setTimeout(() => {
                            this.elements.forEach((t) => t.classList.remove("animation-init"));
                        }, 1e3),
                        e.disconnect());
                });
            },
            { threshold: 0.1 }
        );
        e.observe(this);
    }
    handleTransitionEnd(t) {
        ["left", "inset-inline-start"].includes(t.propertyName) &&
            (t.target.classList.remove("animation-init"),
            this.elements.every((t) => !t.classList.contains("animation-init")) ||
                this.elements.forEach((t) => t.classList.remove("animation-init")));
    }
    disconnectedCallback() {
        this.cleanup();
    }
    init() {
        (this.imageWidth = this.afterImage.offsetWidth),
            (this.imageHeight = this.afterImage.offsetHeight),
            this.addEventListeners(),
            this.updateSplitPosition(this.posSplitCursor),
            this.setupA11y();
    }
    setupA11y() {
        var t = this.splitCursor.querySelector(".js-split-cursor");
        t.setAttribute("role", "slider"),
            t.setAttribute("aria-label", "Image comparison slider"),
            t.setAttribute("aria-valuemin", "1"),
            t.setAttribute("aria-valuemax", "99"),
            t.setAttribute("aria-valuenow", this.posSplitCursor),
            t.setAttribute("tabindex", "0"),
            t.addEventListener("keydown", this.handleKeyDown.bind(this));
    }
    handleKeyDown(t) {
        let e = this.posSplitCursor;
        switch (t.key) {
            case "ArrowLeft":
            case "ArrowDown":
                (e = this.isRTL
                    ? Math.min(100, this.posSplitCursor + this.stepSize)
                    : Math.max(0, this.posSplitCursor - this.stepSize)),
                    t.preventDefault();
                break;
            case "ArrowRight":
            case "ArrowUp":
                (e = this.isRTL
                    ? Math.max(0, this.posSplitCursor - this.stepSize)
                    : Math.min(100, this.posSplitCursor + this.stepSize)),
                    t.preventDefault();
                break;
            case "Home":
                (e = 0), t.preventDefault();
                break;
            case "End":
                (e = 100), t.preventDefault();
                break;
            default:
                return;
        }
        (this.posSplitCursor = e), this.updateSplitPosition(this.posSplitCursor), this.updateA11yAttributes();
    }
    observeResize() {
        (this.resizeObserver = new ResizeObserver(() => {
            (this.imageWidth = this.afterImage.offsetWidth),
                (this.imageHeight = this.afterImage.offsetHeight),
                this.updateSplitPosition(this.posSplitCursor);
        })),
            this.resizeObserver.observe(this.afterImage);
    }
    addEventListeners() {
        this.splitCursor.addEventListener("mousedown", this.slideReady.bind(this)),
            this.splitCursor.addEventListener("touchstart", this.slideReady.bind(this), { passive: !0 }),
            document.addEventListener("mouseup", this.slideFinish.bind(this)),
            document.addEventListener("touchend", this.slideFinish.bind(this), { passive: !0 });
    }
    cleanup() {
        this.resizeObserver?.disconnect(),
            this.rafId && (cancelAnimationFrame(this.rafId), (this.rafId = null)),
            document.removeEventListener("mousemove", this.slideMove.bind(this)),
            document.removeEventListener("touchmove", this.slideMove.bind(this));
    }
    slideReady(t) {
        (this.isClicked = !0),
            this.elements.forEach((t) => {
                t.classList.remove("animation-init"), (t.style.transition = "none");
            }),
            document.addEventListener("mousemove", this.slideMove.bind(this)),
            document.addEventListener("touchmove", this.slideMove.bind(this));
    }
    slideFinish() {
        (this.isClicked = !1),
            this.rafId && (cancelAnimationFrame(this.rafId), (this.rafId = null)),
            this.elements.forEach((t) => {
                t.style.transition = "";
            }),
            document.removeEventListener("mousemove", this.slideMove.bind(this)),
            document.removeEventListener("touchmove", this.slideMove.bind(this));
    }
    slideMove(i) {
        !this.isClicked ||
            this.rafId ||
            (this.rafId = requestAnimationFrame(() => {
                (this.rafId = null), (i = i.changedTouches ? i.changedTouches[0] : i);
                var t = this.offsetLeft,
                    t = i.clientX - t,
                    e = this.imageWidth - 10;
                let s = (Math.min(e, Math.max(10, t)) / this.imageWidth) * 100;
                this.isRTL && (s = 100 - s), (this.posSplitCursor = s), this.updateSplitPosition(this.posSplitCursor);
            }));
    }
    updateSplitPosition(t) {
        this.style.setProperty("--before-after-initial-drag-position", t + "%"), this.updateA11yAttributes();
    }
    updateA11yAttributes() {
        this.splitCursor
            .querySelector(".js-split-cursor")
            .setAttribute("aria-valuenow", Math.round(this.posSplitCursor));
    }
}
customElements.define("sht-before-after-images", SHTBeforeAfterImages);
class SHTMasonry extends SHTCustomComponent {
    constructor() {
        super(),
            (this.masonry = this.$(".js-masonry")),
            (this.items = Array.from(this.$$(".js-masonry-item"))),
            (this.enableOffset = "true" === this.dataset.enableOffset),
            (this.columnHeights = []),
            (this.firstItemInColumn = {}),
            (this.columns = this.calculateColumnCount()),
            (this.debounce = (e, s) => {
                let i;
                return (...t) => {
                    clearTimeout(i), (i = setTimeout(() => e(...t), s));
                };
            });
    }
    connectedCallback() {
        this.masonry &&
            ((this.baseSize = parseFloat(this.dataset.baseSize) || 16),
            (this.gap = this.baseSize / 2),
            (this.offset = this.calculateOffset()),
            this.initializeGrid(),
            this.observeGridChanges(),
            window.addEventListener(
                "resize",
                this.debounce(() => this.handleResize(), 200)
            ));
    }
    disconnectedCallback() {
        window.removeEventListener("resize", this.debounce);
    }
    calculateOffset() {
        var t = window["innerWidth"];
        return 1025 <= t ? 2.5 * this.baseSize : 459 <= t ? 2.25 * this.baseSize : 2 * this.baseSize;
    }
    calculateColumnCount() {
        var t = window["innerWidth"],
            e = parseInt(this.masonry?.dataset.columnDesktop, 10) || 4;
        return 1025 <= t ? e : 459 <= t ? 3 : 2;
    }
    initializeGrid() {
        this.updateGridStructure(), this.updateGridItems();
    }
    updateGridStructure() {
        (this.columns = this.calculateColumnCount()),
            (this.columnHeights = Array(this.columns).fill(0)),
            (this.firstItemInColumn = {}),
            (this.offset = this.calculateOffset());
    }
    updateGridItems() {
        if (this.masonry && this.items.length) {
            const n = (this.masonry.offsetWidth - this.gap * (this.columns - 1)) / this.columns;
            this.items.forEach((t) => {
                var e = this.getShortestColumnIndex(),
                    s = e * (n + this.gap),
                    i = !this.firstItemInColumn[e],
                    i = this.enableOffset && e % 2 && i ? this.offset : 0,
                    r = this.columnHeights[e] + i,
                    a = this.calculateItemHeight(t, n);
                this.positionItem(t, s, r, n, a),
                    (this.columnHeights[e] += a + this.gap + i),
                    (this.firstItemInColumn[e] = !0);
            }),
                this.updateContainerHeight();
        }
    }
    calculateItemHeight(t, e) {
        var s,
            i,
            t = t.dataset.ratio;
        return t.includes("/")
            ? (([s, i] = t.split("/").map(Number)), i ? (e * i) / s : e)
            : ((i = parseFloat(t)), isNaN(i) ? void 0 : e / i);
    }
    getShortestColumnIndex() {
        return this.columnHeights.indexOf(Math.min(...this.columnHeights));
    }
    positionItem(t, e, s, i, r) {
        var a =
            "rtl" ===
            (
                this.closest("[dir]")?.getAttribute("dir") ||
                document.documentElement.getAttribute("dir") ||
                ""
            ).toLowerCase();
        Object.assign(t.style, { width: i + "px", height: r + "px", transform: `translate(${a ? -e : e}px, ${s}px)` });
    }
    updateContainerHeight() {
        this.masonry.style.height = Math.max(...this.columnHeights) + "px";
    }
    observeGridChanges() {
        new ResizeObserver(() => this.initializeGrid()).observe(this.masonry),
            new MutationObserver(() => {
                (this.items = Array.from(this.$$(".js-masonry-item"))), this.initializeGrid();
            }).observe(this.masonry, { childList: !0, subtree: !0 });
    }
    handleResize() {
        this.initializeGrid();
    }
}
customElements.define("sht-masonry", SHTMasonry);
class SHTImageGalleryItem extends SHTCustomComponent {
    constructor() {
        super(),
            (this.openGalleryButton = this.$(".js-open-image-gallery-btn")),
            this.openGalleryButton &&
                this.openGalleryButton.addEventListener("click", (t) => {
                    this.openDialogGallery(t);
                });
    }
    openDialogGallery(t) {
        var e = SHTHelper.qs("#" + t.currentTarget.dataset.galleryDialogId);
        e && e.showModal(t.currentTarget, !0);
    }
}
customElements.define("sht-image-gallery-item", SHTImageGalleryItem);
class CountdownFlip extends HTMLElement {
    constructor() {
        super(), (this.trackers = {}), (this.interval = null);
    }
    connectedCallback() {
        this.init();
    }
    disconnectedCallback() {
        this.destroy();
    }
    init() {
        if (((this.isExpired = JSON.parse(this.dataset.isExpired)), this.isExpired)) return !0;
        (this.timeZoneName = this.dataset.timeZoneName),
            (this.timeZoneOffset = this.dataset.timeZoneOffset),
            (this.endTime = this.dataset.endTime),
            (this.endDate = this.dataset.endDate),
            (this.hideOnEnd = JSON.parse(this.dataset.hideOnEnd)),
            this.validateDateValue(this.endDate) || (this.endDate = this.getCurrentDateTime(!0)),
            this.validateTimeValue(this.endTime) || (this.endTime = "23:59:59"),
            (this.expiredAt = new Date(this.convertDateStringToISOString(this.endDate + ":" + this.endTime)).getTime()),
            (this.currentTime = this.convertDateTimeToSpecificTimeZone(this.getCurrentDateTime())),
            this.setupDisplay(),
            this.start();
    }
    setupDisplay() {
        (this.messageElement = this.querySelector(".js-counter-message")),
            (this.counterElement = this.querySelector(".js-counter")),
            ["days", "hours", "minutes", "seconds"].forEach((t) => {
                var e = this.querySelector(".js-counter-" + t);
                e &&
                    (this.setupFlipCard(e, t),
                    (this.trackers[t] = {
                        element: e,
                        currentValue: null,
                        top: e.querySelector(".flip-card__top"),
                        bottom: e.querySelector(".flip-card__bottom"),
                        back: e.querySelector(".flip-card__back"),
                        backBottom: e.querySelector(".flip-card__bottom-flip"),
                        label: e.nextElementSibling.textContent,
                    }));
            });
    }
    setupFlipCard(t, e) {
        var s = document.createElement("span");
        (s.className = "flip-card p-relative"), t.textContent;
        (s.innerHTML = `
        <span class="flip-card__top"></span>
        <span class="flip-card__bottom"></span>
        <span class="flip-card__back">
          <span class="flip-card__bottom-flip"></span>
        </span>
    `),
            (t.textContent = ""),
            t.appendChild(s);
    }
    updateTracker(t, e) {
        t = this.trackers[t];
        t &&
            (e = String(e).padStart(2, "0")) !== t.currentValue &&
            (null !== t.currentValue &&
                (t.back.setAttribute("data-value", t.currentValue),
                t.bottom.setAttribute("data-value", t.currentValue)),
            (t.currentValue = e),
            (t.top.textContent = t.currentValue),
            t.backBottom.setAttribute("data-value", t.currentValue),
            t.element.classList.remove("flip"),
            t.element.offsetWidth,
            t.element.classList.add("flip"),
            t.element.setAttribute("aria-label", e + " " + t.label));
    }
    start() {
        this.updateDisplay(), (this.interval = setInterval(() => this.updateDisplay(), 1e3));
    }
    updateDisplay() {
        var t,
            e,
            s,
            i = this.expiredAt - this.currentTime;
        i <= 0
            ? this.handleExpired()
            : ((t = Math.floor(i / 864e5)),
              (e = Math.floor((i % 864e5) / 36e5)),
              (s = Math.floor((i % 36e5) / 6e4)),
              (i = Math.floor((i % 6e4) / 1e3)),
              this.updateTracker("days", t),
              this.updateTracker("hours", e),
              this.updateTracker("minutes", s),
              this.updateTracker("seconds", i),
              (this.currentTime = this.currentTime + 1e3));
    }
    handleExpired() {
        this.destroy(),
            this.setAttribute("data-is-expired", "true"),
            ["days", "hours", "minutes", "seconds"].forEach((t) => {
                this.updateTracker(t, 0);
            }),
            this.messageElement &&
                "" !== this.messageElement.innerHTML &&
                this.messageElement.classList.remove("d-none"),
            this.hideOnEnd && this.counterElement && this.counterElement.classList.add("d-none-important");
    }
    destroy() {
        this.interval && (clearInterval(this.interval), (this.interval = null));
    }
    getCurrentDateTime(t = !1) {
        var e = new Date(),
            s = e.getFullYear(),
            i = String(e.getMonth() + 1).padStart(2, "0"),
            r = String(e.getDate()).padStart(2, "0"),
            a = String(e.getHours()).padStart(2, "0"),
            n = String(e.getMinutes()).padStart(2, "0"),
            e = String(e.getSeconds()).padStart(2, "0");
        return t ? s + `-${i}-` + r : s + `-${i}-${r} ${a}:${n}:` + e;
    }
    convertDateTimeToSpecificTimeZone(t, e = !0) {
        var t = new Date(t),
            s = "-" === this.timeZoneOffset[0];
        let i =
            60 *
            (60 * parseInt(this.timeZoneOffset.substring(1, 3)) + parseInt(this.timeZoneOffset.substring(3, 5))) *
            1e3;
        s && (i = -i);
        s = new Date(t.getTime() + i);
        return e ? s.getTime() : s.toISOString();
    }
    convertDateStringToISOString(t) {
        return t.replace(/:/, "T") + ".000Z";
    }
    validateDateValue(t) {
        return /^\d{4}-\d{2}-\d{2}$/.test(t);
    }
    validateTimeValue(t) {
        return /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/.test(t);
    }
}
customElements.define("sht-countdown-flip", CountdownFlip);
class SHTVariation extends SHTCustomComponent {
    constructor() {
        super(),
            (this.productVariations = this.$$(".js-variation-item")),
            (this.sectionId = this.dataset.sectionId),
            (this.isQuickView = this.classList.contains("js-variation-quick-view")),
            (this.cachedData = {}),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.addEventListener("click", this.handleClick.bind(this));
    }
    handleClick(t) {
        t = t.target.closest(".js-variation-item");
        t && this.handleVariationClick(t.dataset.variationUrl);
    }
    handleVariationClick(t) {
        this.isQuickView || window.history.replaceState(null, "", t), this.fetchData(t);
    }
    async fetchData(t) {
        try {
            if (this.cachedData[t]) this.updateDOM(this.cachedData[t], t);
            else {
                var e = t + "?section_id=" + this.sectionId,
                    s = await fetch(e);
                if (!s.ok) throw new Error(`Failed to fetch product: ${s.status} ` + s.statusText);
                var i = await s.text(),
                    r = document.createElement("div");
                (r.innerHTML = i), (this.cachedData[t] = r), await this.preloadImages(r), this.updateDOM(r, t);
            }
        } catch (t) {
            console.error("Error fetching product variation:", t);
        }
    }
    preloadImages(t) {
        var t = t.querySelectorAll('img[src]:not([loading="lazy"])');
        return 0 === t.length
            ? Promise.resolve()
            : ((t = Array.from(t).map(
                  (e) =>
                      new Promise((t) => {
                          e.complete ? t() : ((e.onload = () => t()), (e.onerror = () => t()));
                      })
              )),
              Promise.all(t));
    }
    updateDOM(t, e) {
        var s,
            i = this.isQuickView ? "dialogBodyQuickView" : this.sectionId,
            i = document.querySelector("#" + i);
        t && i
            ? ((s = t.querySelector(".js-main-product")) && s.removeAttribute("data-animate"),
              this.isQuickView
                  ? (s = t.querySelector(".js-quick-view-container")) &&
                    ((i.innerHTML = s.innerHTML),
                    (s =
                        document.querySelector("#dialogQuickShop .js-view-full-btn a") ||
                        document.querySelector(".js-quick-view-drawer .js-view-full-btn a"))) &&
                    e &&
                    (s.href = e)
                  : (i.parentElement.innerHTML = t.children[0].innerHTML),
              window.Shopify?.PaymentButton && Shopify.PaymentButton.init())
            : console.warn("Product elements not found in current or new product");
    }
}
customElements.define("sht-variation", SHTVariation);
class SHTCartDiscount extends SHTCustomComponent {
    static ENTER_KEY = "Enter";
    static CART_UPDATE_DELAY = 500;
    static BIND_BUTTONS_DELAY = 600;
    static ENDPOINTS = { DISCOUNT: "/cart/update.js" };
    constructor() {
        super(), this.initializeProperties(), this.cacheElements(), this.initializeState();
    }
    initializeProperties() {
        (this.sectionId = this.dataset.sectionId),
            (this.isUpdating = !1),
            (this.eventListeners = new Map()),
            (this.debounceTimers = new Map());
    }
    cacheElements() {
        (this.elements = {
            formDiv: this.querySelector("[data-discount-form]"),
            input: null,
            errorContainer: this.querySelector("#cartDiscountError"),
            successContainer: this.querySelector("#cartDiscountSuccess"),
            errorShipping: null,
            errorDiscount: null,
            submitBtn: null,
            pillsContainer: this.querySelector(".js-discount-pills"),
        }),
            this.elements.formDiv &&
                ((this.elements.input = this.elements.formDiv.querySelector(".js-discount-input")),
                (this.elements.submitBtn = this.elements.formDiv.querySelector(".js-discount-submit"))),
            this.elements.errorContainer &&
                ((this.elements.errorShipping = this.elements.errorContainer.querySelector(".js-error-shipping")),
                (this.elements.errorDiscount = this.elements.errorContainer.querySelector(".js-error-discount")));
    }
    initializeState() {
        this.boundHandlers = {
            handleDiscountSubmit: this.handleDiscountSubmit.bind(this),
            handleKeydown: this.handleKeydown.bind(this),
            handleFormSubmit: this.handleFormSubmit.bind(this),
            handleCartUpdate: this.handleCartUpdate.bind(this),
            handleDOMReady: this.handleDOMReady.bind(this),
            handleRemoveClick: this.handleRemoveClick.bind(this),
        };
    }
    connectedCallback() {
        this.setupEventListeners(), this.bindRemoveButtons();
    }
    disconnectedCallback() {
        this.cleanup();
    }
    setupEventListeners() {
        this.setupFormEvents(), this.setupCartUpdateListener(), this.setupRemoveButtonsDelegation();
    }
    setupFormEvents() {
        var t;
        this.elements.formDiv &&
            !this.elements.formDiv.dataset.eventBound &&
            ((this.elements.formDiv.dataset.eventBound = "true"),
            this.elements.submitBtn &&
                this.addEventListener(this.elements.submitBtn, "click", this.boundHandlers.handleDiscountSubmit),
            this.elements.input &&
                this.addEventListener(this.elements.input, "keydown", this.boundHandlers.handleKeydown),
            (t = document.getElementById("cartForm"))) &&
            this.addEventListener(t, "submit", this.boundHandlers.handleFormSubmit);
    }
    setupCartUpdateListener() {
        this.addEventListener(document, "cart:update", this.boundHandlers.handleCartUpdate),
            "loading" === document.readyState
                ? this.addEventListener(document, "DOMContentLoaded", this.boundHandlers.handleDOMReady)
                : this.boundHandlers.handleDOMReady();
    }
    setupRemoveButtonsDelegation() {
        this.elements.pillsContainer &&
            !this.elements.pillsContainer.dataset.delegationBound &&
            ((this.elements.pillsContainer.dataset.delegationBound = "true"),
            this.addEventListener(this.elements.pillsContainer, "click", this.boundHandlers.handleRemoveClick));
    }
    addEventListener(t, e, s) {
        t.addEventListener(e, s);
        var i = t.tagName + "-" + e;
        this.eventListeners.has(i) || this.eventListeners.set(i, []),
            this.eventListeners.get(i).push({ element: t, event: e, handler: s });
    }
    removeEventListener(e, t, s) {
        e.removeEventListener(t, s);
        var i,
            t = e.tagName + "-" + t,
            t = this.eventListeners.get(t);
        t && -1 < (i = t.findIndex((t) => t.element === e && t.handler === s)) && t.splice(i, 1);
    }
    handleKeydown(t) {
        t.key === SHTCartDiscount.ENTER_KEY && (t.preventDefault(), this.handleDiscountSubmit(t));
    }
    handleFormSubmit(t) {
        var e = document.activeElement;
        if (this.isDiscountInputActive(e)) return t.preventDefault(), this.handleDiscountSubmit(t), !1;
    }
    handleCartUpdate(t) {
        "discount" === t.detail?.source && this.debounceBindRemoveButtons();
    }
    handleDOMReady() {
        this.debounce("dom-ready", () => this.bindRemoveButtons(), 100);
    }
    handleRemoveClick(t) {
        var e = t.target.closest(".js-remove-discount");
        e &&
            (t.preventDefault(), t.stopPropagation(), this.hideMessages(), (t = e.dataset.removeDiscount)) &&
            this.processDiscountRemoval(t);
    }
    debounce(t, e, s) {
        this.debounceTimers.has(t) && clearTimeout(this.debounceTimers.get(t));
        s = setTimeout(() => {
            e(), this.debounceTimers.delete(t);
        }, s);
        this.debounceTimers.set(t, s);
    }
    debounceBindRemoveButtons() {
        this.debounce("bind-buttons", () => this.bindRemoveButtons(), SHTCartDiscount.BIND_BUTTONS_DELAY);
    }
    isDiscountInputActive(t) {
        return "discount" === t?.name && t.closest("[data-discount-form]");
    }
    bindRemoveButtons() {
        var t = document.querySelectorAll(".js-remove-discount:not([data-event-bound-remove])");
        0 !== t.length &&
            t.forEach((t) => {
                this.addEventListener(t, "click", (t) => this.handleDiscountRemove(t)),
                    (t.dataset.eventBoundRemove = "true");
            });
    }
    async handleDiscountSubmit(t) {
        t.preventDefault(), t.stopPropagation();
        t = this.getDiscountCodeFromInput();
        t && (await this.processDiscountApplication(t));
    }
    async handleDiscountRemove(t) {
        t.preventDefault(), t.stopPropagation(), this.hideMessages();
        t = t.currentTarget.dataset.removeDiscount;
        t && (await this.processDiscountRemoval(t));
    }
    getDiscountCodeFromInput() {
        return this.elements.input?.value.trim() || "";
    }
    async processDiscountApplication(t) {
        this.setLoading(!0), this.hideMessages();
        try {
            var e,
                s,
                i,
                r = this.getExistingDiscountCodes(),
                a = await this.applyDiscount(t);
            a.ok
                ? ((s = await a.json()),
                  (i = this.validateDiscountResponse(s, r, t)).isValid
                      ? this.handleSuccessfulDiscount()
                      : (this.clearInput(), this.showError(i.errorType)))
                : ((e = await a.json()), this.showError(e.description || "discount_code"));
        } catch (t) {
            console.error("Error applying discount:", t), this.showError("general");
        } finally {
            this.setLoading(!1);
        }
    }
    async processDiscountRemoval(e) {
        this.setLoading(!0), this.hideMessages();
        try {
            var t = this.getExistingDiscountCodes().filter((t) => t !== e);
            (await this.sendDiscountUpdateRequest(t)).ok && this.updateCartDrawer();
        } catch (t) {
            console.error("Error removing discount:", t);
        } finally {
            this.setLoading(!1);
        }
    }
    validateDiscountResponse(t, e, s) {
        return this.isDiscountNotApplicable(t, s)
            ? { isValid: !1, errorType: "discount_code" }
            : this.isShippingOnlyDiscount(t, e, s)
              ? { isValid: !1, errorType: "shipping" }
              : { isValid: !0 };
    }
    isDiscountNotApplicable(t, e) {
        return t.discount_codes?.some((t) => t.code === e && !1 === t.applicable);
    }
    isShippingOnlyDiscount(t, e, s) {
        var i;
        return (
            !!t.sections?.[this.sectionId] &&
            ((i = this.extractDiscountCodesFromHTML(t.sections[this.sectionId])),
            this.isDiscountAlreadyAppliedButNotVisible(i, e, t.discount_codes, s))
        );
    }
    extractDiscountCodesFromHTML(t) {
        t = new DOMParser().parseFromString(t, "text/html").getElementById("shopify-section-" + this.sectionId);
        return t
            ? Array.from(t.querySelectorAll("[data-discount-code]"))
                  .map((t) => t.dataset.discountCode)
                  .filter(Boolean)
            : [];
    }
    isDiscountAlreadyAppliedButNotVisible(t, e, s, i) {
        (t = t.length === e.length && t.every((t) => e.includes(t))),
            (s = s?.some((t) => t.code === i && !0 === t.applicable));
        return t && s;
    }
    async applyDiscount(t) {
        t = [...this.getExistingDiscountCodes(), t];
        return this.sendDiscountUpdateRequest(t);
    }
    async sendDiscountUpdateRequest(t) {
        return fetch(SHTCartDiscount.ENDPOINTS.DISCOUNT, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ discount: t.join(","), sections: this.sectionId }),
        });
    }
    getExistingDiscountCodes() {
        return Array.from(this.querySelectorAll("[data-discount-code]"))
            .map((t) => t.dataset.discountCode)
            .filter(Boolean);
    }
    handleSuccessfulDiscount() {
        this.clearInput(), this.showSuccess(), this.updateCartDrawer();
    }
    clearInput() {
        this.elements.input && (this.elements.input.value = "");
    }
    updateCartDrawer() {
        this.isUpdating ||
            ((this.isUpdating = !0),
            this.dispatchCartUpdateEvent(),
            this.debounce(
                "cart-update",
                () => {
                    this.bindRemoveButtons(), (this.isUpdating = !1);
                },
                SHTCartDiscount.CART_UPDATE_DELAY
            ));
    }
    dispatchCartUpdateEvent() {
        document.dispatchEvent(
            new CustomEvent("cart:update", { detail: { source: "discount", timestamp: Date.now() } })
        );
    }
    hideMessages() {
        this.hideError(), this.hideSuccess();
    }
    showSuccess() {
        this.elements.successContainer &&
            (this.hideError(), this.elements.successContainer.classList.remove("d-none-important"));
    }
    hideSuccess() {
        this.elements.successContainer?.classList.add("d-none-important");
    }
    showError(t) {
        this.elements.errorContainer &&
            (this.hideSuccess(),
            this.elements.errorContainer.classList.remove("d-none-important"),
            this.toggleErrorTypes(t));
    }
    toggleErrorTypes(t) {
        t = "shipping" === t;
        this.elements.errorShipping?.classList.toggle("d-none-important", !t),
            this.elements.errorDiscount?.classList.toggle("d-none-important", t);
    }
    hideError() {
        this.elements.errorContainer?.classList.add("d-none-important");
    }
    setLoading(t) {
        this.toggleAttribute("loading", t),
            this.elements.formDiv?.classList.toggle("loading", t),
            this.elements.submitBtn?.toggleAttribute("disabled", t);
    }
    cleanup() {
        this.debounceTimers.forEach((t) => clearTimeout(t)),
            this.debounceTimers.clear(),
            this.eventListeners.forEach((t) => {
                t.forEach(({ element: t, event: e, handler: s }) => {
                    t.removeEventListener(e, s);
                });
            }),
            this.eventListeners.clear();
    }
}
customElements.define("sht-cart-discount", SHTCartDiscount);
class SHTInfinityScroll extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.renderContainer = SHTHelper.qid("loadMoreContent")),
            (this.loadingIndicator = this.querySelector(".js-loading-overlay-wrapper")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.observer = this.registerObserver(this.loadNextPage.bind(this))), this.observer.observe(this);
    }
    registerObserver(e) {
        let s = !1;
        return new IntersectionObserver(function (t) {
            t[0].isIntersecting &&
                !s &&
                ((s = !0),
                e()
                    .then(() => (s = !1))
                    .catch(() => (s = !1)));
        });
    }
    loadNextPage() {
        let { nextUrl: t, totalPages: e, pageSize: s, totalItems: i } = this.dataset,
            r = parseInt(this.dataset.currentPage) + 1;
        return r > e
            ? (this.observer.disconnect(), Promise.resolve())
            : (this.loadingIndicator.classList.remove("hidden"),
              fetch(t.replace(/page=[0-9]+/, "page=" + r))
                  .then((t) => (this.loadingIndicator.classList.add("hidden"), t.text()))
                  .then((t) => {
                      var e = document.createElement("div"),
                          t = ((e.innerHTML = t), e.querySelector("#loadMoreContent").innerHTML);
                      this.renderContainer.insertAdjacentHTML("beforeend", t);
                  })
                  .catch((t) => {
                      console.error(t);
                  })
                  .finally(() => {
                      (this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1),
                          parseInt(i) - r * parseInt(s) < 0 && (this.innerHTML = this.dataset.label);
                  }));
    }
}
customElements.define("sht-infinity-scroll", SHTInfinityScroll);
class SHTLazyLoader extends HTMLElement {
    constructor() {
        super(), (this.observer = null), (this.isLoaded = !1);
    }
    connectedCallback() {
        this.init();
    }
    disconnectedCallback() {
        this.observer && this.observer.disconnect();
    }
    init() {
        this.isLoaded || "eager" === this.dataset.loading ? this.loadImages() : this.setupIntersectionObserver();
    }
    setupIntersectionObserver() {
        (this.observer = new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting && !this.isLoaded && (this.loadImages(), this.observer.unobserve(t.target));
                });
            },
            { root: null, rootMargin: "50px", threshold: 0.1 }
        )),
            this.observer.observe(this);
    }
    loadImages() {
        this.isLoaded ||
            (this.querySelectorAll("img").forEach((t) => {
                var e;
                t.complete && 0 !== t.naturalHeight
                    ? t.classList.add("loaded")
                    : (t.addEventListener(
                          "load",
                          () => {
                              t.classList.add("loaded");
                          },
                          { once: !0 }
                      ),
                      (t.src && !t.src.includes("data:")) ||
                          ((e = t.dataset.src || t.src) && !e.includes("data:") && (t.src = e)));
            }),
            (this.isLoaded = !0),
            this.setAttribute("data-loaded", "true"));
    }
}
customElements.define("sht-lazy-loader", SHTLazyLoader);
